import { ROUTE_LABELS, routeLabelDictEntries } from "@sendly/shared";

const hu = {
  // Common
  "common.loading": "Betöltés...",
  "common.featureNotAvailable": "Ez a funkció nem elérhető.",
  "common.cancel": "Mégse",
  "common.save": "✓ Mentés",
  "common.yes": "Igen",
  "common.no": "Nem",
  "common.saving": "Mentés...",
  "common.saved": "Mentve",
  "common.close": "Bezárás",
  "common.mainNavigation": "Fő navigáció",
  "common.toggleFilters": "Szűrők ki/be",
  "common.clearSearch": "Keresés törlése",
  "common.moveUp": "Mozgatás felfelé",
  "common.moveDown": "Mozgatás lefelé",
  "common.delete": "Törlés",
  "common.confirm": "Megerősítés",
  "common.ok": "OK",
  "common.typedConfirmLabel": "A megerősítéshez írd be: \"{word}\"",
  "common.error": "Hiba",
  "common.points": "pont",
  "common.routes": "út",
  "common.back": "← Vissza",
  "common.retry": "Újrapróbálom",
  "common.add": "+ Hozzáadás",
  "common.addShort": "+ Hozzáad",
  "common.archived": "archív",
  "common.fullDescription": "Részletes leírás",
  "common.showMore": "Továbbiak mutatása ({count})",

  // Login
  "login.title": "Belépés",
  "login.google": "Google",
  "login.apple": "Apple",
  "login.accountLinkPrompt": "Ezzel az email címmel már van fiók egy másik belépési móddal. Lépj be a korábban használt módszereddel (Google, Apple vagy email), és összekötjük a fiókjaidat.",
  "login.or": "vagy",
  "login.emailPlaceholder": "email@példa.hu",
  "login.send": "Küldés",
  "login.linkSent": "Link elküldve!",
  "login.checkEmailPrefix": "Nézd meg a ",
  "login.checkEmailSuffix": " fiókod, és kattints a linkre a belépéshez.",
  "login.emailHint": "Kapni fogsz egy belépő linket emailben.",
  "login.emailHintPwa": "A belépő link a böngészőben nyílik meg. Utána gyere vissza az appba.",
  "login.confirmEmailTitle": "Email megerősítése",
  "login.confirmEmailDesc": "A biztonság kedvéért add meg újra az email címed.",
  "login.confirmEmailButton": "Megerősítés",
  "login.signInFailed": "A belépés nem sikerült. Próbáld újra.",
  "login.sendFailed": "A link küldése nem sikerült.",
  "login.emailInvalid": "Érvénytelen email cím.",
  "login.networkError": "Hálózati hiba. Ellenőrizd a kapcsolatod.",
  "login.tooManyRequests": "Túl sok próbálkozás. Várj néhány percet.",
  "login.linkInvalid": "A link lejárt vagy érvénytelen. Kérj újat.",
  "login.passwordSectionTitle": "Jelszó (csak teszt)",
  "login.passwordPlaceholder": "Jelszó",
  "login.passwordSignIn": "Belépés",
  "login.passwordSignUp": "Regisztráció",
  "login.passwordTestOnlyHint": "Email + jelszó belépés csak a teszt környezetben elérhető.",
  "login.passwordRequired": "Adj meg egy jelszót.",
  "login.passwordWeak": "A jelszó túl gyenge (legalább 6 karakter).",
  "login.emailInUse": "Ez az email már regisztrálva van. Próbálj belépni helyette.",
  "login.invalidCredentials": "Érvénytelen email vagy jelszó.",
  "login.passwordAuthDisabled": "Az email + jelszó belépés ezen a projekten nincs engedélyezve.",

  // Tabs — `.short` variants are used on narrow viewports (≤480px). For tabs
  // whose full label already fits a 60px column ("Térkép", "Utak", "Admin"),
  // short equals full so the render path stays uniform.
  "tab.map": "Térkép",
  "tab.map.short": "Térkép",
  "tab.routes": "Utak",
  "tab.routes.short": "Utak",
  "tab.setters": "Építők",
  "tab.setters.short": "Építők",
  "tab.spraywall": "Spraywall",
  "tab.spraywall.short": "Spray",
  "tab.admin": "Admin",
  "tab.admin.short": "Admin",

  // Map
  "map.clickToReposition": "📍 Kattints a térképre az áthelyezéshez!",
  "map.clickToPlace": "👆 Kattints a térképre: \u201E{name}\u201D",
  "map.clickToPlaceSprayWall": "👆 Koppints a fal helyére: \u201E{name}\u201D",
  "map.sprayWallPlaced": "\u201E{name}\u201D elhelyezve a térképen",
  "map.sprayWallSaveFailed": "Hiba történt, a fal elhelyezése nem sikerült. Kérjük, frissítsd az appot.",
  "map.saveFailed": "Hiba történt, az út mentése nem sikerült. Kérjük, frissítsd az appot.",
  "map.newRoute": "Új út rögzítése",
  "map.defaultName": "Térkép",
  "map.floors": "Emeletek",
  "map.searchRoutes": "Utak keresése",
  "map.searchPlaceholder": "Út keresése...",
  "map.sortName": "Név (A→Z)",
  "map.sortDiffAsc": "Nehézség ↑",
  "map.sortDiffDesc": "Nehézség ↓",
  "map.sortRating": "Értékelés ★",
  "map.sortAscentsDesc": "Legtöbben megmászták",
  "map.sortClimbsDesc": "Legtöbbet mászták",
  "map.sortNewest": "Legújabb",
  "map.statusAll": "Mind",
  "map.statusUnclimbed": "Nem mászott",
  "map.statusClimbed": "Megmászva ✓",
  "map.legendToggle": "Jelmagyarázat",
  "map.legendHide": "Jelmagyarázat elrejtése",
  "map.legendHoldColor": "Fogásszín",
  "map.legendDifficulty": "Nehézség",
  "map.legendClimbed": "Megmászva",
  "map.legendNewRoute": "Új út",
  "map.legendComp": "Verseny-út (szaggatott narancs gyűrű + 🏆)",
  "map.legendSprayWall": "Spraywall — koppints a fal megnyitásához",
  "map.legendSmall": "Kicsinyített nézetben csak a fogásszín látszik — a középső pötty a megmászást jelöli, nem a nehézséget",
  "map.legendPoints": "Pontszám",
  "map.legendPulsing": "pulzáló kör",
  "map.legendHoldExample": "(narancs)",
  "map.legendDiffExample": "(kék · 2p)",
  "map.routeCount": "{count} út",
  "map.routes": "Utak",
  "map.showAll": "Mind ({count})",
  "map.noResults": "Egy út sem felel meg a szűrőknek.",
  "map.noRoutesOnMap": "Ezen a térképen még nincs út.",
  "map.noRoutesInGym": "Ebben a teremben még nincs út.",
  "map.filterDifficulty": "NEHÉZSÉG",
  "map.filterStatus": "ÁLLAPOT",
  "map.filterComp": "Csak verseny utak",

  // Filters
  "filter.all": "Mind",
  "filter.clearAll": "Mind törlése",
  "filter.sheetTitle": "Szűrők és rendezés",
  "filter.sortLabel": "Rendezés",
  "filter.removeChip": "{name} szűrő eltávolítása",
  "filter.showResults": "{count} út mutatása",

  // Toast
  "toast.undo": "Vissza",
  "toast.sendLogged": "Send: {name}",
  "toast.attemptLogged": "+{count} próba · {name} (ma {today})",
  "toast.repeatLogged": "Újra megmászva: {name}",
  "toast.climbCooldown": "Épp most rögzítetted: {name}",
  "toast.climbFailed": "A mászás rögzítése nem sikerült. Próbáld újra.",

  // Routes management
  "routes.active": "✅ Aktív",
  "routes.archived": "📦 Archív",
  "routes.all": "📋 Mind",
  "routes.empty": "Nincs ilyen út.",
  "routes.loadMoreArchived": "További archiváltak betöltése",
  "routes.showOnMap": "Mutasd a térképen",
  "routes.inCompetition": "verseny",
  "routes.watching": "Figyeled ezt az utat",
  "routes.searchPlaceholder": "Út keresése...",
  "routes.setterFilter": "Építő",
  "routes.filtersLabel": "Szűrők",
  "routes.filterRated": "Értékelt",
  "routes.filterGradeVote": "Grade szavazat",

  // Leaderboard
  "lb.empty": "Még nincsenek megmászások.",

  // Setters
  "setters.empty": "Még nincsenek építők.",
  "setters.totalRoutes": "út összesen",
  "setters.active": "aktív",
  "setters.activeRoutes": "Aktív utak",
  "setters.archivedRoutes": "Archivált utak",
  "setters.noRating": "nincs értékelés",
  "setters.unknown": "Ismeretlen építő",
  "setters.sprayAuthors.title": "Spraywall-szerzők",
  "setters.sprayAuthors.problems": "{count} út",
  "setters.sprayAuthors.sends": "{count} küldés",
  "setters.sprayAuthors.rating": "Átlagos értékelés: {avg} ({count} értékelés)",
  "setters.sprayAuthors.benchmarks": "{count} benchmark",
  "setters.sprayAuthors.empty": "Még nincs publikus spraywall-út.",

  // Admin
  "admin.branding": "🎨 Branding",
  "admin.replaceLogo": "Logó cseréje",
  "admin.replaceCover": "Borítókép cseréje",
  "admin.coverHint": "Ajánlott: {w}×{h} px",
  "admin.stats": "📊 Statisztikák",
  "admin.nav.overview": "Áttekintés",
  "admin.nav.community": "Közösség",
  "admin.nav.gym": "Terem",
  "admin.nav.account": "Fiók & adatok",
  "admin.activeRoutes": "Aktív út",
  "admin.users": "Felhasználó",
  "admin.climbs": "Összes mászás",
  "admin.ascents": "Megmászás",
  "admin.mau": "MAU",
  "admin.usersTitle": "👥 Felhasználók",
  "admin.searchUsers": "Keresés név vagy email...",
  "admin.userRow.role": "Szerepkör",
  "admin.search.placeholder": "Keresés a beállításokban…",
  "admin.sidebar.collapse": "Menü összecsukása",
  "admin.sidebar.expand": "Menü kinyitása",
  "admin.search.noResults": "Nincs találat: \"{query}\"",
  "admin.needsSetup": "Beállítandó",
  "onboarding.hero.titleNamed": "Üdv a Sendlyn, {gymName}! 👋",
  "onboarding.hero.titleGeneric": "Üdv a Sendlyn! 👋",
  "onboarding.hero.subtitle": "Pár lépés és élesben mehet a terem. Becsült idő: ~{minutes} perc — később bármikor folytathatod.",
  "onboarding.hero.dismiss": "Elrejtés",
  "onboarding.hero.dismissHint": "Többé nem jelenik meg ennél a teremnél",
  "onboarding.hero.dismissConfirm": "Biztos elrejted? A checklistát többé nem fogod látni ennél a teremnél, csak a sorokon megmaradó \"Beállítandó\" pillek emlékeztetnek a hiányzó beállításokra.",
  "onboarding.hero.foot": "{done}/{total} kész — bármikor folytathatod ott, ahol abbahagytad.",
  "onboarding.cta.continue": "Folytatás →",
  "onboarding.cta.locked": "Előbb az alapok kellenek",
  "onboarding.compact.title": "Kezdő lépések",
  "onboarding.compact.next": "Folytasd: {step}",
  "onboarding.minutes": "~{n}p",
  "onboarding.step.created.title": "Terem létrehozva",
  "onboarding.step.profile.title": "Alapadatok és típus",
  "onboarding.step.profile.sub": "Leírás, cím, GPS pozíció, email, telefon",
  "onboarding.step.branding.title": "Megjelenés",
  "onboarding.step.branding.sub": "Logo és accent szín",
  "onboarding.step.maps.title": "Térkép feltöltése",
  "onboarding.step.maps.sub": "Legalább egy szint képpel",
  "onboarding.step.difficulty.title": "Nehézségek és fogásszínek",
  "onboarding.step.difficulty.sub": "Adj grade tartományt minden szinthez",
  "onboarding.step.routes.title": "Első utak rögzítése",
  "onboarding.step.routes.sub": "Legalább 3 aktív út, hogy legyen mit mászni",
  "onboarding.step.team.title": "Csapat meghívása",
  "onboarding.step.team.sub": "Setterek, edzők, recepciósok (opcionális)",
  "onboarding.step.hours.title": "Nyitvatartás beállítása",
  "onboarding.step.hours.sub": "Add meg mind a 7 napot és az időzónát",
  "onboarding.step.billing.title": "Számlázási adatok",
  "onboarding.step.billing.sub": "Cégnév és adószám a negyedéves számlához",
  "onboarding.step.publish.title": "Élesítés és nyilvános megjelenés",
  "onboarding.step.publish.sub": "A terem felkerül a Sendly listára, és kapsz megosztható linket",
  "admin.sub.competitions": "{active} aktív · {upcoming} közelgő",
  "admin.sub.events": "{active} aktív · {draft} vázlat",
  "admin.sub.series": "{active} aktív · {closed} lezárt",
  "admin.sub.usersSimple": "{count} tag",
  "admin.sub.usersSimpleOne": "{count} tag",
  "admin.sub.maps": "{count} szint",
  "admin.sub.mapsOne": "{count} szint",
  "admin.sub.tv": "{count} kijelző",
  "admin.sub.tvOne": "{count} kijelző",
  "admin.sub.tvNone": "Nincs konfigurálva",
  "admin.sub.diff": "{levels} szint · {colors} szín",
  "admin.sub.stats": "{routes} aktív út",
  "admin.sub.audit": "Hozzáférés-változások és tiltások",
  "admin.sub.profile": "Név, leírás, elérhetőség",
  "admin.sub.branding": "Logo · szín · borítókép",
  "admin.sub.display": "Nyitvatartás, kiemelés, láthatóság",
  "admin.sub.pwa": "Megosztó link és QR kód",
  "admin.sub.widget": "Beágyazható nyitva tartás",
  "admin.sub.export": "JSON adatcsomag letöltése",
  "admin.sub.maintenance": "Adatok törlése (veszélyzóna)",
  "admin.sub.subscription": "{plan} csomag · MAU {mau}/{max}",
  "admin.sub.subscriptionPlan": "{plan} csomag",
  "admin.usersCount": "{count} felhasználó",
  "admin.showMore": "Továbbiak mutatása",
  "admin.kickTitle": "Kirúgás",
  "admin.reportName.button": "Jelentés",
  "admin.reportName.title": "Név jelentése moderálásra",
  "admin.reportName.confirm": "Jelented {name} megjelenített nevét a Sendly platform moderációjának? A döntést a platform admin hozza meg.",
  "admin.reportName.done": "Név jelentve moderálásra",
  "admin.mapsTitle": "🗺️ Térképek / Emeletek",
  "admin.mapsDesc": "Több emelet vagy zóna esetén adj hozzá újat. Az utak mindig az épp aktív térképre kerülnek.",
  "admin.replaceImage": "🔄 Kép cseréje",
  "admin.uploadImage": "📷 Kép feltöltése",
  "admin.hasImage": "✓ Van kép",
  "admin.width": "Szélesség",
  "admin.height": "Magasság",
  "admin.newFloorPlaceholder": "Új emelet neve…",
  "admin.deleteMapConfirm": "Biztosan törlöd ezt a térképet?",
  "admin.displayTitle": "⚙️ Általános",
  "admin.pwa.title": "📱 PWA & QR kód",
  "admin.pwa.gymLink": "Terem link",
  "admin.pwa.qrCode": "QR kód",
  "admin.pwa.generateQr": "🔲 QR kód generálás",
  "admin.pwa.regenerateQr": "🔄 Újragenerálás",
  "admin.pwa.downloadQr": "⬇️ PNG letöltés",
  "admin.pwa.qrHint": "Nyomtasd ki a QR kódot és helyezd el a teremben — a látogatók beszkennelve közvetlenül megnyithatják az appot.",

  "admin.tvTitle": "📺 TV beállítások",
  "admin.slideDuration": "Slide váltás",
  "admin.seconds": "mp",
  "admin.newRouteHighlight": "Új út jelölés időszak",
  "admin.days": "nap",
  "admin.tvOledProtection": "OLED beégés védelem",
  "admin.tvOledProtectionHint": "Pixel shift + enyhe fényerő-csökkentés a beégés megelőzéséhez. Legjobb eredményért használd a Sötét témát.",
  "admin.tvTheme": "TV téma",
  "admin.tvLanguage": "TV nyelv",
  "admin.themeDark": "🌙 Sötét",
  "admin.themeLight": "☀️ Világos",
  "admin.themeSystem": "📱 Rendszer",
  "admin.logo": "Logó",
  "admin.uploadLogo": "📷 Logó feltöltése",
  "admin.difficultyLevels": "Nehézségi szintek",
  "admin.diffPoints": "Pont:",
  "admin.diffDeleteTitle": "Nehézségi szint törlése",
  "admin.diffDeletePromptBody": "{count} aktív út használja ezt a szintet. Archiválod őket, vagy véglegesen törlöd?\n\nA meglévő megmászások megmaradnak (az archivált utakon is), de a szintjük többé nem oldható fel, így az a szelet a rangsorban és a statisztikákban 0 pontot ér.",
  "admin.diffRetroNotice": "A pont és a grade-tartomány visszamenőleg hat: módosításukkor a terem minden korábbi megmászása és minden tag összpontszáma újraértékelődik. A szín és a felirat csak a megjelenést változtatja.",
  "admin.diffReweightConfirmTitle": "Visszamenőleges átértékelés",
  "admin.diffReweightConfirmBody": "A(z) „{label}” szint pontértéke {from} → {to}.\n\nEz visszamenőleg hat: a terem minden korábbi megmászása újraértékelődik, és {members} tag összpontszáma újraszámolódik. A szinten jelenleg {routes} aktív út van.\n\nEbben a szerkesztésben többször nem kérdezünk rá.",
  "admin.diffGradeRangeConfirmBody": "A(z) „{label}” szint grade-tartománya a termek közötti, normalizált pontszámot mozdítja — visszamenőleg, {members} tag minden korábbi megmászására. A tartomány törlésével a tagok globális profilja erre a teremre nyers pontra esik vissza. A szinten jelenleg {routes} aktív út van.\n\nEbben a szerkesztésben többször nem kérdezünk rá.",
  "admin.diffUnsavedHint": "Nem mentett érték — Enter vagy kattints máshová a mentéshez",
  "admin.newDiffPlaceholder": "Új szint neve...",
  "admin.diffDeleteNote": "Törlés után a meglévő utak megmaradnak, de a törölt szint nem jelenik meg többé.",
  "admin.diffNoSetForDiscipline": "Ehhez a diszciplínához még nincs saját szintkészlet — az utak a közös szinteket használják. Vedd fel itt a szinteket, vagy a Terem profil szekcióban kapcsold ki, majd vissza a diszciplínát: ekkor a másik diszciplína létrája másolódik át.",
  "admin.holdColors": "Fogás színek",
  "admin.holdDeleteTitle": "Fogásszín törlése",
  "admin.holdDeletePromptBody": "{count} aktív út használja ezt a színt. Archiválod őket, vagy véglegesen törlöd?",
  "admin.newHoldPlaceholder": "Új szín neve...",
  "admin.dbTitle": "Adatbázis karbantartás",
  "admin.dbDesc": "Utak, megmászások és értékelések törlése. A művelet nem vonható vissza!",
  "admin.purge.keepYear.label": "📅 Idei év marad",
  "admin.purge.keepYear.desc": "Törli a {year} előtti utakat, megmászásokat és értékeléseket.",
  "admin.purge.keep12m.label": "🕐 Elmúlt 12 hónap marad",
  "admin.purge.keep12m.desc": "Törli a 12 hónapnál régebbi utakat, megmászásokat és értékeléseket.",
  "admin.purge.archived.label": "📦 Archivált utak törlése",
  "admin.purge.archived.desc": "Törli az archivált utakat és a hozzájuk tartozó megmászásokat/értékeléseket.",
  "admin.purge.ascents.label": "🧗 Csak megmászások törlése",
  "admin.purge.ascents.desc": "Törli az összes megmászást (utak és értékelések maradnak).",
  "admin.purge.ratings.label": "⭐ Csak értékelések törlése",
  "admin.purge.ratings.desc": "Törli az összes értékelést (utak és megmászások maradnak).",
  "admin.purge.competitions.label": "🏆 Versenyek és sorozatok törlése",
  "admin.purge.competitions.desc": "Törli az összes versenyt, sorozatot és a hozzájuk tartozó adatokat (csoportok, session-ök, nevezések, kísérletek).",
  "admin.purge.competitionsResult": "{count} verseny és az összes sorozat törölve.",
  "admin.purge.all.label": "💣 Teljes törlés",
  "admin.purge.all.desc": "Törli az összes utat, megmászást és értékelést. Tiszta lap.",
  "admin.purge.confirmAll": "FIGYELEM! Ez MINDENT töröl (utak, megmászások, értékelések).\n\nÍrd be: 'TÖRLÉS' a megerősítéshez.",
  "admin.purge.confirmOther": "Biztosan folytatod?\n\n{desc}\n\nÍrd be: 'TÖRLÉS' a megerősítéshez.",
  "admin.purge.confirmWord": "TÖRLÉS",
  "admin.purge.title": "Adatbázis karbantartás",
  "admin.purge.confirmButton": "Törlés",
  "admin.purge.confirmTypeLabel": "Írd be a(z) \"{word}\" szót a megerősítéshez:",
  "admin.purge.result": "Törölve: {routes} út, {ascents} megmászás, {ratings} értékelés.",

  // Settings
  "settings.profile": "Profil",
  "settings.appearance": "Megjelenés",
  "settings.scoring": "Pontozás",
  "settings.dataAndLegal": "Adatok és jogi",
  "settings.billingSubtitleEmpty": "Nincs mentve számlázási adat",
  "settings.displayName": "Megjelenő név",
  "settings.nameRateLimit": "Túl gyakran változtattad a neved. Kérlek próbáld újra később.",
  "settings.nameRevert": "Eredeti visszaállítása",
  "settings.nameNeedsLetters": "A névben legalább 2 betű legyen.",
  "settings.avatarUseMonogram": "Váltás monogram avatarra",
  "settings.avatarUsePhoto": "Váltás fotó avatarra",

  // Sign-in section (profile settings → 🔐 Bejelentkezés)
  "security.title": "Bejelentkezés",
  "security.emailTitle": "A fiók e-mail címe",
  "security.emailPickSub": "Válaszd ki, melyik címed legyen ez. Csak olyan cím közül lehet választani, amivel be is tudsz lépni.",
  "security.addressOrphan": "Nincs hozzá belépési mód",
  "security.meaningTitle": "Amit ez jelent:",
  "security.meaningMail": "A Sendly e-mailjei ide érkeznek",
  "security.meaningFriends": "A barátaid ezen a címen találnak meg",
  "security.meaningLink": "A jelszó nélküli belépő link is ide jön",
  "security.methodsSub": "Bármelyikkel ugyanabba a fiókba lépsz be.",
  "security.linkRowSub": "mindig a fiók címe",
  "security.disableAction": "Kikapcsolás",
  "security.methodsTitle": "Mivel tudsz belépni",
  "security.methodGoogle": "Google",
  "security.methodApple": "Apple",
  "security.methodEmailLink": "E-mail link",
  "security.noAddress": "Ehhez a módhoz nem tartozik cím",
  "security.methodsHint": "Bármelyik felsorolt móddal ugyanabba a fiókba lépsz be. A Google és az Apple a saját címével azonosít, a varázslink viszont MINDIG a fiók e-mail címére érkezik — annak nincs külön címe. A mászásaid, tagságaid és barátaid a fiókhoz tartoznak, nem a belépési módhoz.",
  "security.notLinkedSub": "Nincs összekapcsolva a fiókoddal",
  "security.enableAction": "Bekapcsolás",
  "security.emailPlaceholder": "uj@cim.hu",
  "security.emailSwitched": "A fiók címe mostantól: {email}",
  "security.makePrimaryAction": "Beállítás",
  "security.makePrimaryConfirmLink": "A fiók e-mail címe {email} lesz. Mivel a varázslinkes belépés mindig a fiók címére érkezik, a belépő linkedet ezután {email} címre küldjük a mostani {current} helyett — a(z) {current} címmel nem fogsz tudni belépni.",
  "security.emailInUseHelp": "Ha a másik fiók is a tiéd és nincs már rá szükséged, lépj be vele és töröld a Beállítások → Fiók törlése alatt — utána ez a cím felszabadul. A törlés végleges: az ottani mászások, tagságok és barátok elvesznek.",
  "security.enableFieldLabel": "Melyik címmel?",
  "security.enableHint": "Erre a címre küldünk egy megerősítő linket. Új cím a fiókra csak így kerülhet fel, ezért a bekapcsolás után ez lesz a fiók e-mail címe — lent bármikor visszaválthatsz.",
  "security.enableSend": "Link küldése",
  "security.linkSent": "Megerősítő link elküldve: {email}",
  "security.linkAwaiting": "Megerősítésre vár — nyisd meg a linket az e-mailedben.",
  "security.linkAwaitingShort": "Elküldve",
  "security.linkAwaitingTitle": "Megerősítésre vár: {email}",
  "security.linkAwaitingHint": "Nyisd meg a linket az erre a címre küldött e-mailben, ugyanezen az eszközön — utána bekapcsol a jelszó nélküli belépés.",
  "security.linkAwaitingCancel": "Mégsem — másik címet adok meg",
  "security.linkAction": "Összekapcsolás",
  "security.unlinkAction": "Leválasztás",
  "security.unlinkConfirm": "Leválasztod a(z) {method} bejelentkezést? Ezután nem tudsz vele belépni, de a fiókod, a mászásaid és a tagságaid megmaradnak — és bármikor újra összekapcsolhatod.",
  "security.lastMethodHint": "Legalább egy bejelentkezési módnak maradnia kell.",
  "security.linked": "Összekapcsolva",
  "security.unlinked": "Leválasztva",
  "security.appleRelayTitle": "Rejtett Apple e-mail cím",
  "security.appleRelayHint": "Ez a cím az Apple-fiókoddal együtt szűnik meg. Ha hosszú távra tervezel, érdemes egy saját címedet is bejelentkezési módként beállítani.",

  // Sign-in section — errors surfaced by mapAuthError (utils/authIdentities.js)
  "security.errEmailInUse": "Ehhez a címhez már tartozik egy Sendly-fiók.",
  "security.errCredentialInUse": "Ez a bejelentkezési mód már egy másik Sendly-fiókhoz tartozik.",
  "security.errRecentLogin": "Biztonsági okból jelentkezz be újra, majd próbáld meg ismét.",
  "security.errNotLinked": "Ez a bejelentkezési mód nincs összekapcsolva a fiókoddal.",
  "security.errGeneric": "A művelet nem sikerült. Próbáld újra.",
  "moderation.cat.profanity": "Trágár vagy sértő kifejezést tartalmaz.",
  "moderation.cat.sexual": "Szexuális tartalmat vagy utalást tartalmaz.",
  "moderation.cat.threat": "Fenyegető tartalmat tartalmaz.",
  "moderation.cat.hate": "Gyűlölködő tartalmat tartalmaz.",
  "moderation.cat.harassment": "Zaklató vagy sértő tartalmat tartalmaz.",
  "moderation.cat.impersonation": "Úgy tűnik, hivatalos szerepet próbál eljátszani.",
  "moderation.cat.generic": "Nem engedélyezett tartalmat tartalmaz.",
  "moderation.nameReset.title": "A megjelenített neved megváltozott",
  "moderation.nameReset.body": "A megjelenített nevedet a Sendly moderáció átállította erre: „{name}”. A Beállításokban bármikor megadhatsz egy másikat.",
  "moderation.nameReset.byPlatform": "Ezt a Sendly platform moderációja kezelte — nem a termed.",
  "moderation.nameReset.noteLabel": "Megjegyzés",
  "settings.birthYear": "Születési év",
  "settings.birthYearPlaceholder": "pl. 1998",
  "settings.birthYearHint": "Korosztályos verseny- és eseménynevezéshez szükséges",
  "settings.birthYearInvalid": "Adj meg egy érvényes évet ({min}–{max})",
  "settings.gender": "Nem",
  "settings.genderFemale": "Nő",
  "settings.genderMale": "Férfi",
  "settings.genderOther": "Egyéb",
  "settings.genderNoAnswer": "Nem adom meg",
  "settings.genderHint": "Opcionális — anonim statisztikákhoz használjuk.",
  "settings.theme": "Téma",
  "settings.language": "Nyelv",
  "settings.haptics": "Haptikus visszajelzés",
  "settings.hapticsHint": "Rövid rezgés megerősítésként a fontosabb műveleteknél (ha az eszköz támogatja — iPhone-on nem elérhető).",
  "settings.notif.title": "Értesítések",
  "settings.notif.device": "Ezen az eszközön",
  "settings.notif.enableDevice": "Push értesítések bekapcsolása",
  "settings.notif.disableDevice": "Push értesítések kikapcsolása",
  "settings.notif.enabled": "Az eszköz regisztrálva",
  "settings.notif.permissionDenied": "Az értesítések le vannak tiltva a böngészőben. Engedélyezd a böngésző oldalbeállításaiban.",
  "settings.notif.unsupportedHint": "Ez az eszköz/böngésző nem támogatja a push értesítéseket. iOS-en telepített PWA-ban (Kezdőképernyőre helyezés) működik.",
  "settings.notif.noVapid": "Hiányzik a VAPID kulcs (VITE_FB_VAPID_KEY) — a push nincs konfigurálva.",
  "settings.notif.error": "Nem sikerült regisztrálni: {code}",
  "settings.notif.group.community": "Felhasználó / közösség",
  "settings.notif.group.gymAdmin": "Terem – admin",
  "settings.notif.group.platform": "Platform",
  "settings.notif.group.moderation": "Moderáció",
  "settings.notif.pref.friendRequests": "Barát-kérés (érkezett / elfogadták)",
  "settings.notif.pref.watchedRoute": "Figyelt út (megmászás, értékelés)",
  "settings.notif.pref.gymNewRoutes": "Új utak a teremben (összevonva)",
  "settings.notif.pref.gymNewComp": "Új verseny a teremben",
  "settings.notif.pref.eventWaitlist": "Esemény: bekerültél a várólistáról",
  "settings.notif.pref.eventReminder": "Esemény: emlékeztető előző nap",
  "settings.notif.pref.gymRouteFreshness": "Régóta nincs új út (3 hét)",
  "settings.notif.pref.mauBand": "MAU sáv átlépése",
  "settings.notif.pref.gymNewMember": "Új tag a teremben (be-/kilépés)",
  "settings.notif.pref.newGym": "Új terem (létrejött / aktiválva / láthatóság)",
  "settings.notif.pref.platformMauBand": "Terem MAU sáv átlépése",
  "settings.notif.pref.crashSpike": "Hibariadó (crash spike)",
  "settings.notif.pref.nameReview": "Név moderálásra vár",
  "settings.notif.pref.sprayProblemComments": "Komment a spray-utamra",
  "settings.notif.pref.sprayReports": "Spray-bejelentések",
  "settings.notif.gymScopedElsewhere": "A termenkénti értesítéseket (új utak, versenyek, figyelt utak) a Termeim menüpontban, teremre bontva állíthatod.",
  "settings.notif.hint": "Kapcsold be a típusokat, amikről értesítést szeretnél kapni.",
  "settings.notif.enableFirst": "Előbb kapcsold be a push értesítéseket ezen az eszközön.",
  "settings.gradePreference": "Nehézségi skála",
  "settings.gradeFont": "Font (6a, 6b+, ...)",
  "settings.gradeV": "V-grade (V3, V4, ...)",
  "settings.weeklyGoal": "Heti cél",
  "settings.weeklyGoalHint": "Állíts be heti célt az előrehaladás nyomon követéséhez. 0 = kikapcsolva.",
  "settings.weeklyGoalPoints": "Pont",
  "settings.weeklyGoalClimbs": "Mászás",
  "settings.weeklyGoalUnitPoints": "pont / hét",
  "settings.weeklyGoalUnitClimbs": "mászás / hét",
  "settings.weeklyGoalPlaceholder": "pl. 50",

  // GymSelector menu
  "gymSelector.menuHelp": "Súgó",
  "gymSelector.menuFeedback": "Írj a Sendlynek",
  "gymSelector.feedbackSubject": "Sendly visszajelzés (v{version})",
  "gymSelector.feedbackBody": "Szia Sendly csapat,\n\n[Írd ide a visszajelzésedet]\n\n\n---\nVerzió: {version}\n",
  "gymSelector.menuContactGym": "Írj a teremnek",
  "gymSelector.contactGymSubject": "Üzenet a Sendly appból – {gym}",
  "gymSelector.contactGymBody": "Sziasztok,\n\n[Írd ide az üzeneted]\n\n\n---\nKüldve a Sendly appból\n",
  "gymSelector.menuPlatformAdmin": "Platform Admin",
  "gymSelector.menuLogout": "Kijelentkezés",

  // Stats tab
  "stats.title": "Statisztikák",
  "stats.title.short": "Stat.",
  "stats.totalPoints": "Összpontszám",
  "stats.climbedRoutes": "Megmászott utak",
  "stats.activityCalendar": "Aktív napok",
  "stats.heatmapHint": "Az elmúlt 12 hét — minden mászós aktivitással. Nem követi az időszak-választót.",
  "stats.heatmapClimbs": "mászás",
  "stats.heatmapSpray": "spray",
  "stats.heatmapAttempts": "projekt",
  "stats.hardest": "Legnehezebb",
  "stats.personalStats": "Személyes statisztikák",
  "stats.gradePyramid": "Nehézség piramis",
  "stats.gradePyramid.idealMarker": "Ideális piramis",
  "stats.activity": "Aktivitás",
  "stats.completion": "Teljesítés",
  "stats.completionHint": "A jelenleg aktív utakra vonatkozik",
  "stats.streak": "{count} hete aktív vagy!",
  "stats.streakBroken": "Legutóbbi sorozatod: {count} hét",
  "stats.noStreak": "Mássz ezen a héten a sorozat indításához!",
  // SmartPeriodPill — universal period selector control
  "period.label": "Időszak",
  "period.prev": "Előző",
  "period.next": "Következő",
  "period.notCurrent": "Nem az aktuális — kattints a vissza-ugráshoz",
  "period.quickPicks": "Gyors választás",
  "period.customRange": "Egyedi tartomány",
  "period.pickEndDate": "Válaszd ki a végdátumot ({d})",
  "period.type.weekly": "Heti",
  "period.type.monthly": "Havi",
  "period.type.yearly": "Éves",
  "period.type.all": "Összesen",
  "period.type.custom": "Egyedi",
  "period.preset.today": "Ma",
  "period.preset.yesterday": "Tegnap",
  "period.preset.thisWeek": "Heti",
  "period.preset.lastWeek": "Múlt hét",
  "period.preset.thisMonth": "Havi",
  "period.preset.lastMonth": "Múlt hónap",
  "period.preset.thisYear": "Éves",
  "period.preset.lastYear": "Tavalyi év",
  "period.preset.last7": "Utolsó 7 nap",
  "period.preset.last30": "Utolsó 30 nap",
  "period.preset.last90": "Utolsó 90 nap",
  "period.preset.lastNDays": "Utolsó {n} nap",
  "period.dow.mon": "H",
  "period.dow.tue": "K",
  "period.dow.wed": "Sze",
  "period.dow.thu": "Cs",
  "period.dow.fri": "P",
  "period.dow.sat": "Szo",
  "period.dow.sun": "V",
  "period.sinceJoined": "Belépésed óta",
  "period.beforeJoinDisabled": "A belépésed előtti időszak nem látható",
  "stats.compare": "Összehasonlítás",
  "stats.compareFriend": "Kivel hasonlítod össze?",
  "stats.commonAscents": "{count} közös megmászás",
  "stats.flashCount": "Flash",
  "stats.flashInBrackets": "(flash)",
  "stats.flashRate": "Flash arány",
  "stats.climbingLevel": "Mászószint",
  "stats.topNAverage": "{count} legnehezebb átlaga",
  "stats.intensityZones": "Intenzitás-zónák",
  "stats.zoneWarmup": "Bemelegítő",
  "stats.zoneHard": "Kemény",
  "stats.zoneLimit": "Limit",
  "stats.intensityZonesHint": "{count} mászás megoszlása a legnehezebb megmászásodhoz mérve · limit = a legnehezebb szinted, kemény = 1–2 szinttel alatta",
  "stats.intensityZonesHintSends": "{count} megmászás megoszlása a legnehezebb megmászásodhoz mérve · limit = a legnehezebb szinted, kemény = 1–2 szinttel alatta",
  "stats.progression": "Fejlődés",
  "stats.progressionPoints": "Pontok",
  "stats.progressionMaxGrade": "Max szint",
  "stats.progressionClimbs": "Mászás",
  "stats.progressionWeeks12": "12 hét",
  "stats.progressionWeeks26": "26 hét",
  "stats.progressionWeeks52": "52 hét",
  "stats.weeklyGoal": "Heti cél",
  "stats.goalReached": "Cél elérve!",
  "quickLog.toggle": "⚡ Gyors naplózás",
  "archiveMode.toggle": "Archiválás mód",
  "archiveMode.armed": "Archiválás mód — koppints egy útra",
  "archiveMode.armedCount": "Archiválva: {count} út",
  "archiveMode.archived": "Archiválva: {name}",
  "archiveMode.alreadyArchived": "Ez az út már archiválva van",
  "archiveMode.failed": "Nem sikerült archiválni: {name}",
  "archiveMode.done": "Kész",
  "quickLog.counter": "{climbs} mászás · {sends} új út",
  "quickLog.cooldown": "{name} — épp most rögzítetted",
  "quickLog.undo": "↩ Vissza",
  "quickLog.done": "Kész",
  "quickLog.todayTitle": "Ma · {count} mászás",
  "quickLog.removeOne": "Egy mászás törlése",
  "activity.title": "Aktivitás",
  "activity.climbs": "Mászás",
  "activity.sessions": "Edzés",
  "activity.perSession": "Ø {count} / edzés",
  "activity.newRoutes": "Ebből új út",
  "activity.longestSession": "Leghosszabb edzés",
  "activity.volumeByGrade": "Volumen nehézség szerint",
  "activity.empty": "Ebben az időszakban még nincs mászásod.",
  "activity.hint": "Minden mászás beleszámít — az első megmászás, az ismétlés, a spray küldés és a spray ismétlés is.",
  "activity.repeats": "Ismétlés",
  "activity.perDay": "Ø mászás / nap",
  "stats.timeline": "Legutóbbi napok",
  "stats.timelineEmpty": "Még nincs bejegyzés.",
  "stats.timelineDaySummary": "{climbs} mászás · {sends} új út",
  "stats.timelineDaySpray": "ebből {count} spray",
  "stats.timelineDayAttempts": "{count} próba",
  "stats.timelineProject": "P {name} · {count} próba",
  "stats.sprayBenchmarkNote": "Spray: csak benchmark problémák",
  "stats.timelineSpraySection": "Spraywall",
  "stats.timelineSprayFlash": "flash",
  "stats.timelineSprayRepeat": "ismétlés",
  "stats.timelineSprayProject": "projekt, {count} próba",
  "stats.timelineSprayProjectNoCount": "projekt",
  "stats.timelineSprayDeleted": "törölt út",
  "stats.timelineSprayUnavailable": "nem elérhető út",
  "stats.leaderboard": "Rangsor",
  "stats.you": "Te",

  // Route modal
  "route.flashBadge": "⚡ Flash",
  "route.hold": "fogás",
  "route.setter": "🔧 Építette:",
  "route.addedBy": "Hozzáadta:",
  "route.watch": "Út figyelése",
  "route.unwatch": "Figyelés kikapcsolása",
  "route.lastEditedBy": "Módosította:",
  "route.unknownUser": "ismeretlen",
  "route.climbersExpand": "+{count} további — kattints a teljes lista kibontásához",

  // User stats modal (climber chip click target)
  "userStats.memberSince": "Csatlakozott:",
  "userStats.noAscents": "Még nincs megmászás ebben a teremben.",
  "userStats.totalAscents": "Megmászás",
  "userStats.totalClimbs": "Összes mászás",
  "userStats.repeatsHint": "ebből {count} ismétlés",
  "userStats.totalPoints": "Pont",
  "userStats.flashCount": "Flash",
  "userStats.activeDays30": "Aktív nap (30)",
  "userStats.currentStreak": "Aktuális streak",
  "userStats.weeks": "hét",
  "userStats.bestStreakHint": "Legjobb: {count} hét",
  "userStats.difficultyBreakdown": "Nehézség szerint",
  "userStats.recentAscents": "Legutóbbi megmászások",
  "userStats.openProfile": "Profil megtekintése",
  "userStats.loadError": "Az adatok betöltése sikertelen.",
  "route.ascentsCount": "🧗 Megmászták:",
  "route.climbAgain": "Mégegyszer",
  "log.today": "Ma",
  "log.empty": "Ma még nem logoltál ezen az úton.",
  "log.emptyArchived": "Archivált út — nem logolható.",
  "log.emptyDay": "Nincs bejegyzés.",
  "log.flashButton": "Flash — elsőre",
  "log.sendNth": "✓ Send · {n}.",
  "log.hint.fresh": "⚡ = elsőre. Ha próbáltad, de nem logoltad: nyomd a Send!-et, utána a ?-re koppintva megadod, hányadikra.",
  "log.hint.project": "Rossz koppintás? Koppints a pöttyre.",
  "log.hint.sent": "Koppints egy pöttyre vagy egy napra a javításhoz.",
  "log.unknownCount.text": "Nem tudjuk, hányadik próbára sikerült.",
  "log.unknownCount.action": "Megadom ›",
  "log.dot.try": "{n}. próba",
  "log.dot.tryGroup": "{count} próba",
  "log.dot.unknown": "Nem tudjuk, hányadikra",
  "log.dot.send": "Send",
  "log.dot.flash": "Flash",
  "log.dot.repeat": "Ismétlés",
  "log.dot.repeatGroup": "{count} ismétlés",
  "log.sel.try": "{n}. próba",
  "log.sel.tryGroup": "{count} próba",
  "log.sel.repeatGroup": "{count} ismétlés",
  "log.sel.tryNote": "A nap próbaszáma eggyel csökken.",
  "log.sel.tryGroupNote": "A Törlés egy próbát vesz le: a nap próbaszáma eggyel csökken.",
  "log.sel.repeatGroupNote": "A Törlés a legutóbbi ismétlést veszi le ({time}).",
  "log.sel.sendNote": "Vele a {count} ismétlés is törlődik, a pont visszavonódik.",
  "log.sel.sendNoteNoRepeats": "A pont visszavonódik.",
  "log.sel.delete": "Törlés",
  "log.sel.deleteDay": "Az egész nap ({count})",
  "log.sel.askCount": "Hányadikra?",
  "log.chart.try": "próba",
  "log.chart.send": "send",
  "log.chart.repeat": "ismétlés",
  "log.chart.tapHint": "koppints egy oszlopra",
  "log.chart.tapBubble": "Koppints egy oszlopra.",
  "log.chart.older": "Korábbi napok",
  "log.chart.newer": "Későbbi napok",
  "log.journal.title": "Napló",
  "log.journal.open": "Napló ›",
  "log.journal.sub": "{name} · {entries} bejegyzés, {days} nap",
  "log.journal.tries": "{count} próba",
  "log.journal.repeats": "{count} ismétlés",
  "log.journal.deleteAll": "Teljes log törlése…",
  "log.journal.done": "Kész",
  "log.journal.confirmTitle": "Teljes log törlése?",
  "log.journal.confirmBody": "A „{name}” mind a {count} bejegyzése törlődik{detail}. Mintha sosem mászottad volna. Nem vonható vissza.",
  "log.journal.confirmSend": "a send",
  "log.count.title": "Hányadik próbára sikerült?",
  "log.count.earlier": "előtte {count} próba más napokon",
  "log.count.flash": "⚡ Elsőre — Flash",
  "log.count.more": "Több?",
  "log.count.ok": "OK",
  "log.count.decrease": "Kevesebb",
  "log.count.increase": "Több",
  "log.count.hint": "Egy koppintás egy számra, és kész. A send előtti próbák borostyán pöttyként jelennek meg a send napján.",
  "log.count.hintUnknown": "Ha nem tudod, csukd be — „?” marad (ismeretlen).",
  "help.info": "Magyarázat",
  "help.gotIt": "Értem",
  "help.info.logButtons": "Magyarázat a gombokhoz",
  "help.info.opinion": "Magyarázat a véleményhez",
  "help.info.chart": "Magyarázat a diagramhoz",
  "help.info.count": "Magyarázat a próbaszámhoz",
  "help.info.footRule": "Magyarázat a lábszabályhoz",
  "help.info.startHold": "Magyarázat a starthoz",
  "route.send": "✓ Send!",
  "route.tried": "Próbáltam",
  "route.whatIsSend": "Mi a send?",
  "route.whatIsSendBody": "Send = az út teljes kimászása esés nélkül, alulról a topig.",
  "route.gradeOpinion": "Szerinted milyen nehéz?",
  "route.gradeOpinion.hint": "Csak az építők látják. A pontot nem változtatja. Később is módosíthatod; a kijelöltre koppintva visszavonod.",
  "route.gradeOpinion.easier": "Könnyebb",
  "route.gradeOpinion.fair": "Reális",
  "route.gradeOpinion.harder": "Nehezebb",
  "route.gradeOpinionLean.easier": "Inkább könnyebb",
  "route.gradeOpinionLean.harder": "Inkább nehezebb",
  "route.gradeOpinionTitle": "Nehézség-vélemény",
  "route.attemptsCount": "{count} próba",
  "route.logRow.repeat": "Ismétlés",
  "route.deleteProject": "Projekt-nap törlése",
  "route.deleteProjectTitle": "Projekt-nap törlése?",
  "route.deleteProjectConfirm": "Törlődik a projekt-nap: {date}, {attempts} próba.",
  "route.deleteSend": "Send törlése",
  "route.deleteSendTitle": "Send törlése?",
  "route.deleteSendConfirm": "Törlődik a send-bejegyzés: „{name}”.",
  "route.deleteSendConfirmRepeats": "Vele együtt {count} ismétlés is törlődik.",
  "route.deleteSendConfirmKeepProject": "A projekt-napok megmaradnak, és újra „projekt” állapotú lesz.",
  "route.deleteRepeat": "Ismétlés törlése",
  "route.deleteRepeatTitle": "Ismétlés törlése?",
  "route.deleteRepeatConfirm": "Törlődik egy ismétlés: {when}.",
  "route.deleteLogTitle": "Teljes log törlése?",
  "route.deleteLogConfirm": "Törlődik a „{name}” minden bejegyzése ({count} bejegyzés). Ez nem vonható vissza.",
  "route.rating": "Értékelés",
  "rating.group": "Értékelés",
  "rating.star": "{count}/5 csillag",
  "rating.display": "{label}: {value}/5",
  "route.commentPlaceholder": "Komment (csak építők látják)...",
  "route.rateLimitError": "Túl sokszor szerkesztetted ezt a kommentet. Kérlek próbáld újra később.",
  "route.updateRating": "Értékelés frissítése",
  "route.saveRating": "Értékelés mentése",
  "route.removeRating": "Értékelés törlése",
  "route.stats": "Statisztikák",
  "route.climbedBadge": "Megmászta",
  "route.edit": "✏️ Szerkesztés",
  "route.name": "Név",
  "route.setterLabel": "Építő",
  "route.difficulty": "Nehézség",
  "route.holdColor": "Fogás szín",
  "route.saveEdit": "💾 Mentés",
  "route.reposition": "📍 Áthelyezés",
  "route.repositionArchivedHint": "Archivált utat nem lehet áthelyezni — előbb aktiváld.",
  "route.archive": "📦 Archiválás",
  "route.activate": "Aktiválás",
  "route.activateConfirm": "Biztosan visszaaktiválod?",
  "route.delete": "Törlés",
  "route.deleteConfirm": "Biztosan véglegesen törlöd? Ez a megmászásokat, a próbálkozásokat és az értékeléseket is törli — nem visszavonható.",
  "route.difficultyNone": "— Nincs megadva —",
  "route.holdColorNone": "— Nincs megadva —",
  "route.ungradedNoPoints": "Nehézség nélküli utak nem kapnak pontot",
  "route.ungraded": "Nem besorolt",
  "route.noHoldColor": "Nincs szín",
  "route.ungradedShort": "—",
  "legend.unsetRoute": "Nehézség / szín nélküli út",

  // Route builder
  "builder.title": "🔧 Új út rögzítése",
  "builder.clickMap": "Kattints a térképre az elhelyezéshez!",
  "builder.namePlaceholder": "Pl. Sárga villám (opcionális)",
  "builder.setterPlaceholder": "Építő neve (opcionális)",
  "builder.holdColorLabel": "Fogás színe",
  "builder.place": "Elhelyezés →",

  // TV Dashboard
  "tv.loading": "Betöltés...",
  "tv.disabled": "A TV Dashboard nem elérhető.",
  "tv.noAscents": "Még nincsenek megmászások ebben az időszakban.",
  "tv.weeklyLeaderboard": "Heti rangsor",
  "tv.monthlyLeaderboard": "Havi rangsor",
  "tv.alltimeLeaderboard": "Összesített rangsor",
  "tv.todayAscents": "Mai megmászások",
  "tv.map": "🗺️ Térkép",
  "tv.activeRoutes": "aktív út",
  "tv.newRoutes": "új ({days} napon belüli)",
  "tv.new": "ÚJ",
  "tv.noRatings": "Nincs értékelés",
  "tv.timesClimbed": "{count}× mászva",
  "tv.locale": "hu-HU",
  "tv.accessDenied": "Ez a dashboard nem elérhető.",
  "tv.accessDeniedHint": "Kérd el a terem admintól a TV linket.",
  "tv.gradeDistribution": "Nehézség eloszlás",
  "tv.sprayWalls": "Spray falak",
  "tv.sprayPublicProblems": "Nyilvános út",
  "tv.sprayNewProblems": "Új út ({days} nap)",
  "tv.brandingScanTitle": "Mit másztál ma?",
  "tv.brandingScanBody": "Olvasd be a QR kódot a teremhez, jegyezd fel a megmászásokat és kövesd a fejlődésedet.",
  "tv.brandingPoweredBy": "Powered by Sendly",
  "tv.climberOfWeek": "A hét mászója",
  "tv.thisWeek": "ezen a héten",
  "tv.lastWeek": "múlt hét",
  "tv.topRatedRoutes": "Top értékelt utak",
  "tv.weeklyComparison": "Heti összehasonlítás",
  "tv.totalAscentsLabel": "Megmászások",
  "tv.totalPointsLabel": "Pontok",
  "tv.activeClimbers": "Aktív mászók",
  "tv.newRoutesShowcase": "Új utak ({days} nap)",
  "tv.noNewRoutes": "Nincsenek új utak.",
  "tv.milestones": "Mérföldkövek",
  "tv.milestoneAscents": "{count}. megmászás elérve!",
  "tv.milestoneFirstDiff": "Először mászta meg:",
  "tv.upcomingCompetitions": "Közelgő versenyek",
  "tv.externalComp": "Külsős",
  "tv.slidePicker": "Diák",
  "tv.groupPicker": "Csoportok",

  // TV Screen Management
  "tv.screens.title": "TV képernyők kezelése",
  "tv.screens.nameLabel": "Képernyő neve",
  "tv.screens.modeLabel": "Mód",
  "tv.screens.groupLabel": "Csoport",
  "tv.screens.copyLink": "Link másolása",
  "tv.screens.status.online": "Online",
  "tv.screens.status.slow": "Lassú",
  "tv.screens.status.offline": "Offline",
  "tv.screens.pendingLabel": "Várakozik",
  "tv.screens.registrationCode": "Regisztrációs kód",
  "tv.screens.registrationHint": "Ez a kód megjelenik a Beállítások → TV képernyők menüben. Kérd az admint, hogy hagyja jóvá.",
  "tv.screens.waitingForApproval": "Adminisztrátori jóváhagyásra vár...",
  "tv.screens.approveBtn": "Jóváhagyás",
  "tv.screens.rejectBtn": "Elutasítás",
  "tv.screens.namePlaceholder": "pl. Nézőtéri TV",
  "tv.screens.competitionLabel": "Verseny",
  "tv.screens.groupAll": "Összes",
  "tv.screens.seriesLabel": "Sorozat",
  "tv.screens.deleteBtn": "TV törlése",
  "tv.screens.renameBtn": "Átnevezés",
  "tv.screens.tvUrl": "TV dashboard link",
  "admin.tvGymDashboardHint": "Ezek a beállítások csak erre a TV-re vonatkoznak, \"Gym dashboard\" módban.",
  "tv.screens.mapLabel": "Térkép",
  "tv.screens.mapAll": "Összes térkép",
  "tv.screens.tvUrlHint": "Nyissa meg ezt a linket a TV böngészőjében (Raspberry Pi, laptop, Android TV). A képernyőn megjelenik egy regisztrációs kód, amit az alábbi listában jóváhagyhat.",
  "tv.screens.tvUrlNoPermission": "Ehhez a teremhez még nincs TV link. A generálásához terem admin jogosultság kell.",
  "tv.screens.emptyState": "Nincs regisztrált TV. Nyissa meg a fenti linket egy böngészős eszközön, és a megjelenő kóddal regisztrálja itt.",
  "tv.screens.quickActions": "Gyorsműveletek",
  "tv.screens.allToCompetition": "Minden TV-t versenyre",
  "tv.screens.allToGymDashboard": "Minden TV-t gym dashboardra",
  "tv.screens.allOff": "Minden TV ki",
  "tv.screens.modes.gym-dashboard": "Gym dashboard",
  "tv.screens.modes.competition-leaderboard": "Verseny rangsor",
  "tv.screens.modes.competition-clock": "Session visszaszámláló",
  "tv.screens.modes.competition-timer": "Döntő timer",
  "tv.screens.modes.competition-startlist": "Verseny startlista",
  "tv.screens.modes.competition-ceremony": "Eredményhirdetés",
  "tv.screens.modes.series-standings": "Sorozat állás",
  "tv.screens.modes.sendly-branding": "Sendly branding",
  "tv.screens.modes.off": "Kikapcsolva",
  "tv.screens.modes.interval-timer": "Interval timer (Tabata)",
  "tv.screens.clock.noActiveSession": "Nincs aktív session",
  "tv.screens.clock.nextSession": "Következő session",
  "tv.screens.clock.paused": "SZÜNET",
  "tv.screens.clock.competitionEnded": "A verseny véget ért",
  "tv.screens.finals.noActiveFinals": "Nincs aktív döntő",
  "tv.screens.finals.observation": "Megtekintés",
  "tv.screens.finals.climbing": "Mászás",
  "tv.screens.finals.rest": "Pihenő",
  "tv.screens.finals.finished": "Befejezve",
  "tv.screens.finals.round": "{current}/{total}. kör",

  // Admin – TV config
  "admin.tvGradePreference": "TV nehézségi skála",
  "admin.tvLeaderboardMode": "Rangsor módja",
  "admin.tvLbAuto": "Automatikus (heti és havi felváltva)",
  "admin.tvLbWeekly": "Heti",
  "admin.tvLbMonthly": "Havi",
  "admin.tvLbAlltime": "Összesített",
  "admin.tvEnabledSlides": "Aktív slide-ok",
  "admin.tvSlideCompetition": "Aktív verseny",
  "admin.tvSlideUpcomingCompetitions": "Közelgő versenyek",
  "admin.tvSlideSeriesLeaderboard": "Sorozat rangsor",
  "admin.tvSlideLeaderboard": "Rangsor",
  "admin.tvSlideTodayAscents": "Mai megmászások",
  "admin.tvSlideMap": "Térkép",
  "admin.tvSlideBranding": "Branding (QR + névjegy)",
  "admin.tvSlideSprayWalls": "Spray falak",
  "admin.tvSlideGradeDistribution": "Nehézség eloszlás",
  "admin.tvSlideClimberOfWeek": "A hét mászója",
  "admin.tvSlideTopRated": "Top értékelt utak",
  "admin.tvSlideWeeklyComparison": "Heti összehasonlítás",
  "admin.tvSlideNewRoutes": "Új utak showcase",
  "admin.tvSlideMilestones": "Mérföldkövek",

  // Admin – Advanced statistics (advancedStats gated)
  "admin.trafficTitle": "Forgalom (30 nap)",
  "admin.trafficNew": "Új út",
  "admin.trafficRepeat": "Ismétlés",
  "admin.trafficTooltip": "{date}: {total} mászás — {sends} új út, {repeats} ismétlés",
  "admin.trafficWeekend": "Hétvége",
  "admin.gradeDistTitle": "Nehézség eloszlás (aktív utak)",
  "admin.ascentDistTitle": "Mászás eloszlás",
  "admin.ascentDistEmpty": "Ebben az időszakban nincs mászás.",
  "admin.ascentDistTotal": "Összesen: {count} mászás",
  "admin.statsCompareTitle": "Időszak-összehasonlítás",
  "admin.statsCompareRange": "{cur} vs {prev}",
  "admin.statsCompareNoPrev": "Ehhez az időszakhoz nincs összehasonlítási alap.",
  "admin.statsCompareVsPrev": "vs {n}",
  "admin.statsCompareAscents": "Megmászás",
  "admin.statsCompareClimbs": "Összes mászás",
  "admin.statsComparePoints": "Pontszám",
  "admin.statsCompareClimbers": "Aktív mászók",
  "admin.statsCompareNewClimbers": "Új mászók",
  "admin.statsGroupCommunity": "Közösség és aktivitás",
  "admin.statsGroupRoutes": "Utak",
  "admin.topRoutes": "Legnépszerűbb (Top 10)",
  "admin.bottomRoutes": "Legkevésbé mászott (Bottom 5)",
  "admin.repeatRatio": "Ismétlési arány",
  "admin.repeatRatioLegend": "mászás / mászó · ismétlés per mászó",
  "admin.repeatRatioHint": "Melyik útért jönnek vissza. A megmászás-szám pár hét után telítődik, ez nem — ezért ez a jobb jel az útcsere időzítéséhez.",
  "admin.routeClassic": "Klasszikus",
  "admin.routeStrippable": "Bontható",
  "admin.routeAge": "Útvonal életkor",
  "admin.routeAgeAvg": "átlag (nap)",
  "admin.routeAgeOldest": "legrégebbi (nap)",
  "admin.ratingOverview": "Értékelés nehézségenként",
  "admin.userGrowthTitle": "Felhasználói aktivitás",
  "admin.activeUsers30d": "Aktív (30 nap)",
  "admin.activeUsersWeek": "Aktív (7 nap)",
  "admin.retentionRate": "Visszatérés",
  "admin.monthlyJoins": "Új tagok havonta",
  "admin.memberChangesTitle": "Tagsági változások (12 hónap)",
  "admin.memberChangesDailyTitle": "Tagsági változások (30 nap)",
  "admin.memberJoinedLabel": "Csatlakozott",
  "admin.memberLeftLabel": "Kilépett",
  "admin.memberChangesEmpty": "Nincs csatlakozás vagy kilépés az elmúlt 12 hónapban.",
  "admin.memberChangesDailyEmpty": "Nincs csatlakozás vagy kilépés az elmúlt 30 napban.",

  // Admin – TV link
  "admin.tvLinkGenerate": "TV link generálása",
  "admin.tvRegenerateLink": "Új link generálása",
  "admin.tvRegenerateConfirm": "Biztosan új linket generálsz? A korábbi link érvénytelenné válik, és a TV-n újra be kell állítani.",

  // Zoomable map
  "zoomMap.uploadHint": "TÖLTS FEL TÉRKÉP KÉPET",
  "zoomMap.useTwo": "Két ujjal mozgasd a térképet",
  "zoomMap.reset": "Nézet visszaállítása",
  "zoomMap.fullscreen": "Teljes képernyő",
  "zoomMap.exitFullscreen": "Teljes képernyő kikapcsolása",

  // Default difficulty / hold colour labels and the "unknown" placeholders —
  // `diff.*`, `hold.*`, `route.unknownColor`, `route.unknownDifficulty` — come
  // from the shared table the e-mails read too, so the two cannot diverge.
  ...routeLabelDictEntries(ROUTE_LABELS.hu),

  // Friends
  "friends.title": "Barátok",
  "friends.tab": "Barátok",
  "friends.addPlaceholder": "Email cím...",
  "friends.send": "Küldés",
  "friends.pendingIncoming": "Bejövő kérések",
  "friends.pendingIncomingCount": "{count} új kérés vár rád",
  "friends.acceptedCount": "{count} barát",
  "friends.pendingOutgoing": "Kimenő kérések",
  "friends.list": "Barátok",
  "friends.cancel": "Visszavonás",
  "friends.accept": "Elfogadás",
  "friends.reject": "Elutasítás",
  "friends.removeTitle": "Barát eltávolítása",
  "friends.removeConfirm": "Biztosan törlöd {name} barátságát?",
  "friends.requestSent": "Barátkérés elküldve!",
  "friends.alreadyFriends": "Már barátok vagytok",
  "friends.requestPending": "Már van függő kérés",
  "friends.userNotFound": "Nem található felhasználó ezzel az email címmel",
  "friends.rateLimit": "Túl sok keresés — próbáld újra később",
  "friends.cannotAddSelf": "Saját magadat nem adhatod hozzá",
  "friends.noFriendsYet": "Még nincsenek barátaid",
  "friends.addFriend": "Barátnak jelölés",
  "friends.sent": "Elküldve",
  "friends.searchPlaceholder": "Barát keresése...",

  // Account deletion
  "profile.deleteDescription": "Fiókod és minden hozzá tartozó adatod véglegesen törlődik. Ez a művelet nem vonható vissza.",
  "profile.deleteList": "Törlésre kerül: megmászások, értékelések, baráti kapcsolatok, aktív versenynevezések és eseményregisztrációk. A lezárt versenyek és események eredményei megmaradnak.",
  "profile.deleteConfirmWord": "TÖRLÉS",
  "profile.deleteConfirmLabel": "Írd be: \"{word}\" a megerősítéshez",
  "profile.deleteButton": "Fiók végleges törlése",
  "profile.deleteShowButton": "Fiók törlése…",
  "profile.deleting": "Törlés folyamatban...",
  "profile.deleteError": "Hiba történt a törlés során. Kérlek próbáld meg újra.",
  "profile.deleteErrorPrecondition": "A fiók nem törölhető: vagy platform admin vagy, vagy te vagy egy terem utolsó aktív adminja. Először adj át admin jogot egy másik tagnak vagy töröld a termet.",

  // Leave gym (single gym, account stays)
  "profile.leaveGymShowButton": "Kilépés a teremből…",
  "profile.leaveGymDescription": "Kilépsz ebből a teremből: {gymName}. A fiókod és a többi teremben lévő tagságod érintetlen marad.",
  "profile.leaveGymList": "Törlésre kerül ebben a teremben: megmászások, értékelések, aktív versenynevezések és eseményregisztrációk. A lezárt versenyek és események eredményei megmaradnak.",
  "profile.leaveGymConfirmWord": "KILÉPÉS",
  "profile.leaveGymConfirmLabel": "Írd be: \"{word}\" a megerősítéshez",
  "profile.leaveGymButton": "Kilépés a teremből",
  "profile.leavingGym": "Kilépés folyamatban...",
  "profile.leaveGymError": "Hiba történt a kilépés során. Kérlek próbáld meg újra.",
  "profile.leaveGymErrorLastAdmin": "Te vagy az utolsó aktív admin ebben a teremben. Először adj át admin jogot egy másik tagnak.",
  "profile.leaveGymErrorBanned": "Bannolt tagok nem tudnak saját maguktól kilépni. Vedd fel a kapcsolatot a terem adminjával.",
  "profile.leftGym": "Kiléptél a teremből.",

  // Global profile page (/profile): header, tabs, settings sections
  "profile.pageTitle": "Sendly profilom",
  "profile.menuMyProfile": "Profilom",
  "profile.tab.stats": "Statisztikák",
  "profile.tab.stats.short": "Statisztika",
  "profile.tab.settings": "Beállítások",
  "profile.tab.settings.short": "Beállítás",
  "profile.group.account": "Fiók",
  "profile.group.community": "Közösség",
  "profile.group.gyms": "Termek",
  "profile.group.data": "Adatok",
  "profile.badgeNew": "Új",
  "profile.section.grades.title": "Pontozás és célok",
  "profile.section.data.sub": "Adatexport, jogi dokumentumok",
  "profile.section.delete.sub": "A fiók és minden adat végleges törlése",
  "profile.deleteSectionTitle": "Fiók törlése",
  "profile.myGyms.title": "Termeim",
  "profile.myGyms.sub": "{count} terem",
  "profile.myGyms.empty": "Még nem csatlakoztál egyetlen teremhez sem.",
  "profile.myGyms.enter": "Belépés →",
  "profile.myGyms.ascentCount": "{count} megmászás",
  "profile.myGyms.notifTitle": "Terem értesítések",
  "profile.myGyms.noMembership": "Ebben a teremben jelenleg nincs aktív tagságod, így az értesítések nem állíthatók.",
  "profile.myGyms.pushOffHint": "A push értesítések nincsenek bekapcsolva ezen az eszközön — a termi értesítésekhez először kapcsold be őket az Értesítések menüpontban.",

  // Data export
  "export.title": "📦 Adatexport",
  "export.userDesc": "Az összes személyes adatod letöltése JSON formátumban (profil, megmászások, értékelések, baráti kapcsolatok).",
  "export.userButton": "Adataim letöltése",
  "export.gymTitle": "📦 Adatexport",
  "export.gymDesc": "Az összes teremhez tartozó adat letöltése JSON formátumban (utak, megmászások, értékelések, tagok, versenyek).",
  "export.gymButton": "Terem adatok letöltése",
  "export.loading": "Exportálás...",
  "export.failed": "Az exportálás nem sikerült. Próbáld újra.",

  // Gym Selector
  // Gym info modal
  "gymInfo.title": "Terem információ",
  "gymInfo.backToGyms": "Vissza a termekhez",
  "gymInfo.copyLink": "Link másolása",
  "gymInfo.linkCopied": "Link másolva!",

  "gymSelector.title": "Válaszd ki a termet",
  "gymSelector.search": "Terem keresése...",
  "gymSelector.noResults": "Nincs találat a keresésedre.",
  "gymSelector.noGyms": "Még nincs elérhető terem.",
  "gymSelector.nearbyBtn": "Közelben",
  "gymSelector.routes": "út",
  "gymSelector.members": "tag",
  "gymSelector.openNow": "Nyitva",
  "gymSelector.closingSoon": "Hamarosan zár",
  "gymSelector.closedNow": "Zárva",
  "gymSelector.opensAt": "{day} {time}-kor nyit",
  "gymSelector.opensAtToday": "{time}-kor nyit",
  "gymSelector.today": "Ma",
  "gymSelector.moreInfo": "Részletek",
  "gymSelector.lessInfo": "Kevesebb",
  "gymSelector.notFound": "A terem nem található",
  "gymSelector.backToList": "Vissza a teremlistához",
  "gymSelector.loadFailed": "Nem sikerült betölteni a termet",
  "gymSelector.loadFailedBody": "Megszakadt a kapcsolat a szerverrel. Ellenőrizd az internetkapcsolatod, és próbáld újra.",
  "notFound.title": "Hoppá, ez az oldal nincs meg",
  "notFound.body": "A megnyitott link talán elgépelt vagy lejárt. Egy régi QR kód vagy könyvjelző is ide hozhatott. Innen vissza tudsz menni a teremlistához.",
  "notFound.cta": "Vissza a teremlistához",
  "gymSelector.signIn": "Bejelentkezés",
  "gymSelector.signInToEnter": "Jelentkezz be a terembe való belépéshez",
  "gymSelector.signInToContinue": "Jelentkezz be a megnyitni kívánt oldalhoz",
  "gymSelector.mapToggle": "Térkép",
  "gymSelector.calendarBtn": "Naptár",
  "gymSelector.mapEnter": "Belépés",
  "gymSelector.mapLoadError": "A térkép nem tölthető be. Próbáld újra később.",
  "gymSelector.myLocation": "Saját pozíció",
  "gymSelector.showAll": "Összes terem mutatása ({count})",
  "gymSelector.recent": "Látogatott",
  "gymSelector.notPublic": "Nem publikus",

  // Gym Profile Editor
  "gymEditor.title": "Terem profil",
  "gymEditor.name": "Terem neve",
  "gymEditor.slug": "URL slug (nem szerkeszthető)",
  "gymEditor.description": "Leírás",
  "gymEditor.address": "Cím",
  "gymEditor.city": "Város",
  "gymEditor.country": "Ország",
  "gymEditor.contactEmail": "Email cím",
  "gymEditor.contactPhone": "Telefonszám",
  "gymEditor.website": "Weboldal",
  "gymEditor.facebook": "Facebook",
  "gymEditor.instagram": "Instagram",
  "gymEditor.accentColor": "Szín téma",
  "gymEditor.coverImage": "Borítókép",
  "gymEditor.uploadCover": "Borítókép feltöltése",
  "gymEditor.isPublic": "Nyilvános megjelenés",
  "gymEditor.isPublicDesc": "A terem megjelenik a nyilvános teremválasztóban.",
  "gymEditor.location": "GPS helyzet",
  "gymEditor.latitude": "Szélességi fok",
  "gymEditor.longitude": "Hosszúsági fok",
  "gymEditor.detectLocation": "Jelenlegi pozícióm használata",
  "gymEditor.clearLocation": "Törlés",
  "gymEditor.locationHint": "Add meg kézzel a koordinátákat, vagy nyomd meg a gombot a teremben az automatikus felismeréshez. A távolság szerinti rendezéshez kell.",
  "gymEditor.geoNotSupported": "A böngésződ nem támogatja a helymeghatározást.",
  "gymEditor.openingHours": "Nyitvatartás",
  "gymEditor.timezone": "Időzóna",
  "gymEditor.opensAt": "Nyitás",
  "gymEditor.closesAt": "Zárás",
  "gymEditor.timezoneAuto": "Böngésző alapértelmezett (auto)",
  "gymEditor.timezoneSuggest": "{tz} használata",
  "gymEditor.timezoneHint": "A nyitvatartás ebben az időzónában lesz kiértékelve, így a más időzónából érkező látogatók is helyes nyitva/zárva státuszt látnak.",
  "gymEditor.dayClosed": "+ Időpont megadása",
  "gymEditor.dayUnset": "Hiányzik",
  "gymEditor.openingHoursIncomplete": "Nincs minden nap kitöltve — add meg minden napra a nyitvatartást, vagy jelöld zártnak.",
  "gymEditor.openingHoursAllClosed": "Nem lehet minden nap zárva — legalább egy napon nyitva kell lennie.",
  "gymEditor.mon": "Hé",
  "gymEditor.tue": "Ke",
  "gymEditor.wed": "Sze",
  "gymEditor.thu": "Csü",
  "gymEditor.fri": "Pé",
  "gymEditor.sat": "Szo",
  "gymEditor.sun": "Va",
  "gymEditor.monFull": "Hétfő",
  "gymEditor.tueFull": "Kedd",
  "gymEditor.wedFull": "Szerda",
  "gymEditor.thuFull": "Csütörtök",
  "gymEditor.friFull": "Péntek",
  "gymEditor.satFull": "Szombat",
  "gymEditor.sunFull": "Vasárnap",
  "gymEditor.specialHours": "Kivételes nyitvatartás",
  "gymEditor.specialHoursHint": "Adott napokra eltérő nyitvatartás vagy zárva nap — például ünnepnapok. A megadott dátumon felülírja a heti rendet.",
  "gymEditor.addSpecial": "+ Kivételes nap hozzáadása",
  "gymEditor.specialLabel": "Megnevezés (opcionális)",
  "gymEditor.specialOpen": "Nyitva",
  "gymEditor.specialClosed": "Zárva",
  "gymEditor.specialNone": "Nincs megadva kivételes nap.",
  "gymEditor.specialDuplicate": "Több bejegyzés azonos dátummal — csak az első érvényesül.",

  // Admin section rename
  "admin.difficultyAndColors": "Nehézség & Színek",

  // Platform Admin
  "platformAdmin.title": "Sendly Admin",
  "platformAdmin.gyms": "Termek",
  "platformAdmin.stats": "Statisztikák",
  "platformAdmin.createGym": "Terem létrehozása",
  "platformAdmin.searchGyms": "Terem keresése...",
  "platformAdmin.allPlans": "Összes csomag",
  "platformAdmin.planFilter": "Csomag szerinti szűrés",
  "platformAdmin.gymCount": "Termek",
  "platformAdmin.totalUsers": "Összes felhasználó",
  "platformAdmin.users": "Felhasználók",
  "platformAdmin.usersSearch": "Keresés név vagy email alapján…",
  "platformAdmin.moderation.title": "Moderálás",
  "platformAdmin.moderation.sub": "Név-felülvizsgálat és tiltólista",
  "platformAdmin.moderation.queueTitle": "Felülvizsgálatra váró nevek",
  "platformAdmin.moderation.queueEmpty": "Nincs felülvizsgálatra váró név",
  "platformAdmin.moderation.banlistTitle": "Tiltólista",
  "platformAdmin.moderation.banlistEmpty": "A tiltólista üres",
  "platformAdmin.moderation.approve": "Jóváhagyás",
  "platformAdmin.moderation.reject": "Elutasítás",
  "platformAdmin.moderation.approved": "Név jóváhagyva",
  "platformAdmin.moderation.resetDone": "Név visszaállítva",
  "platformAdmin.moderation.unbanned": "Feloldva a tiltólistáról",
  "platformAdmin.moderation.unban": "Feloldás",
  "platformAdmin.moderation.actionError": "A művelet nem sikerült",
  "platformAdmin.moderation.sourceAi": "AI-jelölt",
  "platformAdmin.moderation.sourceGym": "Jelentette: {gym}",
  "platformAdmin.moderation.resetTitle": "Név visszaállítása",
  "platformAdmin.moderation.currentName": "Jelenlegi név",
  "platformAdmin.moderation.restoreOriginal": "Eredeti visszaállítása",
  "platformAdmin.moderation.noOriginal": "Nincs eredeti",
  "platformAdmin.moderation.generate": "Generált név",
  "platformAdmin.moderation.regenerate": "Újragenerálás",
  "platformAdmin.moderation.newName": "Új név",
  "platformAdmin.moderation.confirmReset": "Visszaállítás és tiltás",
  "platformAdmin.moderation.confirmResetOnly": "Visszaállítás tiltás nélkül",
  "platformAdmin.moderation.commentPlaceholder": "Üzenet a felhasználónak (opcionális)…",
  "platformAdmin.moderation.commentHint": "Ha kitöltöd, a felhasználó látja a névváltozás-értesítőben.",
  "platformAdmin.moderation.resetNameAction": "Név moderálása",
  "platformAdmin.moderation.mode.original": "eredeti",
  "platformAdmin.moderation.mode.generated": "generált",
  "platformAdmin.usersEmpty": "Nincs találat",
  "platformAdmin.usersShowMore": "Több mutatása ({count})",
  "platformAdmin.userGymsStat": "Terem",
  "platformAdmin.userAdminBadge": "Admin",
  "platformAdmin.userLastLogin": "Utolsó belépés",
  "platformAdmin.userModalMemberships": "Terem tagságok",
  "platformAdmin.userModalNoGyms": "Nem tagja egy teremnek sem",
  "platformAdmin.userModalLoadError": "A felhasználó adatai nem tölthetők be",
  "platformAdmin.userBannedBadge": "Kitiltva",
  "platformAdmin.userBan": "Kitiltás",
  "platformAdmin.userUnban": "Feloldás",
  "platformAdmin.userPlatformBanned": "Platform-tiltás",
  "platformAdmin.userModalBannedFrom": "Kitiltva innen",
  "platformAdmin.totalAscents": "Megmászás",
  "platformAdmin.totalClimbs": "Összes mászás",
  "platformAdmin.demoBadge": "Demo",
  "platformAdmin.gymStatusActive": "Aktív",
  "platformAdmin.gymStatusInactive": "Inaktív",
  "platformAdmin.billingMissingBadge": "Számlázási adat hiányzik",
  "platformAdmin.billingMissingNote": "{count} terem kap számlát ebben a negyedévben, de hiányosak a számlázási adatai, így a számla nem állítható ki.",
  "platformAdmin.totalRoutes": "Összes út",
  "platformAdmin.statsSummary": "Összesítő",
  "platformAdmin.emailPrefsTitle": "Felhasználói email beállítások",
  "platformAdmin.topGymsByUsers": "Legnépszerűbb termek (felhasználók)",
  "platformAdmin.topGymsByAscents": "Legnépszerűbb termek (megmászások)",
  "platformAdmin.planDistribution": "Csomag eloszlás",
  "platformAdmin.enterGym": "Belépés a terembe",
  "platformAdmin.accessDenied": "Hozzáférés megtagadva",
  "platformAdmin.backToGyms": "Vissza a teremlistához",
  "platformAdmin.buildInfo": "Verzió és build infó",
  "platformAdmin.deleteConfirm": "Írd be DELETE a(z) {name} végleges törléséhez:",
  "platformAdmin.settingsTab": "Beállítások",
  "platformAdmin.showMap": "Térkép a teremválasztón",
  "platformAdmin.googleMapsKey": "Google Maps API kulcs",
  "platformAdmin.googleMapsKeyHint": "A Google Cloud Console-ból szerezhető be. A Maps JavaScript API-t kell engedélyezni.",
  "platformAdmin.mapSaved": "Mentve!",
  "platformAdmin.accentColor": "Platform szín",
  "platformAdmin.accentColorHint": "A platform admin felület akcentszíne. A termek saját színét nem befolyásolja.",
  "platformAdmin.accentColorSaved": "Mentve!",
  "platformAdmin.accentColorHex": "Szín hex kódja",
  "platformAdmin.gradeScale": "Nehézségi skála",
  "platformAdmin.gradeScaleHint": "A normalizált pontszámok és fokozatnevek a termek közötti összehasonlításhoz. Módosítás után mentsd el.",
  "platformAdmin.gradeFont": "Font",
  "platformAdmin.gradeV": "V-skála",
  "platformAdmin.gradeFrench": "Francia",
  "platformAdmin.gradeUiaa": "UIAA",
  "platformAdmin.gradePoints": "Pont",
  "platformAdmin.gradeAdd": "Új fokozat",
  "platformAdmin.gradeScaleSaved": "Mentve!",
  "platformAdmin.gradeScaleReset": "Alapértelmezés",
  "platformAdmin.gradeRow": "{row}. fokozat",
  "platformAdmin.gradeRemove": "Fokozat törlése",
  "platformAdmin.adminsTitle": "Platform adminok",
  "platformAdmin.adminsHint": "Mindenki, akinek van platform-jogosultsága. A teljes platform admin minden termet, beállítást és statisztikát kezel; a „Részleges” jelölésűek csak a 🔑 alatt bejelölt jogosultságokat kapták meg.",
  "platformAdmin.adminsPartialBadge": "Részleges",
  "platformAdmin.adminsAdd": "Hozzáadás",
  "platformAdmin.adminsRemove": "Eltávolítás",
  "platformAdmin.adminsEmailPlaceholder": "Felhasználó email címe...",
  "platformAdmin.adminsEmailLabel": "Új platform admin email címe",
  "platformAdmin.adminsNotFound": "Nem található felhasználó ezzel az email címmel",
  "platformAdmin.adminsAlready": "A felhasználó már platform admin",
  "platformAdmin.adminsLastAdmin": "Utolsó admin",
  "platformAdmin.crashLogsTitle": "Hibanaplók",
  "platformAdmin.crashLogsEmpty": "Nincsenek hibanaplók",
  "platformAdmin.crashLogsStack": "Stack trace",
  "platformAdmin.crashLogsDetails": "Részletek",
  "platformAdmin.crashLogsShowAll": "Összes mutatása ({count})",
  "platformAdmin.crashDigestTitle": "Napi hibajelentés email",
  "platformAdmin.crashDigestHint": "Az előző napi hibanaplók elküldése a megadott email címre minden reggel 7:00-kor (CET).",
  "platformAdmin.crashDigestEnable": "Napi hibajelentés engedélyezése",
  "platformAdmin.crashDigestEmailPlaceholder": "cimzett@pelda.hu",
  "platformAdmin.crashDigestEmailLabel": "Címzett email címe",
  "platformAdmin.crashDigestSaved": "Mentve!",
  "platformAdmin.marketData": "Piaci adatok",
  "platformAdmin.marketDataSub": "Havi anonim snapshot-ok",
  "platformAdmin.marketMap": "Terem-térkép",
  "platformAdmin.marketMapSub": "Termek, aktivitás és közös mászók térképen",
  // Spraywall hold-detection platform page (PlatformHoldDetector)
  "platformAdmin.holdDetector.title": "Fogásfelismerés",
  "platformAdmin.holdDetector.sub": "Aktív modell és valós minőség",
  "platformAdmin.holdDetector.activeTitle": "Aktív modell",
  "platformAdmin.holdDetector.optionLabel": "{id} · {date} · P {p} / R {r}",
  "platformAdmin.holdDetector.activeMark": "aktív",
  "platformAdmin.holdDetector.activate": "Élesítés",
  "platformAdmin.holdDetector.rollback": "Visszalépés: {id}",
  "platformAdmin.holdDetector.confirmTitle": "Modell élesítése",
  "platformAdmin.holdDetector.confirmBody": "Élesíted a(z) {id} modellt? Minden terem felismerése és Okos jelölése a következő hívástól ezt használja.",
  "platformAdmin.holdDetector.switched": "Aktív modell: {id}",
  "platformAdmin.holdDetector.readOnlyHint": "Modellt váltani a platform.settings.edit jogosultsággal lehet.",
  "platformAdmin.holdDetector.noModels": "Még nincs feltöltött modell.",
  "platformAdmin.holdDetector.noActive": "Nincs aktív modell — a felismerés és az Okos jelölés nem elérhető.",
  "platformAdmin.holdDetector.notEligible": "A(z) {id} nem felelt meg az élesítési feltételnek (85% alatti pontosság vagy találati arány a tesztkészleten, vagy gyengébb a feltöltéskor aktív modellnél). Választható, a döntés a tiéd.",
  "platformAdmin.holdDetector.compareTitle": "Verziók összevetése",
  "platformAdmin.holdDetector.compareSub": "utolsó 365 nap · valós használatból",
  "platformAdmin.holdDetector.modeAll": "Mind",
  "platformAdmin.holdDetector.modeFresh": "Új fotó",
  "platformAdmin.holdDetector.modeRefresh": "Frissítés",
  "platformAdmin.holdDetector.colVersion": "Verzió",
  "platformAdmin.holdDetector.colRuns": "Futás",
  "platformAdmin.holdDetector.colPrecision": "Valós pontosság",
  "platformAdmin.holdDetector.colRecall": "Valós találati arány",
  "platformAdmin.holdDetector.colCorrected": "Kézzel javított",
  "platformAdmin.holdDetector.colDuration": "Átl. idő",
  "platformAdmin.holdDetector.durationSec": "{s} mp",
  "platformAdmin.holdDetector.formula": "Valós pontosság = elfogadott / javasolt · valós találati arány = elfogadott / (elfogadott + pótolt + megtartott).",
  "platformAdmin.holdDetector.worstTitle": "Leggyengébb futások",
  "platformAdmin.holdDetector.worstSub": "utolsó 90 nap",
  "platformAdmin.holdDetector.colGym": "Terem",
  "platformAdmin.holdDetector.colWall": "Fal",
  "platformAdmin.holdDetector.colModel": "Modell",
  "platformAdmin.holdDetector.colRunPrecision": "Pontosság",
  "platformAdmin.holdDetector.colRunRecall": "Találati arány",
  "platformAdmin.holdDetector.deletedWall": "törölt fal",
  "platformAdmin.holdDetector.noRuns": "Még nincs futás ebben az időszakban.",
  "platformAdmin.holdDetector.consentsTitle": "Tanítási hozzájárulás",
  "platformAdmin.holdDetector.consentsCount": "{n} terem engedte",
  "platformAdmin.holdDetector.consentsSince": "{date} óta",
  "platformAdmin.holdDetector.loadError": "Nem sikerült betölteni.",

  // Market data viewer (snapshot-only reads)
  "marketData.empty": "Még nincs piaci snapshot. Az első automatikusan elkészül a következő hónap elsején, vagy a backfillMarketSnapshots függvénnyel generálható visszamenőleg.",
  "marketData.platformSummary": "Platform összesítő",
  "marketData.benchmark": "Benchmark: {n}/{min} terem",
  "marketData.benchmarkOk": "Benchmark-képes ({n} terem)",
  "marketData.benchmarkTitle": "Terem-anonimitás: piaci benchmark csak legalább 5 terem adatából készülhet, hogy egyedi terem az átlagból ne legyen visszafejthető.",
  "marketData.prevMonth": "Előző hónap",
  "marketData.nextMonth": "Következő hónap",
  "marketData.monthSelect": "Hónap",
  "marketData.gymSelect": "Terem",
  "marketData.totalAscents": "Mászások",
  "marketData.newRegistrations": "Új regisztrációk",
  "marketData.multiGymUsers": "Több teremben aktív",
  "marketData.errors": "Hibás termek",
  "marketData.trendAscents": "Trend — mászások",
  "marketData.trendMau": "Trend — MAU",
  "marketData.activity": "Aktivitás",
  "marketData.newMembers": "Új tagok",
  "marketData.heatmap": "Heatmap (nap × óra, egyedi mászók)",
  "marketData.retention": "Visszatérők (kohorsz)",
  "marketData.cohortSize": "Kohorsz (új tagok)",
  "marketData.weekN": "{n}. hét",
  "marketData.retentionHint": "Visszatérők a csatlakozás utáni 1/4/12 héten belül (a csatlakozás napja nem számít). A heti érték csak a teljes kohorsz időablakának lezárulta után jelenik meg — addig „—”, a következő havi futások töltik fel. Több-havi nézetben a százalék nevezője csak a már beérett hónapok kohorsza — ilyenkor a kártya „visszatérők/beérett kohorsz” formában mutatja (pl. 31/31).",
  "marketData.grades": "Grade-eloszlás",
  "marketData.routesByGrade": "Aktív utak grade szerint",
  "marketData.ascentsByGrade": "Mászások grade szerint",
  "marketData.climberLevel": "Mászói szint (legnehezebb havi mászás)",
  "marketData.flashRate": "Flash arány",
  "marketData.unknown": "Ismeretlen",
  "marketData.noData": "Nincs adat",
  "marketData.lifecycle": "Út-életciklus (a hónapban archivált utak)",
  "marketData.archivedCount": "Archivált utak",
  "marketData.avgLifetimeDays": "Átl. élettartam (nap)",
  "marketData.avgAscentsPerRoute": "Átl. mászás / út",
  "marketData.decayCurve": "Elhalási görbe (átlag mászás / út / élethét)",
  "marketData.decayHint": "A forgalom a(z) {w}. élethét környékén esik a kezdeti csúcs negyede alá — ekkortájt érdemes az útcserét időzíteni.",
  "marketData.decayNoDrop": "A forgalom a megfigyelt ablakban nem esett a kezdeti csúcs negyede alá.",
  "marketData.decayNoData": "Még nincs elég adat az elhalási görbéhez — hosszabb időablakkal (12 hónap / Összes) több élethét gyűlik össze.",
  "marketData.demographics": "Demográfia",
  "marketData.ageBuckets": "Korosztály (születési évtized)",
  "marketData.gender": "Nem",
  "marketData.language": "Nyelv",
  "marketData.langHu": "Magyar",
  "marketData.langEn": "Angol",
  "marketData.competitions": "Versenyek",
  "marketData.compCount": "Versenyek száma",
  "marketData.totalParticipants": "Nevezők",
  "marketData.externalRatio": "Külsős nevezők aránya",
  "marketData.kAnonNote": "K-anonimitás: minden közzétett csoport mögött legalább 10 egyedi felhasználó áll; a kisebb csoportok az „Ismeretlen” kategóriába olvadnak.",
  "marketData.window1": "1 hónap",
  "marketData.window3": "3 hónap",
  "marketData.window12": "12 hónap",
  "marketData.windowAll": "Összes",
  "marketData.windowSelect": "Időablak",
  "marketData.mauAvg": "MAU (havi átlag)",
  "marketData.monthlyBreakdown": "Havi bontás",
  "marketData.latestMonthHint": "Több-havi nézetben az utak grade szerint, a mászói szint, a flash arány és a demográfia az időszak utolsó hónapját mutatja — ezek egyedi felhasználókat számolnak, hónapok közt nem összegezhetők.",
  "marketData.activation": "Aktivációs tölcsér",
  "marketData.actJoined": "Csatlakozott",
  "marketData.actFirstAscent": "Mászott az 1. héten",
  "marketData.actWeek2": "Aktív a 2. héten",
  "marketData.churn": "Lemorzsolódás (utolsó aktív hét)",
  "marketData.churn_never": "Nem tért vissza",
  "marketData.churn_w1": "1. hét",
  "marketData.churn_w2_4": "2–4. hét",
  "marketData.churn_w5_8": "5–8. hét",
  "marketData.churn_w9_12": "9–12. hét",
  "marketData.churn_unknown": "Ismeretlen (K alatt összevonva)",
  "marketData.gymPairs": "Terem-párok (közös aktív tagok)",
  "marketData.gymPairsEmpty": "Nincs legalább 10 közös aktív taggal rendelkező terem-pár ebben a hónapban.",
  "marketData.refreshCurrentMonth": "Aktuális hónap frissítése",
  "marketData.refreshing": "Frissítés…",
  "marketData.refreshHint": "Az aktuális hónap (hó közbeni) adatainak újraszámítása — nem kell megvárni a hónap végét.",
  "marketData.refreshDone": "{month} piaci adatai frissítve.",
  "marketData.refreshError": "A frissítés nem sikerült",
  "marketData.exportPdf": "PDF export",
  "marketData.exporting": "Exportálás…",
  "marketData.exportError": "Az export nem sikerült",
  "marketData.reportTitle": "Piaci adatok",
  "marketData.pdfGeneratedAt": "Készült: {date}",

  // Market map (Terem-térkép)
  "marketMap.country": "Ország",
  "marketMap.allCountries": "🌍 Összes ország",
  "marketMap.metric": "Mérőszám",
  "marketMap.minShared": "Min. közös mászó",
  "marketMap.edges": "Kapcsolatok",
  "marketMap.heat": "Hőtérkép",
  "marketMap.summary": "Összesítő",
  "marketMap.gyms": "Termek",
  "marketMap.connections": "Kapcsolatok",
  "marketMap.topConnections": "Legtöbb közös mászó",
  "marketMap.sharedClimbers": "Közös mászók",
  "marketMap.noConnections": "Nincs a küszöböt elérő kapcsolat.",
  "marketMap.noApiKey": "A térképhez Google Maps API kulcs kell — állítsd be a Beállítások → Térkép szekcióban.",
  "marketMap.loadError": "A térkép nem tölthető be",
  "marketMap.legendTitle": "Jelmagyarázat",
  "marketMap.legendSize": "Kör mérete = {metric}",
  "marketMap.legendColor": "Szín = aktivitás intenzitása (hova járnak többet)",
  "marketMap.legendEdge": "Vonal vastagsága = közös aktív mászók",
  "marketMap.coordsNote": "{withCoords}/{total} teremnek van beállított koordinátája — koordináta nélküli termek nem jelennek meg a térképen.",
  "marketMap.export": "CSV export",
  "marketMap.csvName": "Terem",
  "marketMap.csvLat": "Szélesség",
  "marketMap.csvLng": "Hosszúság",

  // Platform Gym Editor
  "platformGymEditor.title": "Terem szerkesztése",
  "platformGymEditor.createTitle": "Új terem létrehozása",
  "platformGymEditor.name": "Terem neve",
  "platformGymEditor.slug": "URL slug",
  "platformGymEditor.slugTaken": "Ez a slug már foglalt.",
  "platformGymEditor.city": "Város",
  "platformGymEditor.country": "Ország",
  "platformGymEditor.plan": "Csomag",
  "platformGymEditor.planFree": "Free",
  "platformGymEditor.planPro": "Pro",
  "platformGymEditor.planCompetition": "Competition",
  "platformGymEditor.features": "Funkció felülbírálások",
  "platformGymEditor.friendsSprayHint": "Kikapcsolva a Spraywall barát-szintű útjai és listái is privátként viselkednek.",
  "platformGymEditor.initialAdminEmail": "Kezdő admin (email)",
  "platformGymEditor.adminRequired": "A kezdő admin megadása kötelező",
  "platformGymEditor.userNotFound": "Nem található felhasználó ezzel az email címmel.",
  "platformGymEditor.isActive": "Aktív",
  "platformGymEditor.activate": "A terem aktív és látható.",
  "platformGymEditor.deactivate": "A terem deaktiválva és rejtve.",
  "platformGymEditor.isDemo": "Demo terem",
  "platformGymEditor.isDemoHint": "Nem valódi terem — kizárva a valódi-terem számlálásokból (pl. nyilvános terem-szám, benchmark).",
  "platformGymEditor.deleteGym": "Terem törlése",
  "platformGymEditor.limits": "Limitek",
  "platformGymEditor.limitsHint": "Üres = korlátlan",
  "platformGymEditor.gymAdmins": "Terem adminok",
  "platformGymEditor.addAdminPlaceholder": "Admin hozzáadása email-lel",
  "platformGymEditor.removeAdminConfirm": "Eltávolítod ezt az admint?",
  "platformGymEditor.noAdmins": "Még nincs admin.",
  "platformGymEditor.create": "Terem létrehozása",
  "platformGymEditor.sectionOverview": "Áttekintés",
  "platformGymEditor.sectionPlan": "Csomag és funkciók",
  "platformGymEditor.sectionStatus": "Állapot",
  "platformGymEditor.sectionDanger": "Veszélyzóna",

  // Kiegészítő-keret (add-on) — PlatformGymEditor "Kiegészítők" blokk, docs/spec/15-platform-admin.md
  // ("addons.title" a lenti AdminSubscription-blokkban van definiálva — közös kulcs)
  "addons.mcp.fallbackName": "Sendly MCP szerver",
  "addons.mcp.badge": "MCP",
  "addons.sprayWall.fallbackName": "Spraywall",
  "addons.sprayWall.badge": "Spray",
  "addons.readOnlyHint": "A kiegészítők be- vagy kikapcsolásához a platform.gym.editAddons jogosultság szükséges",
  "addons.contractRefTitle": "Kiegészítő bekapcsolása",
  "addons.contractRefBody": "A(z) „{name}” kiegészítő bekapcsolásához add meg a keretszerződés-melléklet hivatkozását.",
  "addons.contractRefLabel": "Keretszerződés-melléklet hivatkozása",
  "addons.contractRefPlaceholder": "pl. 1. sz. melléklet v1, aláírva 2026-10-01",
  "addons.contractRefRequired": "A keretszerződés-melléklet hivatkozása kötelező",
  "addons.logTitle": "Napló (utolsó 10)",
  "addons.logEmpty": "Még nincs napló-bejegyzés.",
  "addons.logOn": "Bekapcsolva",
  "addons.logOff": "Kikapcsolva",
  "addons.logByUnknown": "Platform admin",
  // Spraywall training consent toggle (PlatformGymEditor, sprayWall add-on card)
  "addons.sprayTraining.title": "Falak használata tanításhoz",
  "addons.sprayTraining.hint": "Csak aláírt hozzájárulással. Visszavonva a következő exportból kimarad; a már betanított modellből nem vehető ki.",
  "addons.sprayTraining.promptTitle": "Tanítási hozzájárulás",
  "addons.sprayTraining.promptBody": "Add meg az aláírt hozzájárulás hivatkozását (keretszerződés-melléklet). A platform audit-naplóba kerül.",
  "addons.sprayTraining.contractRefLabel": "Hozzájárulás hivatkozása",
  "addons.sprayTraining.contractRefPlaceholder": "pl. 2. sz. melléklet, 5. pont — aláírva 2026-10-01",
  "addons.sprayTraining.contractRefRequired": "A hozzájárulás hivatkozása kötelező",
  "addons.sprayTraining.since": "Engedélyezve {date} óta",

  // Feature enforcement / limits
  "limits.routesReached": "Csomag limit elérve ({count}/{max} út).",

  // Global Profile
  "globalProfile.memberSince": "Tag mióta",
  "globalProfile.totalPoints": "Összpontszám",
  "globalProfile.totalAscents": "Megmászás",
  "globalProfile.totalGyms": "Terem",
  "globalProfile.timeline": "Legutóbbi napok",
  "globalProfile.timelineEmpty": "Még nincs bejegyzés.",
  "globalProfile.showMore": "Mutass többet",
  "globalProfile.perGym": "Teremenkénti bontás",
  "globalProfile.points": "pont",
  "globalProfile.ascents": "megmászás",
  "globalProfile.climbs": "mászás összesen",
  "globalProfile.ofWhichNew": "ebből {count} új út",
  "globalProfile.sectionAscents": "Megmászások",
  "globalProfile.sectionActivity": "Aktivitás",
  "globalProfile.totalAscentsN": "Összesen {count} megmászás",
  "globalProfile.totalClimbsN": "Összesen {count} mászás",
  "globalProfile.viewGym": "Terem megnyitása",
  "globalProfile.noGyms": "Még nem csatlakoztál egyetlen teremhez sem.",
  "globalProfile.loading": "Profil betöltése...",
  "globalProfile.thisWeek": "E héten",
  "globalProfile.thisMonth": "E hónapban",
  "globalProfile.diffBreakdown": "Nehézség bontás",

  // Upload validation
  "upload.invalidType": "Nem támogatott fájltípus. Használj JPG, PNG vagy WebP formátumot.",
  "upload.tooLarge": "A fájl túl nagy. Maximum méret: {max} MB.",
  "upload.hintLogo": "Max 1,5 MB · JPG, PNG, WebP",
  "upload.hintImage": "Max 3 MB · JPG, PNG, WebP · Ajánlott: nagy felbontás",

  // PWA install
  "pwa.installHint": "{name} hozzáadása a kezdőképernyőhöz!",
  "pwa.install": "Telepítés",
  "pwa.iosHint": "Nyomd meg a Megosztás ⎋ → Kezdőképernyőhöz adás",

  // App update banner — shown when a new service worker version is ready
  "update.available": "Új verzió érhető el",
  "update.refresh": "Frissítés",
  // Client–backend compatibility (docs/spec/19d-client-backend-compat.md):
  // the build is below the live level — the update modal, the standing screen
  // after the loop brake, the callable refusal text and the /version rows.
  "compat.clientOutdated": "Frissítsd az appot, és próbáld újra",
  "compat.modal.title": "Itt az új Sendly",
  "compat.modal.body": "A folytatáshoz frissíteni kell. Pár másodperc, és már az új verziót használod.",
  "compat.modal.update": "Frissítem",
  "compat.modal.updating": "Frissítés…",
  "compat.stuck.title": "Az app nem tudott frissülni.",
  "compat.stuck.body": "Zárd be teljesen, és nyisd meg újra.",
  "compat.stuck.retrying": "Újra próbálkozik…",
  "compat.stuck.ownLevel": "Saját szint: {level} · build {build}",
  "compat.stuck.liveLevel": "Élő szint: {level} · build {build}",
  "compat.version.level": "kompatibilitás {own} (élő: {live})",
  "compat.version.buildId": "build azonosító",
  "compat.version.liveUnknown": "ismeretlen",
  "offline.banner": "Offline mód — a változtatások az eszközön mentődnek és automatikusan szinkronizálódnak, ha visszajön a kapcsolat",
  "offline.blockedBanner": "{n} mászás nem rögzült — a verseny lezárult vagy a nevezés le van zárva. Kérd a szervezőt, hogy nyissa újra, vagy dobd el az X-szel.",
  // „Van net, de nem megy át semmi" — a telefon fel van kapcsolódva, ezért az
  // offline banner néma, miközben a mentések sorban állnak.
  "offline.pendingBanner": "{n} mentés szinkronizálásra vár — a kapcsolat lassú. Az adatok az eszközön biztonságban vannak.",
  "offline.blockedDiscardTitle": "Sikertelen mászások eldobása",
  "offline.blockedDiscardConfirm": "Biztosan eldobod ezt a(z) {n} sikertelen mászást? Ez a művelet nem visszavonható.",
  "offline.blockedDiscardConfirmLabel": "Eldobás",
  "offline.blockedDiscardAria": "Sikertelen mászások eldobása",

  // Grade normalization
  "grade.gradeRange": "Grade tartomány",
  "grade.noMapping": "Ez a terem még nem rendelte hozzá a nehézségi szinteket a standard fokozatokhoz.",
  "grade.clear": "Tartomány törlése",
  "grade.unmappedWarning": "{count} terem nem használ egységes besorolást",
  "globalProfile.scoreInfoNorm": "Az összpontszám a normalizált nehézségi rendszer alapján számolódik. Minden megmászás a nehézségi szint standard fokozatához rendelt normalizált pontot kap, így a különböző termek eredményei összehasonlíthatóak.",
  "globalProfile.scoreInfoOpen": "Hogyan számoljuk az összpontszámot?",
  "globalProfile.scoreInfoRaw": "Az összpontszám a termek saját pontrendszere alapján számolódik. Ha a termeid beállítják a nehézségi szintjeik standard besorolását, az összpontszám automatikusan normalizáltra vált, ami lehetővé teszi a termek közötti összehasonlítást.",
  "globalProfile.noAdvancedStats": "Nincs elérhető bővített statisztika. A statisztikák csak azoknál a termeknél elérhetők, amelyeknél a funkció aktiválva van.",
  "globalProfile.advancedStatsNotAvailable": "Bővített statisztikák nem elérhetők ennél a teremnél.",
  "globalProfile.activeDays": "Aktív nap",
  "globalProfile.activityHint": "Az aktivitás minden mászást számol, a spray küldést és ismétlést is, minden szakágban — a szakág-szűrő rá nem vonatkozik.",

  // Platform analytics (Phase 6)
  "platform.growthTitle": "Platform növekedés (12 hónap)",
  "platform.totalGyms": "Összes terem",
  "platform.totalUsersAll": "Összes felhasználó",
  "platform.newGymsMonthly": "Új termek havonta",
  "platform.userChangesMonthly": "Felhasználói változások havonta",
  "platform.userChangesDaily": "Felhasználói változások naponta (30 nap)",
  "platform.newUsersLabel": "Új",
  "platform.deletionsLabel": "Törölt",
  "platform.revenueTitle": "Bevétel (12 hónap)",
  "platform.revenueEmpty": "Az elmúlt 12 hónapra nincs számlázott bevétel — vagy minden negyedévben csak 0 Ft-os termek voltak, vagy az utolsó negyedévi futás már a 12 hónapos ablakon kívül esik.",
  "platform.revenueNoRuns": "A grafikon a `sendQuarterlyBilling` által ténylegesen elküldött negyedéves számlázások snapshot-jaiból építkezik. Még nem futott le negyedéves küldés — az első futás után jelennek meg az értékek (jan 1 / ápr 1 / júl 1 / okt 1, 08:00). Vissza­menőleg szándékosan nem számolunk: a csomag, MAU, kedvezmény és árazás bármelyike változhatott közben.",
  "platform.revenueLoadError": "Nem sikerült betölteni a számlázási snapshot-okat.",
  "platform.revenueTotal12m": "12 havi összesen ({currency})",
  "platform.revenueMonthly": "Havi bontás — {currency}",
  "platform.revenueSourceNote": "A grafikon a ténylegesen kiküldött negyedéves számlák snapshot-jait mutatja (platform/quarterlyBilling/runs/{quarter}), nettó (áfa nélküli) összegekkel. Egy gym régi negyedévei akkor is a korábbi csomag/árazás/kedvezmény szerint jelennek meg, ha azóta változtak — ezért egyezik az itteni szám a könyvelésben.",
  "platform.gymHealthTitle": "Terem egészség",
  "platform.sortName": "Név",
  "platform.sortUsers": "Tagok",
  "platform.sortRoutes": "Utak",
  "platform.sortBilling": "Számlázás",
  "platform.sortBy": "Rendezés",
  "platform.colBillingTooltip": "Számlázási adatok kitöltve",
  "platform.colBillingComplete": "Számlázási adatok kitöltve",
  "platform.colBillingMissing": "Hiányoznak a számlázási adatok",
  "platform.colName": "Név",
  "platform.colPlan": "Csomag",
  "platform.colRoutes": "Utak",
  "platform.colUsers": "Tagok",
  "platform.colAscents": "Megm.",
  "platform.upsellTitle": "Upsell jelöltek",
  "platform.upsellLimits": "Free termek limit közelében (80%+)",
  "platform.upsellAdvanced": "Magas aktivitás, advancedStats nélkül",
  "platform.feature.tvDashboard": "TV kijelző",
  "platform.feature.friends": "Barátok",
  "platform.feature.competitions": "Versenyek",
  "platform.feature.customBranding": "Egyedi arculat",
  "platform.feature.dbMaintenance": "Adatbázis-karbantartás",
  "platform.feature.setterStats": "Építő statisztikák",
  "platform.feature.gymPwa": "Terem PWA",
  "platform.feature.advancedStats": "Bővített statisztikák",
  "platform.feature.gradeMapping": "Fokozat-hozzárendelés",
  "platform.noUpsellCandidates": "Nincs upsell jelölt jelenleg.",
  "platform.featureAdoptionTitle": "Funkció adoptáció",

  // GlobalStats
  "globalStats.normalAscent": "Normál",
  "globalStats.friendRanking": "Barátok rangsor",

  // Activity feed
  "feed.title": "Barátok aktivitása",
  "feed.empty": "Nincs friss aktivitás az elmúlt 48 órában.",
  "feed.climbSummary": "{climbs} mászás · {sends} új út",
  "feed.justNow": "Most",
  "feed.hoursAgo": "{count} órája",
  "feed.yesterday": "Tegnap",

  // Activity heatmap labels
  "heatmap.mon": "Hé",
  "heatmap.wed": "Sze",
  "heatmap.fri": "Pé",
  "heatmap.sun": "Va",
  "heatmap.less": "Kevesebb",
  "heatmap.more": "Több",

  // Admin heatmap
  "admin.heatmapTitle": "Úthőtérkép",
  "admin.heatmapHint": "A szám minden mászás — az ismétlések is. Ezért látszik rajta, melyik útért jönnek vissza.",
  "admin.heatmapLegendNone": "0",
  "admin.heatmapLegendLow": "Kevés",
  "admin.heatmapLegendMed": "Közepes",
  "admin.heatmapLegendHigh": "Sok",
  "admin.heatmapLegendHot": "Top",

  // Competition
  "tab.comp": "Verseny",
  "tab.comp.short": "Verseny",
  "comp.title": "Versenyek",
  "comp.backToGym": "Vissza a teremhez",
  "comp.create": "+ Új verseny",

  // Calendar (shared: gym Események tab + platform /calendar)
  "calendar.viewList": "Lista",
  "calendar.viewCalendar": "Naptár",
  "calendar.viewToggle": "Lista vagy naptár nézet",
  "calendar.period": "Időszak",
  "calendar.filterKinds": "Szűrés típus szerint",
  "calendar.kind.all": "Mind",
  "calendar.kind.comp": "Versenyek",
  "calendar.kind.event": "Események",
  "calendar.status.live": "Élő",
  "calendar.status.upcoming": "Közelgő",
  "calendar.status.draft": "Vázlat",
  "calendar.status.closed": "Lezárt",
  "calendar.status.past": "Lezajlott",
  "calendar.reg.open": "Nyitott nevezés",
  "calendar.reg.soon": "Nevezés hamarosan",
  "calendar.reg.closed": "Nevezés lezárva",
  "calendar.reg.toggle": "Nevezési időszak",
  "calendar.reg.legend": "Nevezési időszak",
  "calendar.reg.legendUrgent": "{n} napon belül zárul",
  "calendar.reg.spanLabel": "{name} · nevezés",
  "calendar.reg.closesAt": "Nevezés zárul: {date}",
  "calendar.reg.closesToday": "Nevezés ma {time}-kor zárul",
  "calendar.reg.closesTodayDate": "Nevezés ma zárul",
  "calendar.reg.opensAt": "Nevezés nyílik: {date}",
  "calendar.reg.opensIn": "{n} nap múlva",
  "calendar.reg.daysLeft": "{n} nap",
  "calendar.reg.lastDays": "Utolsó {n} nap!",
  "calendar.reg.untilStart": "Nevezés a kezdés napjáig",
  "calendar.reg.closedOn": "Nevezés lezárult — {date}",
  "calendar.reg.closedManual": "Nevezés lezárva",
  "calendar.external": "Külső",
  "calendar.open": "Megnyitás",
  "calendar.openMonth": "Hónap megnyitása",
  "calendar.openDay": "Nap megnyitása",
  "calendar.openInGym": "Megnyitás a teremben",
  "calendar.modal.about": "Leírás",
  "calendar.modal.groups": "Csoportok",
  "calendar.modal.sessions": "Sessionök",
  "calendar.modal.program": "Program",
  "calendar.modal.friends": "Barátok",
  "calendar.modal.feePerGroup": "Csoportonként eltérő",
  "calendar.modal.free": "Ingyenes",
  "calendar.modal.cap": "max. {n} fő",
  "calendar.backToGyms": "Termek",
  "calendar.platformTitle": "Naptár",
  "calendar.platformSubtitle": "Minden Sendly-terem nyilvános versenye és eseménye egy helyen.",
  "calendar.platformEmpty": "Jelenleg nincs meghirdetett verseny vagy esemény egyik teremben sem.",
  "calendar.platformFooter": "Kattints egy versenyre a részletekért és a nevezésért a terem oldalán.",
  "calendar.today": "Ma",
  "calendar.undated": "Időpont nélkül",
  "calendar.noDate": "nincs dátum",
  "calendar.empty": "Nincs megjeleníthető verseny vagy esemény ebben az időszakban.",
  "calendar.emptyButReg": "Ebben az időszakban nincs verseny vagy esemény — a jelölt napokon viszont nyitva van egy-egy nevezés.",
  "calendar.more": "+{n} még",
  "calendar.dow.0": "H",
  "calendar.dow.1": "K",
  "calendar.dow.2": "Sze",
  "calendar.dow.3": "Cs",
  "calendar.dow.4": "P",
  "calendar.dow.5": "Szo",
  "calendar.dow.6": "V",
  "comp.import.excel.btnLabel": "📊 Import Excel-ből",
  "comp.import.excel.title": "Verseny importálása Excel-ből",
  "comp.import.results.btnLabel": "Eredmények importálása Excel-ből",
  "comp.import.results.title": "Eredmények importálása Excel-ből",
  "comp.import.results.fileLabel": "Excel fájl (.xlsx)",
  "comp.import.results.dropzoneHint": "Kattints vagy húzd ide a fájlt",
  "comp.import.results.formatHelpTitle": "Elvárt formátum",
  "comp.import.results.formatHelpBody": "A B oszlopban van a versenyző neve. Az 1. sorban oszloppárok (pl. 'R1Z', 'R1T', 'R2Z', 'R2T') — a prefix az út neve. R1Z = az R1 út zóna próbáinak száma, R1T = az R1 út top próbáinak száma. Üres vagy 0 érték = nem érte el. Akinek top száma > 0, annak a zóna is elérve. A meglévő próbák felülíródnak, ha a versenyzőt és az utat sikerült beazonosítani.",
  "comp.import.results.previewTitle": "Előnézet",
  "comp.import.results.previewMatchedRoutes": "Beazonosított utak: {matched} / {total}",
  "comp.import.results.previewMatchedRows": "Beazonosított versenyzők: {matched} / {total}",
  "comp.import.results.previewTotalWrites": "Mentendő próbák: {n}",
  "comp.import.results.previewSkippedUnchanged": "Változatlan (kihagyva): {n}",
  "comp.import.results.warningsTitle": "Figyelmeztetések",
  "comp.import.results.warnUnmatchedRoutes": "Nem található utak a versenyben: {names}",
  "comp.import.results.warnUnmatchedRows": "Nem nevezett versenyzők: {names}",
  "comp.import.results.warnDuplicateProblemName": "Két kiválasztott probléma neve azonos ({name}) — az oszlop nem rendelhető egyértelműen.",
  "comp.import.results.warnUnknownHeaders": "Figyelmen kívül hagyott oszlopok (nem {{útnév}}Z / {{útnév}}T): {headers}",
  "comp.import.results.nextBtn": "Tovább",
  "comp.import.results.importBtn": "Importálás",
  "comp.import.results.importing": "Importálás folyamatban... ({n} / {total})",
  "comp.import.results.doneTitle": "Eredmények sikeresen importálva",
  "comp.import.results.doneSummary": "{n} próba mentve.",
  "comp.import.results.errorInvalidFile": "Csak .xlsx fájl tölthető fel.",
  "comp.import.results.errorParseFailure": "A fájl nem olvasható. Ellenőrizd, hogy érvényes .xlsx formátum-e.",
  "comp.import.results.errorRow": "Az importálás megállt a(z) {n}. bejegyzésnél ({name}): {message}. Ugyanezt a fájlt nyugodtan importálhatod újra — a már beírt sorok nem duplázódnak.",
  "comp.import.results.errorEmptyFile": "A fájl nem tartalmaz feldolgozható adatot (B oszlop + Rn{Z|T} fejlécek kellenek).",
  "comp.import.results.errorImportFailed": "Hiba történt az import során: {message}",
  "comp.import.excel.competitionName": "Verseny neve",
  "comp.import.excel.fileLabel": "Excel fájl (.xlsx)",
  "comp.import.excel.dropzoneHint": "Kattints vagy húzd ide a fájlt",
  "comp.import.excel.formatHelpTitle": "Elvárt formátum",
  "comp.import.excel.formatHelpBody": "Az A oszlop a session neve, B a versenyző neve. A C és D oszlop opcionális, nem kerül feldolgozásra. Minden tab két csoportot ad: '{sheet} Kezdő' és '{sheet} Haladó' — mindenki alapból a Haladó csoportba kerül, később az admin szerkesztőből a Kezdőbe áttehető.",
  "comp.import.excel.previewTitle": "Előnézet",
  "comp.import.excel.previewSessionsCount": "Session-ök: {n}",
  "comp.import.excel.previewGroupsCount": "Csoportok: {n}",
  "comp.import.excel.previewCompetitorsCount": "Versenyzők összesen: {n}",
  "comp.import.excel.warningsTitle": "Figyelmeztetések ({n})",
  "comp.import.excel.warningRow": "{sheet}, sor {row}: {reason}",
  "comp.import.excel.warningEmptyCell": "Üres cella",
  "comp.import.excel.warningInvalidGender": "Érvénytelen Nem érték: '{value}'",
  "comp.import.excel.warningEmptySheet": "Üres tab (nincs adatsor)",
  "comp.import.excel.nextBtn": "Tovább",
  "comp.import.excel.importBtn": "Létrehozás",
  "comp.import.excel.importing": "Importálás folyamatban...",
  "comp.import.excel.stepCreatingComp": "Verseny létrehozása...",
  "comp.import.excel.stepCreatingGroups": "Csoportok létrehozása ({n}/{total})...",
  "comp.import.excel.stepCreatingSessions": "Session-ök létrehozása ({n}/{total})...",
  "comp.import.excel.stepCreatingGuests": "Vendég versenyzők nevezése ({n}/{total})...",
  "comp.import.excel.doneTitle": "Verseny sikeresen létrehozva!",
  "comp.import.excel.doneSummary": "{sessions} session, {groups} csoport, {competitors} vendég versenyző",
  "comp.import.excel.openEditor": "Szerkesztés megnyitása",
  "comp.import.excel.errorInvalidFile": "Csak .xlsx fájl tölthető fel.",
  "comp.import.excel.errorParseFailure": "A fájl nem olvasható. Ellenőrizd, hogy érvényes .xlsx formátum-e.",
  "comp.import.excel.errorEmptyFile": "A fájl nem tartalmaz importálható adatot.",
  "comp.import.excel.errorImportFailed": "Hiba történt az import során: {message}",
  "comp.import.excel.errorPartialImport": "A verseny részben létrejött. A piszkozatok között megtalálod.",

  // Verseny sablon — vágólapra másolás és beillesztés
  "comp.template.copy.btnLabel": "Másolás sablonként",
  "comp.template.copy.downloadLabel": "Letöltés .json-ként",
  "comp.template.copy.copied": "Verseny-sablon a vágólapra másolva",
  "comp.template.copy.failed": "Nem sikerült a vágólapra másolni.",
  "comp.template.copy.unsupported": "Ebből a verseny típusból nem készíthető sablon.",
  "comp.template.paste.btnLabel": "📋 Beillesztés sablonból",
  "comp.template.paste.title": "Verseny létrehozása sablonból",
  "comp.template.paste.intro": "Illessz be egy másik versenyből másolt sablont. A beállítások, a csoportok és a sessionök jönnek át — utak, dátumok, résztvevők és eredmények nem.",
  "comp.template.paste.nameLabel": "Az új verseny neve",
  "comp.template.paste.previewTitle": "Amit a sablon tartalmaz",
  "comp.template.paste.previewCounts": "{groups} csoport · {sessions} session",
  "comp.template.paste.previewSource": "Forrás: {gym}",
  "comp.template.paste.previewExcluded": "Nem jön át: utak, dátumok, résztvevők, szervezők, bírók, eredmények. A verseny piszkozatként jön létre.",
  "comp.template.paste.previewExcluded_external": "Nem jön át: dátumok, eredmény-link. A verseny piszkozatként jön létre.",
  "comp.template.paste.previewExcluded_challenge": "Nem jön át: dátumok, résztvevők, kizárások, eredmények. A kihívás piszkozatként jön létre.",
  "comp.template.paste.warningsTitle": "Figyelmeztetések ({n})",
  "comp.template.paste.warnUnknownGroupKey": "A(z) „{session}” session ismeretlen csoportra hivatkozik: {key} — kihagyva.",
  "comp.template.paste.warnDuplicateGroupKey": "Ismétlődő csoport-kulcs: {key} — a második új kulcsot kapott.",
  "comp.template.paste.warnGroupNoName": "A(z) {n}. csoportnak nincs neve — kihagyva.",
  "comp.template.paste.warnUnknownDifficulty": "A(z) {group} csoport legnehezebb szintje ebben a teremben nem létezik — felső határ nélkül jön létre.",
  "comp.template.paste.warnSprayNoAddon": "A sablon spray forrású, de a teremben nincs Spraywall — a vázlatban állítsd át a forrást Utakra.",
  "comp.template.paste.warnSessionNoName": "A(z) {n}. sessionnek nincs neve — kihagyva.",
  "comp.template.paste.warnGroupsTruncated": "{n} csoport a limit fölött — kihagyva.",
  "comp.template.paste.warnSessionsTruncated": "{n} session a limit fölött — kihagyva.",
  "comp.template.paste.createBtn": "Létrehozás",
  "comp.template.paste.importing": "Létrehozás…",
  "comp.template.paste.stepCreatingComp": "Verseny létrehozása…",
  "comp.template.paste.stepCreatingGroups": "Csoportok létrehozása… ({n}/{total})",
  "comp.template.paste.stepCreatingSessions": "Sessionök létrehozása… ({n}/{total})",
  "comp.template.paste.doneTitle": "A verseny létrejött",
  "comp.template.paste.doneSummary": "{groups} csoport és {sessions} session jött létre.",
  "comp.template.paste.doneSummarySimple": "A beállítások átjöttek a sablonból.",
  "comp.template.paste.doneNextSteps": "A verseny piszkozat állapotban van. Állítsd be a dátumokat és az utakat, mielőtt aktiválod.",
  "comp.template.paste.doneNextSteps_external": "A verseny piszkozat állapotban van. Állítsd be a dátumokat és ellenőrizd a linket, mielőtt aktiválod.",
  "comp.template.paste.doneNextSteps_challenge": "A kihívás piszkozat állapotban van. Állítsd be a dátumokat, mielőtt aktiválod.",
  "comp.template.paste.openEditor": "Megnyitás",
  "comp.template.paste.error_empty": "A mező üres — illessz be egy sablont.",
  "comp.template.paste.error_notJson": "A beillesztett szöveg nem érvényes JSON.",
  "comp.template.paste.error_notTemplate": "A beillesztett szöveg nem Sendly verseny-sablon.",
  "comp.template.paste.error_wrongKind": "Ez nem verseny-sablon.",
  "comp.template.paste.error_futureVersion": "Ez a sablon egy újabb verzióval készült. Frissítsd az alkalmazást.",
  "comp.template.paste.error_noContent": "A sablon nem tartalmaz versenynevet, csoportot vagy sessiont.",
  "comp.template.paste.errorImportFailed": "Hiba történt a létrehozás során: {message}",
  "comp.template.paste.errorPartialImport": "A verseny részben létrejött. A piszkozatok között megtalálod.",
  // Shared by every "create from template" dialog (competition, event).
  "template.textareaLabel": "Sablon (JSON)",
  "template.textareaPlaceholder": "Ide illeszd be a sablont (Ctrl+V), vagy húzz ide egy .json fájlt",
  "template.clipboardHint": "Ha a böngésző nem engedte a vágólap olvasását, illeszd be kézzel a mezőbe (Ctrl+V), vagy válassz egy korábban mentett .json fájlt.",
  "template.pickFile": "Fájl kiválasztása…",
  "template.clear": "Törlés",
  "template.errorFileTooLarge": "A fájl túl nagy (max. 2 MB).",
  "template.errorFileRead": "A fájlt nem sikerült beolvasni.",

  "comp.activate": "Aktiválás",
  "comp.close": "Lezárás",
  "comp.closing": "Lezárás folyamatban…",
  "comp.closeFailed": "A lezárás nem sikerült",
  "comp.delete": "Törlés",
  "comp.status.draft": "Vázlat",
  "comp.status.active": "Aktív",
  "comp.status.closed": "Lezárt",
  "comp.type.standard": "Standard",
  "comp.type.external": "Külső",
  "comp.type.challenge": "Kihívás",
  "comp.filter.active": "Aktív",
  "comp.filter.closed": "Lezárt",
  "comp.filter.draft": "Vázlat",
  "comp.filter.all": "Mind",
  "comp.participants": "{count} résztvevő",
  "comp.noCompetitions": "Nincs ilyen verseny",
  "comp.noActive": "Jelenleg nincs meghirdetett verseny ebben a teremben.",
  "comp.deleteConfirm": "Biztosan törlöd a(z) \"{name}\" versenyt és minden hozzá tartozó adatot?",
  "comp.deleteFailed": "A verseny törlése nem sikerült",
  "comp.activateConfirm": "Aktiválod a(z) \"{name}\" versenyt? Ezzel elérhetővé válik a versenyzők számára.",
  "comp.activateConfirmExternal": "Aktiválod a(z) \"{name}\" külsős versenyt?",
  "comp.closeConfirm": "Lezárod a(z) \"{name}\" versenyt? A végeredmény rögzítésre kerül.\n\nA topok bekerülnek a versenyzők személyes statisztikájába is: megmászás, pont és aktív nap jár értük. Vendégekért nem.",
  "comp.closeConfirmChallenge": "Lezárod a(z) \"{name}\" kihívást? A végeredmény rögzítésre kerül.",
  "comp.closeConfirmExternal": "Lezárod a(z) \"{name}\" külsős versenyt?",
  "comp.closeWithRoutesBody": "Lezárod a(z) \"{name}\" versenyt? A végeredmény rögzítésre kerül.\n\nA topok bekerülnek a versenyzők személyes statisztikájába is: megmászás, pont és aktív nap jár értük. Vendégekért nem.\n\nA versenyhez {count} út van hozzárendelve. Ezek az utak lezárás után újra megjelennek a térképen — szeretnéd most egyszerre archiválni őket?",
  "comp.closeWithArchive": "Lezárás + archiválás",
  "comp.closeOnly": "Csak lezárás",
  "toast.compClosedAndArchived": "Verseny lezárva, {count} út archiválva",
  "comp.alreadyActiveExists": "Már fut egy aktív verseny. Biztosan elindítod mellette a(z) \"{name}\" versenyt is? Ezzel két verseny fog egyszerre futni a teremben.",
  "comp.notCompDay": "Session csak a verseny napjain indítható",
  "comp.sessionControl": "Session vezérlés",
  "comp.lockAttempts": "Rögzítés zárása",
  "comp.unlockAttempts": "Rögzítés megnyitása",
  "comp.lockAttemptsHint": "A próbák rögzítésének zárása — bírók és versenyzők nem rögzíthetnek új próbát (admin/szervezői javítás továbbra is lehetséges).",
  "comp.unlockAttemptsHint": "A próbák rögzítésének megnyitása.",
  "comp.attemptsLockedBanner": "A próbák rögzítése zárva van ehhez a versenyhez.",
  "comp.attemptsLockedToast": "A próbák rögzítése zárva van.",
  "comp.sessionStart": "Indítás",
  "comp.sessionStop": "Leállítás",
  "comp.sessionPause": "Szünet",
  "comp.sessionResume": "Folytatás",
  "comp.sessionFinish": "Befejezés",
  "comp.sessionRestart": "Újraindítás",
  "comp.sessionRunning": "Fut",
  "comp.sessionPaused": "Szünetel",
  "comp.sessionScheduled": "Tervezett",
  "comp.sessionFinished": "Befejezett",
  "comp.sessionStartTime": "Kezdés: {time}",
  "comp.sessionDuration": "{minutes} perc",
  "comp.sessionParticipants": "{count} résztvevő",
  "comp.sessionAutoStopped": "A session automatikusan lezárult",
  "comp.sessionCantStart": "Egyszerre csak egy session futhat — előbb fejezd be a jelenlegit",
  "comp.sessionAdjustRemaining": "Hátralévő idő módosítása",

  // Competition editor
  "comp.editor.title": "Verseny szerkesztése",
  "comp.editor.titleNew": "Új verseny létrehozása",
  "comp.editor.tabRoutes": "Útvonalak",
  "comp.editor.tabRoutes.short": "Utak",
  "comp.editor.tabGroups": "Csoportok",
  "comp.editor.tabGroups.short": "Csop.",
  "comp.editor.tabSessions": "Sessionök",
  "comp.editor.tabSessions.short": "Sess.",
  "comp.editor.tabSettings": "Beállítások",
  "comp.editor.tabSettings.short": "Beáll.",
  "comp.editor.tabJudges": "Bírók",
  "comp.editor.tabJudges.short": "Bírók",
  "comp.editor.tabParticipants": "Résztvevők",
  "comp.editor.tabParticipants.short": "Részt.",
  "comp.editor.tabEntryFees": "Nevezési díjak",
  "comp.editor.tabEntryFees.short": "Díjak",
  "comp.editor.name": "Verseny neve",
  "comp.editor.description": "Rövid leírás",
  "comp.editor.descriptionHint": "Egy-két mondat — ez látszik fixen a kártyákon és a nevezésnél",
  "comp.editor.longDescription": "Részletes leírás",
  "comp.editor.longDescriptionHint": "A teljes kiírás — a kártyákon és a nevezési oldalon alapból összecsukva jelenik meg",
  "comp.editor.rules": "Szabályzat",
  "comp.editor.rulesHint": "A nevezésnél jelenik meg, a versenyző elfogadja",
  "localizedText.label": "Szöveg nyelve",
  "localizedText.base": "alap",
  "localizedText.filled": "Van szöveg ezen a nyelven",
  "localizedText.empty": "Még nincs szöveg ezen a nyelven",
  "localizedText.hintBase": "A terem alapnyelve. Ha egy nyelven üres egy mező, a néző ezt a szöveget látja.",
  "localizedText.hintTranslation.hu": "Fordítás. Amit üresen hagysz, az a nézőnek magyarul jelenik meg.",
  "localizedText.hintTranslation.en": "Fordítás. Amit üresen hagysz, az a nézőnek angolul jelenik meg.",
  "localizedText.fallback.hu": "Üresen hagyva a magyar szöveg jelenik meg.",
  "localizedText.fallback.en": "Üresen hagyva az angol szöveg jelenik meg.",
  "comp.editor.type": "Típus",
  "comp.editor.startDate": "Kezdés dátuma",
  "comp.editor.endDate": "Befejezés dátuma",
  "comp.editor.nameRequired": "Add meg a verseny nevét",
  "comp.editor.groupNameRequired": "Add meg minden csoport nevét",
  "comp.editor.startNumbersBackfilled": "{count} korábbi nevezőnek osztottunk rajtszámot",
  "comp.editor.startNumbersBackfillFailed": "A korábbi nevezők rajtszámának kiosztása nem sikerült",
  "comp.editor.invalidDateRange": "Érvényes kezdő- és záródátum szükséges (ÉÉÉÉ-HH-NN)",
  "comp.editor.endBeforeStart": "A záródátum nem lehet korábbi a kezdő dátumnál",
  "comp.editor.coverImage": "Borítókép",
  "comp.editor.coverHint": "Ajánlott: 1200×400 px · Max 5 MB · JPG, PNG, WebP",
  "comp.editor.externalUrl": "Külső link",
  "comp.editor.resultsUrl": "Eredmények link",
  "comp.editor.routeCount": "{count} út kiválasztva",
  "comp.editor.problemCount": "{count} probléma kiválasztva",
  "comp.editor.source": "Forrás",
  "comp.editor.sourceRoutes": "Utak",
  "comp.editor.sourceSpray": "Spray",
  "comp.editor.sourceSprayHint": "Spray versenyen csak benchmark problémák választhatók. A pont a probléma Font-fokozatához tartozó nehézségi szint pontja; mentéskor rögzül.",
  "comp.editor.sourceSwitchConfirm": "A forrás váltása törli a kiválasztott utakat és pontjaikat.",
  "comp.editor.sprayScoringForced": "Spray versenyen a pontozás Classic Redpoint.",
  "comp.editor.sprayNoBand": "sáv nélkül",
  "comp.editor.sprayNoFinals": "Spray versenyen nincs döntő — töröld a döntő sessiont a mentés előtt.",
  "comp.editor.sprayNoBenchmarks": "Nincs benchmark probléma a Spraywallon. A moderátor jelölheti meg a benchmarkokat.",
  "comp.editor.noGroupsForRoutes": "Hozz l\u00e9tre csoportokat az utak hozz\u00e1rendel\u00e9s\u00e9hez",
  "comp.editor.multiGroupHint": "Ctrl / \u2318 / Shift + kattint\u00e1s: t\u00f6bb csoport egyszerre szerkeszthet\u0151",
  "comp.editor.selectAll": "Mind kijelöl",
  "comp.editor.deselectAll": "Mind töröl",
  "comp.editor.bulkAddLabel": "Új út:",
  "comp.editor.bulkAddRoutes": "+ létrehozás",
  "comp.editor.bulkAddHint": "Üres utak létrehozása (nehézség és fogásszín nélkül), és azonnali hozzárendelésük a kiválasztott csoport(ok)hoz. A név sorszámozott — a kezdő sorszám, az előtag és az utótag is megadható. A térképen később áthelyezhetők és beállíthatók.",
  "comp.editor.bulkAdvanced": "Speciális generálás",
  "comp.editor.bulkPrefix": "Előtag",
  "comp.editor.bulkStart": "Kezdő sorszám",
  "comp.editor.bulkCount": "Darab",
  "comp.editor.bulkSuffix": "Utótag",
  "comp.editor.bulkPrefixPlaceholder": "pl. A",
  "comp.editor.bulkSuffixPlaceholder": "pl. -F",
  "comp.editor.bulkPreview": "Így fognak hívni",
  "comp.editor.groupName": "Csoport neve",
  "comp.editor.groupMode": "Mód",
  "comp.editor.groupColor": "Szín",
  "comp.editor.sessionName": "Session neve",
  "comp.editor.sessionStart": "Kezdés",
  "comp.editor.sessionDuration": "Időtartam (perc)",
  "comp.editor.durationUnit": "perc",
  "comp.editor.sessionMaxParticipants": "Max létszám",
  "comp.editor.sessionGroups": "Csoportok",
  "comp.editor.hasZones": "Zone rendszer",
  "comp.editor.scoringSystem": "Pontozási rendszer",
  "comp.editor.pointPool": "Pontpool (utanként)",
  "comp.editor.sectionScoring": "Pontozás",
  "comp.editor.sectionRegistration": "Nevezés",
  "comp.editor.countBest": "Legjobb utak száma",
  "comp.editor.countBestHint": "Hány legjobb megmászott út pontja számít az összesítésbe",
  "comp.editor.countBestSpray": "Legjobb problémák száma",
  "comp.editor.countBestHintSpray": "Hány legjobb megmászott probléma pontja számít az összesítésbe",
  "comp.editor.flashBonusHintSpray": "Extra pontok az első kísérletre megmászott problémákért (üres = nincs bónusz)",
  "challenge.editor.countAllSpray": "Összes probléma számít",
  "challenge.editor.countAllHintSpray": "Kikapcsolva csak a legjobb N probléma pontja számít.",
  "comp.editor.noGroupsForProblems": "Hozz létre csoportokat a problémák hozzárendeléséhez",
  "comp.editor.filterAllMaps": "Minden térkép",
  "comp.editor.filterAllWalls": "Minden fal",
  "comp.editor.filterAllLevels": "Minden szint",
  "comp.closeConfirmSpray": "Lezárod a(z) \"{name}\" versenyt? A végeredmény rögzítésre kerül.\n\nA topok bekerülnek a versenyzők Spraywall-naplójába: megmászás és aktív nap jár értük, pont nem. Vendégekért nem.",
  "comp.scorecard.problemName": "Probléma",
  "comp.editor.flashBonus": "Flash bónusz",
  "comp.editor.flashBonusHint": "Extra pontok az első kísérletre megmászott utakért (üres = nincs bónusz)",
  // ── Challenge (kihívás) ──
  "challenge.editor.countAll": "Összes út számít",
  "challenge.editor.countAllHint": "Kikapcsolva csak a legjobb N út pontja számít.",
  "challenge.editor.participation": "Részvétel",
  "challenge.editor.participationAuto": "Automatikus",
  "challenge.editor.participationOptIn": "Jelentkezéses",
  "challenge.editor.participationAutoHint": "Mindenki rajta van a táblán, aki mászik az ablakban (bármikor kiléphet).",
  "challenge.editor.participationOptInHint": "Csak az látszik, aki csatlakozott.",
  "challenge.editor.saved": "Mentve",
  "challenge.editor.saveFailed": "Mentés sikertelen",
  "challenge.editor.source": "Forrás",
  "challenge.editor.sourceRoutes": "Utak",
  "challenge.editor.sourceSpray": "Spray",
  "challenge.editor.sourceSprayHint": "Spray kihívásban csak benchmark problémák számítanak. A pont a probléma Font-fokozatához tartozó nehézségi szint pontja.",
  "challenge.editor.sourceSprayNoBands": "A spray forráshoz legalább egy nehézségi szintnek kell grade tartomány (Nehézségi szintek).",
  "challenge.editor.sourceSprayNoAddon": "A Spraywall kiegészítő nincs bekapcsolva — a tagok most nem tudnak spray-t naplózni.",
  "challenge.dash.sourceNote": "Csak benchmark spray problémák számítanak.",
  "challenge.unit.problems": "{n} probléma",
  "challenge.dash.climber": "Mászó",
  "challenge.dash.points": "Pont",
  "challenge.dash.empty": "Még senki nem szerzett pontot ebben az időszakban.",
  "challenge.dash.noRank": "helyezés nélkül",
  "challenge.dash.showAll": "Mind a(z) {count} mutatása",
  "challenge.dash.showLess": "Kevesebb",
  "challenge.dash.partLabel": "Részt veszek a versenyen",
  "challenge.dash.partHintOn": "A mászásaid pontot érnek ebben a versenyben.",
  "challenge.dash.partHintOff": "Kapcsold be, hogy a mászásaid pontot érjenek.",
  "challenge.exclude.label": "Kizárás",
  "challenge.exclude.normal": "Számít a táblán",
  "challenge.exclude.noRank": "Látszik, helyezés nélkül",
  "challenge.exclude.hidden": "Elrejtve a tábláról",
  "challenge.exclude.saveFailed": "Nem sikerült menteni a kizárást — próbáld újra.",
  "challenge.dash.excludedRoutes": "{count} út nem számít: {names}",
  "challenge.routes.help": "A kijelölt utak nem érnek pontot ebben a kihívásban.",
  "challenge.routes.count": "{count} út kizárva",
  "challenge.routes.save": "Kizárások mentése",
  "challenge.routes.saved": "Mentve, a rangsor újraszámolódik.",
  "challenge.routes.saveFailed": "Nem sikerült menteni a kizárásokat — próbáld újra.",
  "challenge.routes.closedConfirm": "A lezárt rangsor újraszámolódik, a helyezések és a pontok változhatnak.",
  "challenge.routes.archived": "archivált",
  "challenge.routes.archivedIncomplete": "Az archivált utakat nem sikerült teljesen betölteni, a lista hiányos lehet.",
  "challenge.routes.empty": "Nincs ilyen út.",
  "challenge.participants.hint": "A táblán szereplő mászók (az időablakból). Itt állíthatod, hogy ki ne kapjon helyezést, vagy egyáltalán ne látsszon a táblán.",
  "challenge.dash.excludedBanner": "Az admin kizárt ebből a kihívásból.",
  "challenge.dash.noRankBanner": "Látszol a táblán, de helyezést nem kapsz (az admin versenyen kívülre tett).",
  "comp.editor.fillPoints": "Pontok kitöltése",
  "comp.editor.fillPresetGym": "Terem pontok átvétele",
  "comp.editor.fillPresetLinear": "Lineáris (100–1000)",
  "comp.editor.fillPresetCustom": "Egyedi",
  "comp.editor.fillConfirm": "Felülírja a meglévő pontokat?",
  "comp.editor.maxAttempts": "Max próba (utanként)",
  "comp.editor.maxAttemptsHint": "Üres = korlátlan",
  "comp.editor.maxAttemptsPlaceholder": "Korlátlan",
  "comp.editor.ageRange": "Korosztály (-tól / -ig)",
  "comp.editor.ageMin": "-tól",
  "comp.editor.ageMax": "-ig",
  "comp.editor.ageRangeHint": "Üres = nincs korhatár. A korosztály a verseny évében betöltött kor szerint számít.",
  "comp.editor.groupDescription": "Kategória leírása",
  "comp.editor.groupDescriptionHint": "Bejelentkezés nélkül is olvasható: a nevezési oldalon és a kártyán jelenik meg. Ne írj bele személyes adatot.",
  "comp.editor.groupMaxDifficulty": "Legnehezebb szint",
  "comp.editor.groupMaxDifficultyNone": "Nincs felső határ",
  "comp.editor.groupMaxDifficultyHint": "Ajánlás, nem korlát. Nevezéskor ezt a csoportot ajánljuk annak, akinek a mászószintje eddig ér. Aki erősebb, ide is nevezhet, de a Résztvevők listán jelölést kap.",
  "comp.editor.groupMaxDifficultyDeleted": "Ez a nehézségi szint már nem létezik a teremben, ezért a csoportnak most nincs felső határa. Válassz másik szintet.",
  "comp.editor.groupMaxDifficultyDeletedOption": "(törölt szint)",
  "comp.editor.ageRangeInvalid": "A minimum nem lehet nagyobb a maximumnál",
  "comp.editor.announcements": "Hangjelzések",
  "comp.editor.warningMinutes": "Figyelmeztetés percei",
  "comp.editor.tts": "Szöveges bemondás (TTS)",
  "comp.editor.useStartNumbers": "Rajtszám rendszer",
  "comp.editor.showRegCounts": "Nevezésszám mutatása",
  "comp.editor.showRegCountsHint": "Kikapcsolva a nevezők nem látják, hányan vannak egy sessionben. A session létszámkerete, a „Megtelt” és a {n} alatti szabad hely ettől függetlenül mindig látszik.",
  "comp.editor.registrationStart": "Nevezés nyitása",
  "comp.editor.registrationDeadline": "Nevezés zárása",
  "comp.editor.addJudge": "Bíró hozzáadása",
  "comp.editor.removeJudge": "Bíró eltávolítása",
  "comp.editor.judgeSessions": "Sessionök",
  "comp.editor.noJudges": "Még nincs bíró hozzárendelve.",
  "comp.editor.removeOrganizer": "Szervező eltávolítása",
  "comp.editor.addParticipant": "Résztvevő hozzáadása",
  "comp.editor.removeParticipant": "Eltávolítás",
  "comp.editor.noParticipants": "Még nincs nevezett résztvevő.",
  "comp.editor.saved": "Mentve!",
  "comp.mode.jam": "JAM",
  "comp.mode.judged": "Felügyelt (Judged)",
  "comp.scoring.ifscClassic": "IFSC Classic",
  "comp.scoring.ifscClassicHint": "Rangsor: topok → zone-ok → legkevesebb próba. Top automatikusan zone-nak számít.",
  "comp.scoring.ifsc2024": "IFSC 2024",
  "comp.scoring.ifsc2024Hint": "Top = 25 pont, Zone = 10 pont, −0.1 próbálkozásonként. Csak a legmagasabb elért hold számít.",
  "comp.scoring.ifsc2024NoZoneHint": "Zone nélkül: Top = 25 pont, −0.1 próbálkozásonként. A zóna sem pontot, sem holtverseny-döntőt nem ad.",
  "comp.scoring.topsAndZones": "Topok + Zone-ok",
  "comp.scoring.topsAndZonesHint": "Pont = topok × 25 + zone-ok × 5. Holtverseny: kevesebb próbálkozás nyer.",
  "comp.scoring.points": "Pontelosztás",
  "comp.scoring.pointsHint": "Utankénti pontkeret egyenlően oszlik el a toppolók között.",
  "comp.scoring.classicRedpoint": "Classic Redpoint",
  "comp.scoring.classicRedpointHint": "Fix pontértékű utak, a legjobb N megmászás számít az összesítésbe.",

  // Competition user tab
  "comp.past": "Korábbi versenyek",
  "comp.register": "Nevezés",
  "comp.registering": "Nevezés folyamatban…",
  "comp.loadFailed": "A versenyek betöltése nem sikerült — úgy tűnik, elakadt a kapcsolat.",
  // A nevezések sorosítva mennek be (ez akadályozza a túlnevezést), ezért egy
  // rohamnál a sor végén állók tíz-húsz másodpercet is várhatnak.
  "comp.registerBusyHint": "Sokan neveznek egyszerre — a nevezésed sorban áll, kérlek várj.",
  "comp.acceptRules": "Elfogadom a verseny szabályzatát és feltételeit",
  "comp.unregister": "Nevezés visszavonása",
  "comp.selectGroup": "Válassz csoportot",
  "comp.selectSession": "Válassz sessiont",
  "comp.registrationClosed": "A nevezés lezárult",
  "comp.registrationOpens": "Nevezés nyílik: {date}",
  "comp.registrationDeadline": "Nevezés zárul: {date}",
  "comp.registrationNotYetOpen": "A nevezés még nem nyitott",

  // Public /register landing — the shareable link for posters and Facebook
  "compReg.notFound": "Ez a verseny nem található vagy még nincs meghirdetve",
  "compReg.feeRange": "{min} – {max} {currency}",
  "compReg.factDeadline": "Nevezés zárul",
  "compReg.factOpens": "Nevezés nyílik",
  "compReg.factEntered": "Eddig neveztek",
  "compReg.competitorCount": "{n} versenyző",
  "compReg.sessionFree": "{free} szabad hely",
  "compReg.ctaChange": "Nevezésem módosítása",
  "compReg.viewDashboard": "Élő eredmények",
  "compReg.hintNeedsAccount": "A nevezéshez Sendly-fiók kell — a gombra kattintva be tudsz lépni vagy fiókot nyitni, és utána egyből a nevezési űrlap nyílik meg.",
  "compReg.hintGuestAllowed": "Vendéget is nevezhetsz — olyasvalakit, akinek nincs Sendly-fiókja.",
  "compReg.hintRegistered": "A vendégeidet és a nevezési díj állását a verseny kártyáján találod a teremben.",
  "compReg.hintClosedRegistered": "A nevezésed rögzítve van. A határidő lejárt, így már nem módosítható — keresd a szervezőket, ha változtatnál.",
  "compReg.hintStaffRole": "Ehhez a versenyhez nem kell külön nevezned.",
  "compReg.hintOpensOn": "A nevezés {date}-kor nyílik meg.",
  "compReg.hintSignInEarly": "Lépj be vagy hozz létre fiókot már most, hogy nyitáskor egy kattintás legyen a nevezés.",
  "compReg.ctaSignIn": "Bejelentkezés vagy fiók létrehozása",
  "compReg.ctaSignInAndRegister": "Belépés és nevezés",
  "compReg.hintClosed": "A nevezési határidő lejárt. A helyszíni nevezésről a teremben tudnak felvilágosítást adni.",
  "compReg.alreadyRole.competitor": "Már neveztél erre a versenyre",
  "compReg.alreadyRole.judge": "Bíróként veszel részt ezen a versenyen",
  "compReg.alreadyRole.organizer": "Szervezőként veszel részt ezen a versenyen",
  // Public event sign-up landing (/gym/:slug/event/:id/register)
  "eventReg.notFound": "Ez az esemény nem található vagy még nincs meghirdetve",
  "eventReg.factDeadline": "Jelentkezés zárul",
  "eventReg.factOpens": "Jelentkezés nyílik",
  "eventReg.factSpots": "Helyek",
  "eventReg.ctaChange": "Jelentkezésem módosítása",
  "eventReg.ctaSignInAndRegister": "Belépés és jelentkezés",
  "eventReg.ctaFull": "Betelt",
  "eventReg.already.participant": "Már jelentkeztél erre az eseményre",
  "eventReg.already.waitlist": "Várólistán vagy",
  "eventReg.guestCount": "Jelentkeztetett vendégeid: {n}",
  "eventReg.hintCancelled": "Ez az esemény elmarad. A részletekről a szervező tud felvilágosítást adni.",
  "eventReg.hintEventClosed": "Ez az esemény már lezárult.",
  "eventReg.hintRegistered": "A vendégeidet és a regisztrációs díj állását az esemény kártyáján találod a teremben.",
  "eventReg.hintClosedRegistered": "A jelentkezésed rögzítve van. A határidő lejárt, így már nem módosítható — keresd a szervezőt, ha változtatnál.",
  "eventReg.hintWaitlisted": "Ha felszabadul egy hely, a várólista sorrendjében kerülsz be. Az esemény kártyáján a teremben látod, ha bejutottál.",
  "eventReg.hintNeedsAccount": "A jelentkezéshez Sendly-fiók kell — a gombra kattintva be tudsz lépni vagy fiókot nyitni, és utána egyből a jelentkezési űrlap nyílik meg.",
  "eventReg.hintGuestAllowed": "Vendéget is jelentkeztethetsz — olyasvalakit, akinek nincs Sendly-fiókja, például a gyerekedet.",
  "eventReg.hintWaitlist": "Minden hely betelt, de feliratkozhatsz a várólistára.",
  "eventReg.hintFull": "Minden hely betelt, és ennél az eseménynél nincs várólista.",
  "eventReg.hintOpensOn": "A jelentkezés nyitása: {date}.",
  "eventReg.hintSignInEarly": "Lépj be vagy hozz létre fiókot már most, hogy nyitáskor egy kattintás legyen a jelentkezés.",
  "eventReg.hintClosed": "A jelentkezési határidő lejárt. A részletekről a szervező vagy a terem tud felvilágosítást adni.",
  "eventReg.ageRange": "{min}–{max} évesek",
  "eventReg.ageMin": "{min} évestől",
  "eventReg.ageMax": "{max} évesig",
  "comp.rules": "Szabályzat",
  "comp.enter": "Belépés",
  "comp.viewResults": "Eredmények",
  "comp.externalLink": "Részletek (külső link)",
  "comp.resultsLink": "Eredmények",
  "comp.noActiveSession": "Nincs aktív session",

  // Registration flow — step accordion + missing-field feedback
  "comp.reg.step.group": "Csoport",
  "comp.reg.step.session": "Session",
  "comp.reg.step.groupHint": "Melyik kategóriában indulsz?",
  "comp.reg.step.groupHintOther": "Melyik kategóriában indul?",
  "comp.reg.step.sessionHint": "Mikor mászol?",
  "comp.reg.step.sessionHintOther": "Mikor mászik?",
  "comp.reg.step.billingHint": "Kinek a nevére állítsuk ki?",
  "comp.reg.step.billingOptionalHint": "Nem kötelező — a versenyző később maga is megadhatja",
  "comp.reg.step.rulesHint": "Olvasd el és fogadd el",
  "comp.reg.chip.required": "Kötelező",
  "comp.reg.chip.done": "Kész",
  "comp.reg.chip.missing": "Hiányzik",
  "comp.reg.chip.optional": "Nem kötelező",
  "comp.reg.missing": "Hiányzik: {field}",
  "comp.reg.jump": "Ugrás",
  "comp.reg.rulesAcceptedShort": "Elfogadva",
  "comp.reg.err.required": "Kötelező mező",
  "comp.reg.step.guest": "Vendég adatai",
  "comp.reg.step.guestHint": "Kit nevezel be?",
  "comp.reg.step.consent": "Hozzájárulás",
  "comp.reg.step.consentHint": "Nyilatkozat a vendég nevében",
  "comp.reg.consentGiven": "Megadva",
  "comp.reg.billingSharedHint": "Versenyenként egy számlázási adat — a vendégeidre is ez vonatkozik, nem kell külön megadni.",
  "comp.reg.billingGuestOwnHint": "A vendég a saját nevezési díjának fizetője — ezek az adatok az ő számlájára kerülnek.",

  // Nevezés elutasítva a szerveren (a form közben elavult: betelt a session, lejárt a határidő)
  "comp.reg.err.sessionFull": "Ez a session időközben betelt. Válassz másikat.",
  "comp.reg.err.notActive": "Erre a versenyre most nem lehet nevezni.",
  "comp.reg.err.closed": "A nevezést lezárták.",
  "comp.reg.err.notStarted": "A nevezés még nem nyílt meg.",
  "comp.reg.err.deadline": "A nevezési határidő lejárt.",
  // Torlódás, nem elutasítás. A második mondat azért kell, mert a kliens
  // lejárhat úgy is, hogy a szerver közben mégis rögzítette a nevezést.
  "comp.reg.err.busy": "Túl sokan neveznek egyszerre — próbáld újra egy pillanat múlva. Lehet, hogy a nevezésed közben beért: nézd meg a verseny kártyáját.",

  // Competition view (JAM)
  // Leadás előtt fel kell töltődnie minden offline mentésnek — utána a szerver már nem fogad be próbát
  "comp.view.countdown": "Hátralévő idő",
  "comp.view.routes": "Verseny útvonalak",
  "comp.view.timeline": "Idővonal",

  // Session timeline — "milyen sorrendben, hány próbával másztam"
  "comp.timeline.title": "Idővonal",
  "comp.timeline.sessionTitle": "A sávod idővonala",
  "comp.timeline.myTimeline": "Idővonalam",
  "comp.timeline.climber": "Mászó",
  "comp.timeline.me": "Én",
  "comp.timeline.noOtherClimbers": "Nincs más mászó, akit megnézhetnél",
  "comp.timeline.now": "most",
  "comp.timeline.chartAlt": "A session idővonala: mikor melyik útra mentél, hány próbával",
  "comp.timeline.axis.difficulty": "Nehézség",
  "comp.timeline.axis.points": "Pont",
  "comp.timeline.axis.pointsShort": "pont",
  "comp.timeline.axis.label": "Függőleges tengely",
  "comp.timeline.pill.routes": "út",
  "comp.timeline.pill.problems": "probléma",
  "comp.timeline.pill.attempts": "próba",
  "comp.timeline.pill.tops": "{count} top",
  "comp.timeline.pill.zones": "{count} zóna",
  "comp.timeline.pill.active": "aktív",
  "comp.timeline.legend.top": "Top",
  "comp.timeline.legend.zone": "Zóna",
  "comp.timeline.legend.none": "Nincs meg",
  "comp.timeline.legend.number": "szám = próbák",
  // Sorszámmal, mert a magyar sorszámnév ragozása („az 1.", „a 3.") a
  // névelőn múlik, azt viszont a szám alakja dönti el — ezért marad a
  // névelő nélküli forma, ami minden számra helyes
  "comp.timeline.row.topAt": "Top a(z) {n}. próbán",
  "comp.timeline.row.zone": "Zóna",
  "comp.timeline.row.attempts": "{count} próba",
  "comp.timeline.row.sendOfAttempts": "{count} próbából",
  "comp.timeline.row.notYet": "még nincs meg",
  "comp.timeline.row.flash": "flash",
  "comp.timeline.dur.min": "{n} perc",
  "comp.timeline.dur.hour": "{n} óra",
  "comp.timeline.dur.day": "{n} nap",
  // Ha az első és az utolsó mentés más napra esik, az nem az úton töltött
  // idő, hanem egy később visszanyitott pontlap
  "comp.timeline.row.laterEdit": "később kiegészítve",
  "comp.timeline.row.backfilled": "utólag rögzítve",
  "comp.timeline.row.noDifficulty": "nincs nehézség",
  "comp.timeline.row.pointsUnit": "p",
  "comp.timeline.row.send": "Megmászva",
  "comp.timeline.row.repeat": "Ismétlés",
  "comp.timeline.event.fall": "esés",
  "comp.timeline.event.zone": "zóna",
  "comp.timeline.event.top": "top",
  "comp.timeline.backfilledHint": "Az utólag rögzített eredménynek (Excel-import vagy admin szerkesztés) nincs valódi mászás-ideje, ezért nem kerül az idővonalra.",
  "comp.timeline.empty.notStarted": "A sávod még nem indult el.",
  "comp.timeline.empty.notStartedHint": "Indulás után itt látod időrendben, mikor melyik útra mentél, hány próbával.",
  "comp.timeline.empty.noAttempts": "Még nincs rögzített próba.",
  "comp.timeline.empty.noAttemptsHint": "Ahogy mented az eredményeidet, az utak itt sorban megjelennek.",
  "comp.timeline.empty.notEntered": "Nem indultál ezen a versenyen.",
  "comp.timeline.empty.notEnteredOther": "Ez a mászó nem indult ezen a versenyen.",
  "comp.timeline.day.title": "A nap idővonala",
  "comp.timeline.day.competition": "Verseny",
  "comp.timeline.day.noAttemptData": "A próbaszám csak ott szerepel, ahol megadtad; a többi mászásnál nincs adat — a sorrend és a nehézségi ív viszont teljes.",
  "comp.view.noRoutes": "Még nincsenek versenyutak",
  "comp.view.noRoutesHint": "Amint a szervező kijelöli a verseny útjait, itt jelennek meg — és a Térkép tabon is megtalálod majd őket.",
  // A szűrő nevét a térképről vesszük át ({filter}), hogy a két felirat ne csússzon szét
  "comp.view.routesOnMap": "Ezeket az utakat a Térkép tabon is megtalálod — a szűrők közt a 🏆 {filter} kapcsolóval csak ezek maradnak láthatók.",
  "comp.view.routesOnMapLater": "A verseny útjai a Térkép tabon is megjelennek, amint elindul a sessionöd.",

  // Classic Redpoint summary
  "comp.redpoint.total": "Összpontszám",
  "comp.redpoint.flashBonusTotal": "ebből {count}⚡ flash bónusz: +{points}",
  "comp.redpoint.notCounted": "nem beszámított",
  "comp.redpoint.notTopped": "nem megmászott",

  // Competition attempt modal
  "comp.attempt.zoneAttempts": "Zone próbák",
  "comp.attempt.zoneReached": "Zone elérve",
  "comp.attempt.topAttempts": "Top próbák",
  "comp.attempt.topped": "TOP",
  "comp.attempt.zone": "Zóna",
  "comp.attempt.top": "Top",
  "comp.attempt.attempts": "Próbák száma",
  "comp.attempt.fewer": "Eggyel kevesebb próba",
  "comp.attempt.more": "Eggyel több próba",
  "comp.attempt.reachedAtAttempt": "Elérte a {n}. próbán",
  "comp.attempt.notReached": "Nem érte el",
  "comp.attempt.maxLabel": "max",
  "comp.attempt.openDetail": "Részletek megnyitása",
  "comp.attempt.compPoints": "pont",
  "comp.attempt.flash": "⚡ Flash!",
  "comp.attempt.flashBonus": "+{n} flash bónusz",
  "comp.attempt.save": "Mentés",
  "comp.attempt.saveFailed": "A mentés nem sikerült — a sor a szerveren tárolt értéket mutatja. Ellenőrizd a kapcsolatot és próbáld újra.",
  "comp.attempt.notRecordedYet": "Még nincs rögzítve",
  "comp.attempt.triedNotReached": "{n} próba — még nincs meg",
  "comp.attempt.topImpliesZone": "A top automatikusan a zónát is beszámítja",
  "comp.attempt.offlineNote": "Offline vagy — a mentés sorba kerül, és magától feltöltődik.",
  "comp.attempt.saveOfflineSub": "Sorba kerül · feltöltődik, ha lesz net",
  "comp.attempt.readOnly.notStarted": "A sessionöd még nem indult el — csak megtekintheted.",
  "comp.attempt.readOnly.locked": "A szervező lezárta a próbák rögzítését.",
  "comp.attempt.readOnly.judged": "Ebben a csoportban a bíró rögzíti az eredményt.",
  "comp.attempt.readOnly.closed": "A verseny lezárult, az eredmények véglegesek.",
  "comp.attempt.readOnly.notRegistered": "Nem vagy nevezve erre a versenyre — csak megtekintheted.",
  "comp.attempt.pending": "Függőben",
  "comp.attempt.savedToast": "{route} — mentve",
  "comp.attempt.queuedToast": "{route} — sorba került, feltöltődik",
  "comp.attempt.undo": "Visszavonás",
  "comp.attempt.competitor": "Versenyző",
  "comp.attempt.registeredBy": "Rögzítette",

  // Competition judge
  "comp.judge.title": "Bíró mód",
  "comp.judge.selectClimber": "Versenyző kiválasztása",
  "comp.judge.searchClimber": "Keresés név vagy rajtszám alapján...",
  "comp.judge.eventFall": "Esés",
  "comp.judge.eventZone": "Zóna",
  "comp.judge.eventTop": "Top",
  "comp.judge.currentState": "Eddig",
  "comp.judge.attemptsCount": "{n} próba",
  "comp.judge.zoneStatus": "Zóna",
  "comp.judge.topStatus": "Top",
  "comp.judge.zoneAtAttempt": "{n}. próba",
  "comp.judge.notReached": "nincs",
  "comp.judge.myEventsRecent": "Saját események (30 mp)",
  "comp.judge.undo": "Visszavonás",
  "comp.judge.recordError": "Esemény rögzítése sikertelen",
  "comp.judge.undoError": "Visszavonás sikertelen",
  "comp.judge.maxAttemptsReached": "Elérted a max próbaszámot",
  "comp.judge.backToCompetitors": "Vissza",
  "comp.judge.maxAttemptsLabel": "Max {n} próba",
  "comp.judge.noAssignedSessions": "Nincs hozzád rendelve bírált session. Kérd meg a verseny adminját, hogy a Bírók fülön válasszon ki legalább egy sessiont neked.",
  "comp.judge.noCompetitorsInSession": "Nincs versenyző a hozzád rendelt bírált csoportokban.",
  "comp.judge.noSearchResults": "Nincs találat a keresésre.",
  "comp.judge.offline": "Offline",
  "comp.judge.pendingSync": "{n} esemény vár a szinkronra",
  "comp.judge.syncing": "{n} esemény szinkronizálódik…",
  "comp.judge.resync": "Újrapróbálkozás",
  "comp.judge.pendingTooltip": "Az eseményeid biztonságban vannak az eszközödön és automatikusan elküldjük, amint visszajön a kapcsolat.",

  // Competition leaderboard
  "comp.leaderboard.title": "Rangsor",
  "comp.leaderboard.rank": "Hely",
  "comp.leaderboard.name": "Név",
  "comp.leaderboard.startNumber": "#",
  "comp.leaderboard.tops": "Top",
  "comp.leaderboard.zones": "Zone",
  "comp.leaderboard.top": "Top",
  "comp.leaderboard.zone": "Zóna",
  "comp.competitor.noRoutes": "Ehhez a csoporthoz nincs út hozzárendelve.",
  "comp.dashboard.viewCompetitorDetail": "Utankénti bontás megjelenítése",
  "comp.scorecard.topZoneAtt": "T / z",
  "comp.scorecard.attempts": "Próbák",
  "comp.leaderboard.attempts": "Próba",
  "comp.leaderboard.score": "Pont",
  "comp.leaderboard.empty": "Még nincs eredmény.",

  // Competition countdown
  "comp.countdown.warning": "Még {minutes} perc!",
  "comp.countdown.lastSeconds": "Utolsó {seconds} másodperc!",
  "comp.countdown.ended": "VÉGE!",

  // Competition dashboard
  "comp.dashboard.live": "ÉLŐ",
  "comp.dashboard.groupLabel": "Csoport:",
  "comp.dashboard.draftBanner": "Vázlat — ez a verseny még nincs meghirdetve. Az előnézetet csak a verseny szervezői látják; mások számára az oldal nem található.",
  "comp.dashboard.finalsCutoff": "Döntő — {n} továbbjut",
  "comp.dashboard.viewLabel": "Nézet:",
  "comp.dashboard.viewList": "Ranglista",
  "comp.dashboard.viewMatrix": "Ponttáblázat",
  "comp.matrix.flash": "Flash",
  "comp.matrix.top": "Top",
  "comp.matrix.zone": "Zóna",
  "comp.matrix.attemptsHint": "A számok = próbálkozások",
  "comp.matrix.attemptsWord": "próbálkozás",
  "common.previous": "Előző",
  "common.next": "Következő",

  // Competition TV dashboard
  "comp.tv.enableAudio": "Hang engedélyezése",

  // Competition export
  "comp.export.csv": "Eredmények (CSV)",
  "comp.export.pdf": "Eredmények (PDF)",

  // Competition QR
  "comp.qr.generate": "QR kód",
  "comp.deactivate": "Deaktiválás",
  "comp.deactivateConfirm": "Deaktiválod a versenyt? Visszakerül vázlat állapotba.",
  "comp.changeRegistration": "Módosítás",
  "comp.friends.label": "Barátaid:",
  "comp.updateRegistration": "Nevezés módosítása",
  "comp.sessionFull": "Megtelt",
  "comp.details": "Részletek",
  "comp.overview": "Áttekintés",
  "comp.alreadyCompetitor": "Már versenyzőként nevezve",
  // Judges and organizers sign up for a ROLE, they don't enter the competition,
  // so these two deliberately keep "regisztrálva" after the entry-wording rename.
  "comp.alreadyJudge": "Már bíróként regisztrálva",
  "comp.alreadyOrganizer": "Már szervezőként regisztrálva",
  "comp.editor.tabOrganizers": "Szervezők",
  "comp.editor.tabOrganizers.short": "Szerv.",
  "comp.editor.addOrganizer": "Szervező hozzáadása",
  "comp.editor.noOrganizers": "Még nincs szervező hozzárendelve.",
  "comp.editor.deleteSessionWithRegs": "Ehhez a session-höz {count} versenyző van hozzárendelve. Törlés után a session hozzárendelés törlődik náluk. Biztosan törlöd?",
  "comp.editor.deleteSessionConfirm": "Biztosan törlöd ezt a session-t?",
  "comp.editor.deleteGroupWithRegs": "Ehhez a csoporthoz {count} versenyző van hozzárendelve. Törlés után a csoport hozzárendelés törlődik náluk. Biztosan törlöd?",
  "comp.editor.deleteGroupConfirm": "Biztosan törlöd ezt a csoportot?",
  "comp.closeEditor": "Bezárás",
  "comp.openDashboard": "Dashboard",
  // Card section headers & actions
  "comp.card.regSection": "Nevezés",
  // Label of the filled header bar when the user has an entry or a guest here.
  "comp.card.regState.mine": "✓ Nevezve",
  "comp.card.regState.guestOnly": "✓ Vendéget neveztél",
  // Right end of the bar: who the entry covers. Alone it is the group · session,
  // with guests a head count, and for a single guest the name itself.
  "comp.card.regWho.mePlusOne": "Te + {name}",
  "comp.card.regWho.mePlusN": "Te + {n} vendég",
  "comp.card.regWho.guests": "{n} vendég",
  "comp.regRowActions": "{name} nevezésének műveletei",
  "comp.card.kicker.competition": "Verseny",
  "comp.card.kicker.challenge": "Kihívás",
  "comp.card.kicker.external": "Külsős verseny",
  "comp.card.kicker.series": "Sorozat",
  "comp.card.organizerBar": "Szervező",
  "comp.card.expand": "Kártya kinyitása",
  "comp.card.collapse": "Kártya összecsukása",
  "comp.card.row.when": "Mikor",
  "comp.card.row.registration": "Nevezés",
  "comp.card.row.you": "Te",
  "comp.card.row.friends": "Ismerősök",
  "comp.card.row.entrants": "Nevezők",
  "comp.card.row.field": "Mezőny",
  "comp.card.row.rounds": "Fordulók",
  "comp.card.row.recording": "Rögzítés",
  "comp.card.row.createdBy": "Készítette",
  "comp.card.reg.until": "{date}-ig",
  "comp.card.reg.opensAt": "{date}-tól",
  "comp.card.reg.untilStart": "a kezdés napjáig",
  "comp.card.reg.atOrganizer": "A rendező oldalán",
  "comp.card.reg.guestHint": "Vendéget is nevezhetsz ({n}/{max})",
  "comp.card.recording.open": "Nyitva",
  "comp.card.recording.locked": "Zárva",
  "comp.card.groupSummary.jam": "{n} JAM",
  "comp.card.groupSummary.judged": "{n} bírós",
  "comp.card.sessionsCount": "{n} futam",
  "comp.card.noSessionsYet": "futam még nincs",
  "comp.card.participantCount": "{n} résztvevő",
  "comp.card.expander.age": "Korosztály",
  "comp.card.expander.attempts": "Próbák",
  "comp.card.expander.mode": "Mód",
  "comp.card.expander.maxDifficulty": "Legnehezebb szint",
  "comp.card.expander.noAgeLimit": "nincs korlát",
  "comp.card.expander.unlimited": "korlátlan",
  "comp.card.expander.open": "{name} részletei",
  "comp.control": "Vezérlés",
  "comp.manage": "Szerkesztés",
  "comp.registerOwn": "+ Saját nevezés",
  "comp.unregisterShort": "Nevezés visszavonása",
  "comp.role.judge": "Bíró",
  "comp.role.organizer": "Szervező",
  "comp.role.judgeSessions": "Session: {sessions}",
  "comp.feeStatus.paid": "{paid} ✓ kifizetve",
  "comp.feeStatus.partial": "{paid} / {total}",
  "comp.feeStatus.unpaid": "{amount} — fizetésre vár",
  "comp.unregister.paidBlock": "Nem vonhatod vissza a nevezést, mert van befizetett összeg. Kérjük, keresd a szervezőket!",
  "comp.entryFees.filterAll": "Összes",
  "comp.entryFees.filterUnpaid": "Nem fizetve",
  "comp.entryFees.filterPartial": "Részben",
  "comp.entryFees.filterPaid": "Fizetve",
  "comp.entryFees.totalExpected": "Várható",
  "comp.entryFees.totalPaid": "Befizetett",
  "comp.entryFees.outstanding": "Hátralék",
  "comp.entryFees.noEntries": "Nincsenek fizetési tételek",
  "comp.entryFees.searchPlaceholder": "Keresés név, email, csoport szerint",
  "comp.entryFees.searchNoMatch": "Nincs találat",
  "comp.entryFees.methodLabel": "Fizetés módja",
  "comp.entryFees.methodNone": "— mód",
  "comp.entryFees.method.card": "Bankkártya",
  "comp.entryFees.method.transfer": "Utalás",
  "comp.entryFees.method.cash": "Készpénz",
  "comp.entryFees.unregisteredParent": "Csak vendégek",
  "comp.guest.addBtn": "+ Vendég nevezése",
  "comp.guest.addBtnCounter": "+ Vendég nevezése ({n}/{max})",
  "common.more": "Egyéb",
  "comp.menu.printable": "Nyomtatható",
  "comp.menu.export": "Export",
  "comp.menu.other": "Eszközök",
  "common.qrCode": "QR kód",
  "comp.overview.competitors": "versenyző",
  "comp.overview.judges": "bíró",
  "comp.overview.groups": "csoport",
  "comp.overview.sessions": "session",
  "comp.overview.unassigned": "Beosztás nélkül",
  "comp.overview.headcount": "Létszám",
  "comp.qr.download": "QR kód letöltés",
  "comp.qr.copyLink": "Link másolása",
  "comp.qr.linkCopied": "Link a vágólapra másolva",
  "comp.qr.linkCopyFailed": "Nem sikerült a vágólapra másolni — jelöld ki a linket kézzel.",
  "comp.qr.targetLabel": "Mire mutasson",
  "comp.qr.targetRegister": "Nevezés",
  "comp.qr.targetDashboard": "Élő eredmények",
  "comp.copyRegLink": "Nevezési link másolása",
  "comp.editAttempts": "Próbák szerkesztése",

  // Entry fee
  "comp.entryFee.label": "Nevezési díj",
  "comp.entryFee.enabled": "Van nevezési díj",
  "comp.entryFee.amount": "Összeg",
  "comp.entryFee.currency": "Pénznem",
  "comp.entryFee.note": "Megjegyzés",
  "comp.entryFee.notePlaceholder": "pl. Helyszínen készpénzzel fizetendő",
  "comp.entryFee.paid": "Fizetve",
  "comp.entryFee.overviewBadge": "{paid}/{total} fizetve",
  "comp.entryFee.unpaidWarning": "A nevezési díj nincs befizetve. Az eredményeid nem jelennek meg a rangsorban a fizetésig.",
  "comp.entryFee.unpaidBadge": "Nem fizetve",
  "comp.entryFee.groupAmount": "Nevezési díj (csoport)",
  "comp.entryFee.groupAmountHint": "Üresen hagyva: {amount} {currency} (verseny alapdíj)",

  // Billing
  "settings.billingInfo": "Számlázási adatok",
  "billing.individual": "Magánszemély",
  "billing.company": "Cég",
  "billing.namePlaceholder.individual": "Teljes név",
  "billing.namePlaceholder.company": "Cégnév",
  "billing.taxNumber": "Adószám",
  "billing.zip": "Irányítószám",
  "billing.city": "Város",
  "billing.address": "Utca, házszám",
  "billing.country": "Ország",
  "billing.saved": "Mentve!",
  "billing.saveToProfile": "Mentés a profilomba",
  "billing.saveToProfileHint": "Legközelebb már kitöltve várnak ezek az adatok.",
  "billing.err.name": "Add meg a számlázási nevet",
  "billing.err.companyName": "Add meg a cégnevet",
  "billing.err.taxNumber": "Add meg az adószámot",
  "billing.editSection": "Számlázási adatok",
  "billing.vatId": "EU adószám (VAT)",
  "billing.vatIdPlaceholder": "HU12345678",
  "billing.contactName": "Kapcsolattartó neve",
  "billing.invoiceEmail": "Számlázási email",
  "billing.companyName": "Cég vagy egyéni vállalkozó neve",
  "billing.gymSectionTitle": "Számlázási adatok",
  "billing.gymSectionHint": "Ezekre az adatokra állítjuk ki a negyedéves számlát. A platform üzemeltetője negyedévente küld összesítőt és számlát.",
  "billing.save": "Számlázási adatok mentése",
  "billing.savedToast": "Számlázási adatok mentve.",
  "billing.required": "A cégnév és adószám kötelező a számlázáshoz.",
  "billing.complete": "Kitöltve",
  "billing.incomplete": "Hiányzik",
  "billing.invoiceCurrencyNotice": "💱 A számlát ebben a pénznemben fogod kapni: {currency} (változtatás fent, a Pénznem választónál).",
  "billing.invoiceCurrencyNoticeLocked": "💱 A számlát ebben a pénznemben fogod kapni: {currency}. A pénznemet a platform üzemeltetője rögzítette — módosításhoz vedd fel velünk a kapcsolatot.",
  "billing.currencyLockedNotice": "A pénznemet a platform üzemeltetője rögzítette.",
  "billing.currencyNoCapNotice": "Nincs jogosultságod a pénznem módosításához.",
  "billing.vatIdRequiredEu": "EU-s székhelyű cégnél az EU adószám szükséges a fordított adózáshoz. Amíg nincs megadva, {rate}% áfát számítunk fel.",
  // Dynamic keys: billing.vatStatusName.{domestic|reverse_charge|out_of_scope|eu_missing_vat_id}
  "billing.vatStatusName.domestic": "áfás ({rate}% áfa)",
  "billing.vatStatusName.reverse_charge": "fordított adózás (0% áfa)",
  "billing.vatStatusName.out_of_scope": "áfa hatályán kívül (0% áfa)",
  "billing.vatStatusName.eu_missing_vat_id": "EU adószám hiányzik — {rate}% áfa",
  "comp.billing.guestSummary": "Vendégeid: {count} fő — az ő díjukat is fizeted.",
  "comp.billing.exportExcel": "Számlázási lista (Excel)",
  "comp.billing.pdfTitle": "Számlázási lista",
  "comp.billing.pdfTotal": "Összesen",
  "comp.billing.pdfCompetitor": "Versenyző",
  "comp.billing.pdfBillingName": "Számlázási név",
  "comp.billing.pdfAddress": "Cím",
  "comp.billing.pdfTaxNumber": "Adószám",
  "comp.billing.pdfCount": "Fő",
  "comp.billing.xlsExpected": "Fizetendő",
  "comp.billing.xlsPaid": "Befizetve",
  "comp.billing.xlsPaidFlag": "Fizetve (X)",
  "comp.billing.xlsOutstanding": "Hátralék",
  "comp.billing.xlsSummary": "--- Összesítés ---",
  "comp.billing.xlsPayingUsers": "Fizető felhasználók",
  "comp.billing.xlsFullyPaid": "Teljesített fizetések",
  "comp.entryFee.paidAmountPrompt": "Befizetett összeg ({currency}):",

  // Rendező elérhetősége (organizerContact) — verseny, sorozat és esemény közösen.
  // NEM a „Szervező" szerep (az gym-tag írási joggal): ez kapcsolattartási adat.
  "organizerContact.title": "Rendező elérhetősége",
  "organizerContact.name": "Név",
  "organizerContact.email": "Email",
  "organizerContact.phone": "Telefon",
  "organizerContact.gymFallback": "A terem elérhetősége",
  "organizerContact.publicHint": "Bejelentkezés nélkül is látható.",
  "organizerContact.fallbackPreview": "Kitöltés nélkül a terem elérhetősége látszik:",
  "organizerContact.noGymContact": "A teremnek sincs megadva email címe és telefonszáma, így a nevezők nem találnak elérhetőséget. Add meg a rendezőt, vagy töltsd ki a terem elérhetőségét a terem adatainál.",

  // Guest competitors
  "comp.settings.allowGuests": "Vendég versenyzők",
  "comp.settings.allowGuestsHint": "Fiók nélküli versenyzők nevezése (pl. gyerekverseny)",
  "comp.settings.guestMode.off": "Kikapcsolva",
  "comp.settings.guestMode.organizer": "Csak szervező",
  "comp.settings.guestMode.anyone": "Bárki",
  "comp.settings.guestMode.offHint": "Nincsenek vendég versenyzők.",
  "comp.settings.guestMode.organizerHint": "Csak te és a szervezők vehettek fel vendéget a Résztvevők fülön. A versenyzők nem látnak vendég gombot.",
  // The number itself lives in the field below, not here — one place on screen.
  "comp.settings.guestMode.anyoneHint": "A versenyzők is nevezhetnek vendéget, bírált csoportba.",
  "comp.settings.proxyGuestLimit": "Egy fő hány vendéget nevezhet",
  "comp.settings.proxyGuestLimitHint": "Mindenkire vonatkozik — rád és a szervezőkre is. Ha ennél több vendég kell, a Résztvevők fülön korlátlanul nevezhettek. ({min}–{max})",
  "comp.guest.addTitle": "Vendég versenyző hozzáadása",
  "comp.guest.name": "Versenyző neve",
  "comp.guest.namePlaceholder": "Név",
  "comp.guest.birthYear": "Születési év",
  "comp.guest.birthYearPlaceholder": "pl. 2015",
  "comp.guest.email": "E-mail cím",
  "comp.guest.emailPlaceholder": "pl. anya@example.com",
  "comp.guest.emailHint": "Nem kötelező. Ide megy az értesítés és a számla — vendégnél gyakran a szülő címe.",
  "comp.guest.emailInvalid": "Érvénytelen e-mail cím",
  "comp.age.tooYoung": "Túl fiatal ehhez a korosztályhoz",
  "comp.age.tooOld": "Túl idős ehhez a korosztályhoz",
  "comp.level.recommended": "Ajánlott",
  "comp.level.yours": "A mászószinted ebben a teremben: {level}",
  "comp.level.above": "A mászószinted ({level}) e csoport felső határa ({cap}) fölött van. Ide is nevezhetsz, de a szervezők látni fogják.",
  "comp.level.aboveOther": "A mászó szintje ({level}) e csoport felső határa ({cap}) fölött van. Nevezhető ide, de a Résztvevők listán jelölést kap.",
  "comp.level.theirs": "A mászó szintje ebben a teremben: {level}",
  "comp.level.approx": "kb. {level}",
  "comp.level.yoursGlobal": "A mászószinted más termekben mért szinted alapján: {level}",
  "comp.level.theirsGlobal": "A mászó szintje más termekben mért szintje alapján: {level}",
  "comp.level.theirsNone": "A mászónak még nincs mászószintje: ebben a teremben kevesebb mint {min} első megmászása van, és más termekből sem számolható.",
  "comp.age.birthYearRequired": "Ehhez a korosztályhoz kötelező megadni a születési évet",
  "comp.age.birthYearMissingHint": "Add meg a születési évedet a beállításokban a korosztályos nevezéshez",
  "comp.age.birthYearMissingOther": "A versenyzőnek nincs megadva születési éve — korosztályos csoportba így nem nevezhető",
  "comp.guest.club": "Egyesület / csapat",
  "comp.guest.clubPlaceholder": "Egyesület neve",
  "comp.guest.notes": "Megjegyzés",
  "comp.guest.notesPlaceholder": "Belső megjegyzés (csak szervezők látják)",
  "comp.guest.add": "Hozzáadás",
  "comp.guest.addAndNext": "Hozzáadás és még egy",
  "comp.guest.added": "{name} hozzáadva",
  "comp.guest.addedCount": "{count} vendég hozzáadva ebben a körben",
  "comp.guest.onlyJudged": "Vendég versenyzők csak bírált csoportokba nevezhetők.",
  "comp.guest.noJudgedGroups": "Nincs bírált csoport. Hozz létre egy bírált csoportot a vendég versenyzők nevezéséhez.",
  "comp.guest.noGroups": "Nincs csoport. Hozz létre legalább egy csoportot a vendég versenyzők nevezéséhez.",
  "comp.guest.jamGroupHint": "JAM csoport: a vendég nem tudja magának rögzíteni az eredményét — a próbáit a „Próbák szerkesztése” felületen te viszed be.",
  "comp.guest.proxyTitle": "Vendég nevezése",
  "comp.guest.proxyButton": "Vendég nevezése",
  "comp.guest.badge": "Vendég",
  "comp.guest.deleteConfirm": "Biztosan törölni szeretnéd {name} nevezését?",
  "comp.guest.editTitle": "Vendég szerkesztése",
  "comp.guest.consent": "Kijelentem, hogy a vendég (vagy törvényes képviselője) hozzájárult a nevezéshez",
  "comp.guest.proxyLimit": "Elérted a maximum {max} vendég nevezési limitet.",
  "comp.participants.addGuest": "+ Vendég hozzáadása",
  "comp.participants.addUserTitle": "Versenyző nevezése",
  "comp.participants.noEmail": "Nincs e-mail cím",
  "comp.participants.noGroups": "Nincs csoport. Hozz létre legalább egy csoportot a nevezéshez.",
  "comp.participants.ageCheckedHint": "Korosztályos csoport — a rendszer a versenyző születési éve alapján ellenőrzi a nevezést.",
  "comp.participants.deleteConfirm": "Biztosan törölni szeretnéd {name} nevezését?",
  "comp.participants.searchPlaceholder": "Keresés név / email / rajtszám / klub szerint",
  "comp.participants.searchNoMatch": "Nincs találat erre a keresésre.",
  "comp.participants.excludedBadge": "kizárva",
  "comp.participants.excludeBtn": "Kizár",
  "comp.participants.excludedTitleOn": "Kizárva a hivatalos rangsorból — kattints a visszavonáshoz",
  "comp.participants.excludedTitleOff": "Versenyző kizárása a hivatalos rangsorból (pontok megmaradnak)",
  "comp.participants.levelAboveBadge": "szint felett",
  "comp.participants.levelAboveTitle": "Mászószint nevezéskor: {level} · a csoport felső határa: {cap}",
  "comp.participants.levelAboveTitleGlobal": "Becsült mászószint nevezéskor (más termek alapján): {level} · a csoport felső határa: {cap}",
  "comp.participants.levelAboveCount": "{count} szint felett",
  "comp.ranking.excludedNote": "Versenyen kívül induló — hivatalos rangsorba nem számít. A pontok szerinti helyezés zárójelben.",

  // Scorecard
  "comp.scorecard.btnLabel": "Verseny lapok (PDF)",
  "comp.scorecard.dialogTitle": "Verseny lapok nyomtatása",
  "comp.scorecard.layout": "Elrendezés",
  "comp.scorecard.layoutStandard": "Standard (1/lap)",
  "comp.scorecard.layoutCompact": "Kompakt (2/lap)",
  "comp.scorecard.sortBy": "Rendezés",
  "comp.scorecard.groupBy": "Csoportosítás",
  "comp.scorecard.groupByNone": "Nincs csoportosítás",
  "comp.scorecard.groupBySession": "Session",
  "comp.scorecard.groupByGroup": "Csoport",
  "comp.scorecard.groupBySessionGroup": "Session, azon belül csoport",
  "comp.scorecard.groupByGroupSession": "Csoport, azon belül session",
  "comp.scorecard.finalsSection": "Döntő",
  "comp.scorecard.sortByStartNumber": "Rajtszám",
  "comp.scorecard.sortByName": "Név",
  "comp.scorecard.filterGroup": "Csoport szűrő",
  "comp.scorecard.allGroups": "Mind",
  "comp.scorecard.generate": "Generálás",
  "comp.scorecard.zoneReached": "Zóna",
  "comp.scorecard.topped": "Top",
  "comp.scorecard.attemptMark": "Próba",
  "comp.scorecard.routeName": "Út",
  "comp.scorecard.compPointsCol": "Pont",
  "comp.scorecard.redpointFooter": "Legjobb {n} út számít",
  "comp.scorecard.redpointFlashFooter": "+ {n} bónusz flash-enként",
  "comp.scorecard.attemptCol": "{n}. próba",
  "comp.scorecard.tallyBoxesNote": "A sor végi kockákat ({boxes}) nem kell kitölteni — azokat az összesítéskor a számlálók töltik ki.",
  "comp.scorecard.mode": "Mit nyomtatunk",
  "comp.scorecard.modeAll": "Mindenki",
  "comp.scorecard.modeSelected": "Kijelöltek",
  "comp.scorecard.modeBlank": "Üres lapok",
  "comp.scorecard.selectedCount": "{n} kijelölve",
  "comp.scorecard.selectAll": "Mind kijelöl",
  "comp.scorecard.selectNone": "Kijelölés törlése",
  "comp.scorecard.searchCompetitor": "Keresés név vagy rajtszám szerint",
  "comp.scorecard.searchCompetitorEmail": "Keresés név, rajtszám vagy email szerint",
  "comp.scorecard.noCompetitors": "Nincs találat",
  "comp.scorecard.everyGroup": "Minden csoport",
  "comp.scorecard.blankPerGroup": "Lap csoportonként",
  "comp.scorecard.blankTotal": "Összesen {n} lap ({groups} csoport)",
  "comp.scorecard.blankHint": "a név helye üresen marad a lap tetején",
  "comp.scorecard.blankNoRoutes": "Egyetlen csoporthoz sincs út rendelve, így nincs mit nyomtatni.",
  "comp.scorecard.blankNameLabel": "Név",
  "comp.scorecard.nothingToPrint": "Ehhez a beállításhoz nincs nyomtatható versenylap.",

  // Action log
  "comp.actionLog.title": "Bírói műveletek",
  "comp.actionLog.btnLabel": "Műveletek napló",
  "comp.syncClimbs.btnLabel": "Mászások átvezetése a statisztikába",
  "comp.syncClimbs.running": "Mászások átvezetése folyamatban…",
  "comp.syncClimbs.done": "{count} mászás átvezetve a versenyzők statisztikájába.",
  "comp.syncClimbs.noCompetitors": "Ezen a versenyen csak vendégek indultak — nincs kinek statisztikát írni.",
  "comp.syncClimbs.failed": "Az átvezetés nem sikerült",
  "comp.actionLog.entryCount": "{n} bírói művelet",

  // Audit log
  "comp.audit.filterCompetitor": "Versenyző",
  "comp.audit.filterRoute": "Útvonal",
  "comp.audit.typeJudgeEvent": "Bírói event",
  "comp.audit.typeJamSave": "JAM (versenyző saját)",
  "comp.audit.typeAdminEdit": "Admin szerkesztés",
  "comp.audit.typeAdminImport": "Excel import",
  "comp.audit.refresh": "Frissítés",
  "comp.audit.loadMore": "Továbbiak",
  "comp.audit.empty": "Nincs még naplóbejegyzés",
  "comp.audit.snapshotLabel": "Pillanatkép",
  "comp.audit.judgeRole": "Bíró",
  "comp.audit.adminRole": "Admin",
  "comp.audit.organizerRole": "Szervező",
  "comp.audit.competitorRole": "Versenyző",
  "comp.audit.attemptN": "{n}. próba",
  "comp.audit.zoneShort": "Zóna",
  "comp.audit.topShort": "Top",
  "comp.audit.noTop": "–",
  "comp.audit.allFilter": "Mind",
  "comp.audit.jamSelfNote": "(JAM saját rögzítés)",
  "comp.audit.revoked": "visszavonva",

  // Bib number export
  "comp.bibExport.btnLabel": "Rajtszámok (PDF)",
  "comp.finalsRotation.btnLabel": "Döntő rotáció (PDF)",
  "comp.finalsRotation.round": "Forduló",
  "comp.finalsRotation.startOrder": "Rajtsorrend",
  "comp.finalsRotation.routesOrder": "Utak sorrendje",
  "comp.finalsRotation.gapNote": "Szünet a csoportok között: {rounds} forduló",
  "comp.finalsRotation.noFinals": "Ehhez a versenyhez nincs döntő kijelölt finalistákkal.",

  // Participant list
  "comp.participantList.btnLabel": "Résztvevő lista (PDF)",
  "comp.participantList.generatedAt": "Generálva: {date}",
  "comp.participantList.appeared": "Megjelent",
  "comp.participantList.competitorCount": "Versenyzők: {count}",
  "comp.participantList.judgeCount": "Bírók: {count}",
  "comp.participantList.groupCount": "Csoportok: {count}",
  "comp.participantList.sessionCount": "Sessionök: {count}",
  "comp.participantList.printOverview": "Nyomtatás",
  "comp.participantList.session": "Session",
  "comp.participantList.startNumber": "Rajtszám",
  "comp.participantList.judgeSessions": "Sessionök",
  "comp.participantList.sessionDuration": "Időtartam",
  "comp.participantList.sessionMax": "Max résztvevők",
  "comp.participantList.sessionGroups": "Csoportok",
  "comp.participantList.sessionCompetitors": "Versenyzők",

  // Finals session
  "comp.sessionType.standard": "Standard",
  "comp.sessionType.finals": "Döntő",
  "comp.newFinalsSession": "Új döntő session",
  "comp.finals.topN": "Döntősök száma",
  "comp.finals.maxAttempts": "Max próba (döntő)",
  "comp.finals.topNHint": "Hány legjobb versenyző jut a döntőbe",
  "comp.finals.loadFromRanking": "Rangsor betöltése",
  "comp.finals.noFinalists": "Válassz csoportot és töltsd be a rangsorból",
  "comp.finals.sourceSession": "Forrás",
  "comp.finals.sourceAll": "Teljes verseny",
  "comp.finals.timePerBoulder": "Idő boulderenként",
  "comp.finals.multiGroupHint": "Több csoport esetén a versenyzők nem keverednek: a csoportok egymás után, közös idővonalon mennek (lásd a szünetet).",
  "comp.finals.groupGap": "Szünet csoportok közt",
  "comp.finals.groupGapHint": "forduló (boulder-idő) a csoportok között",
  "comp.finals.selectGroupsFirst": "Előbb jelölj ki legalább egy csoportot.",
  "comp.finals.moveGroupUp": "Csoport előrébb",
  "comp.finals.moveGroupDown": "Csoport hátrébb",
  "comp.finals.restBetween": "Pihenő körök között",
  "comp.finals.restRounds": "Pihenőkörök száma",
  "comp.finals.restRoundsHint": "ennyi kört pihen a versenyző két mászás közt (IFSC: 1, néha 2)",
  "comp.finals.observationTime": "Megtekintési idő",
  "comp.finals.routes": "Döntő útvonalak",
  "comp.finals.routesHint": "A döntő útjai (eltérhetnek a selejtezőtől)",
  "comp.finals.finalists": "Döntősök",
  "comp.finals.reverseOrderHint": "Fordított selejtező sorrend (legrosszabb kezd)",
  "comp.finals.totalRounds": "Összesen {n} kör",
  "comp.finals.autoDuration": "Becsült időtartam: {n} perc",
  "comp.finals.control": "Döntő vezérlés",
  "comp.finals.round": "Kör: {current} / {total}",
  "comp.finals.phaseObservation": "Megtekintés",
  "comp.finals.phaseClimbing": "Mászás",
  "comp.finals.phaseRest": "Rotáció / pihenő",
  "comp.finals.phaseFinished": "Befejezve",
  "comp.finals.startObservation": "Megtekintés indítása",
  "comp.finals.startClimbing": "Mászás indítása (1. kör)",
  "comp.finals.nextRound": "Következő kör",
  "comp.finals.finish": "Döntő befejezése",
  "comp.finals.waiting": "Várakozik",
  "comp.finals.allDone": "Végzett",
  "comp.finals.isolation": "Izoláció",
  "comp.finals.isolationWait": "Kérjük, várj a sorodra!",
  "comp.finals.isolationPosition": "Te vagy a(z) {n}. mászó",
  "comp.finals.isolationEntryRound": "Belépésed a(z) {n}. körben",
  "comp.finals.isolationCurrentRound": "Aktuális kör: {current} / {total}",
  "comp.finals.selectRoutes": "Döntő útvonalak kiválasztása",
  "comp.finals.badge": "DÖNTŐ",
  "comp.finals.addManually": "Versenyző hozzáadása",
  "comp.finals.searchCompetitor": "Versenyző keresése...",
  "comp.finals.noCompetitorsAvailable": "Nincs több elérhető versenyző",

  // Series
  "series.title": "Verseny sorozatok",
  "series.new": "Új sorozat",
  "series.badge": "Sorozat",
  "series.roundsProgress": "{done}/{total} forduló kész",
  "series.viewStandings": "Állás megtekintése",
  "series.totalPoints": "Összpont",
  "series.round": "Forduló",
  "series.noResults": "Még nincs eredmény",
  "series.noSeries": "Nincs ilyen sorozat",
  "series.notFound": "Ez a sorozat nem található",
  "series.notClosed": "A verseny még nem lett lezárva",
  "series.status.active": "Aktív",
  "series.status.closed": "Lezárt",
  // Series Editor
  "series.editor.settings": "Beállítások",
  "series.editor.competitions": "Versenyek",
  "series.editor.groups": "Csoportok",
  "series.editor.name": "Sorozat neve",
  "series.editor.description": "Leírás",
  "series.editor.scoring": "Pontozás",
  "series.editor.scoringType": "Pontozási mód",
  "series.editor.scoringRawPoints": "Pontok összeadása",
  "series.editor.scoringRawPointsHint": "A versenyekben szerzett pontszámok közvetlen összege",
  "series.editor.scoringPlacement": "Helyezés-alapú",
  "series.editor.scoringPlacementHint": "A helyezéshez rendelt pontok (konfiguálható)",
  "series.editor.pointMap": "Pont táblázat",
  "series.editor.place": "Helyezés",
  "series.editor.points": "Pont",
  "series.editor.addRow": "Sor hozzáadása",
  "series.editor.defaultPoints": "Alapértelmezett pont",
  "series.editor.defaultPointsHint": "A táblázaton kívüli helyezettek pontja",
  "series.editor.countBest": "Legjobb eredmények száma",
  "series.editor.countBestHint": "Üres = minden forduló számít",
  "series.editor.addCompetition": "Verseny hozzáadása",
  "series.editor.noClosedComps": "Nincs lezárt verseny",
  "series.editor.addGroup": "Csoport hozzáadása",
  "series.editor.groupName": "Csoport neve",
  "series.editor.groupMapping": "Verseny csoport hozzárendelés",
  "series.editor.noMapping": "Nincs ilyen csoport",
  "series.editor.close": "Sorozat lezárása",
  "series.editor.closeConfirm": "Biztosan lezárod a sorozatot?",
  "series.editor.delete": "Sorozat törlése",
  "series.editor.deleteConfirm": "Biztosan törlöd a sorozatot? Ez a művelet nem vonható vissza.",
  "series.editor.saved": "Mentve!",

  // Boulder name generator
  "names.adjectives": "Dinamikus,Statikus,Tapadós,Beöntött,Magnéziás,Bátor,Precíz,Repülő,Fáradhatatlan,Izzadt,Gumiujjú,Ziháló,Remegő,Izzadós,Vakmerő,Lelkes,Kétségbeesett,Akrobatikus,Súlytalan,Nyögő,Ügyeskedő,Pihent,Repedezett,Görcsös,Lendületes,Megfontolt,Rugalmas,Hősies,Mázlis,Csúszós,Poros,Elszánt",
  "names.nouns": "Gekkó,Hegyi kecske,Sloper-király,Peremhuszár,Béta-gyilkos,Kunszt-lovag,Ziccer-mászó,Dinó-bajnok,Magnéziazsák,Mászócipő,Zuzmó,Slapaj,Falmászó,Ziccer-hős,Lépésművész,Peremlakó,Dinamó-király,Sloper-bűvölő,Kunszt-vadász,Béta-mester,Magnézia-felhő,Hegyi-törpe,Fal-huszár,Boulder-manó,Erőgép,Akasztó-bajnok,Repülő-mókus,Zuzmó-pajti,Karom-mester,Fogás-kereső,Fal-akrobata,Stand-bajnok",
  "names.route.adjectives": "Hajnali,Éjféli,Csúszós,Ravasz,Szemtelen,Néma,Vad,Álmos,Hamis,Gonosz,Szelíd,Kegyetlen,Rejtett,Elveszett,Ferde,Görbe,Titkos,Bolond,Forró,Jeges,Szédült,Mérges,Lusta,Hosszú,Rövid,Kopott,Fekete,Ezüst,Arany,Utolsó,Első,Furfangos,Ördögi,Kacskaringós",
  "names.route.nouns": "Perem,Tánc,Csapda,Ösvény,Lépcső,Vihar,Álom,Kanyar,Hullám,Létra,Örvény,Kígyó,Pók,Sas,Ugrás,Lendület,Rejtély,Átkelés,Kísértés,Repedés,Párkány,Sárkány,Macska,Fecske,Torony,Mutatvány,Ballada,Pillanat,Kaland,Labirintus,Taréj,Zsákutca,Varázslat,Szakadék",

  // Pricing & billing
  "pricing.title": "Árazás",
  "pricing.tiers": "Csomagok",
  "pricing.mauBands": "MAU sávok",
  "pricing.tierName": "Csomag neve",
  "pricing.quarterly": "negyedév",
  "pricing.perQuarter": "/ negyedév",
  "pricing.addBand": "+ Sáv hozzáadása",
  "pricing.minMau": "Min MAU",
  "pricing.maxMau": "Max MAU",
  "pricing.unlimited": "Korlátlan",
  "pricing.save": "Árak mentése",
  "pricing.saved": "Árak mentve",
  "pricing.setupFee": "Beüzemelési díj (egyszeri)",
  "pricing.netNotice": "Minden ár nettó ár, áfa nélkül értendő.",
  "pricing.vatRate": "Áfakulcs",
  "pricing.addons.title": "Kiegészítők",
  "pricing.addons.nameHu": "Név (HU)",
  "pricing.addons.nameEn": "Név (EN)",

  // Gym admin — subscription section
  "subscription.title": "Előfizetés és Számlázás",
  "subscription.currentTier": "Aktuális csomag",
  "subscription.currency": "Pénznem",
  "subscription.mauQuarterMax": "MAU csúcs ({quarter})",
  "subscription.mauQuarterMaxHint": "ez alapján számlázunk negyedév végén",
  "subscription.mauBand": "MAU sáv",
  "subscription.mauTrend": "MAU trend (3 hónap)",
  "subscription.tierPrice": "Csomag ár",
  "subscription.mauPrice": "MAU sáv ár",
  "subscription.totalPrice": "Összesen (nettó)",
  "subscription.vat": "Áfa ({rate}%)",
  "subscription.grossTotal": "Bruttó összesen",
  "subscription.vatReverseCharge": "Fordított adózás — a számla áfát nem tartalmaz, az áfát a vevő számolja el a saját tagállamában.",
  "subscription.vatOutOfScope": "Az áfa területi hatályán kívül — a számla áfát nem tartalmaz.",
  "subscription.discount": "Kedvezmény",
  "subscription.addonDiscountTag": "−{pct}%",
  "subscription.nextQuarter": "Következő negyedév kezdete",
  "subscription.bandWarning": "A MAU közeledik a sáv felső határához",

  // Platform admin — gym card
  "platform.gym.mau": "MAU",
  "platform.gym.band": "Sáv",
  "platform.gym.currency": "Pénznem",
  "platform.gym.billing": "Számlázás",
  "platform.gym.invoiceDetailsEmpty": "A terem még nem adott meg számlázási adatot.",
  "platform.gym.invoiceDetailsUpdated": "Utoljára módosítva: {date}",
  "platform.gym.invoiceDetailsHint": "A terem admin tölti ki az Admin → Előfizetés és Számlázás szekcióban.",
  "platform.gym.quarterlyTotal": "Negyedéves összeg (nettó)",
  "platform.gym.mauHistory": "MAU történet",
  "platform.gym.discount": "Kedvezmény",
  "platform.gym.addonDiscounts": "Kiegészítő-kedvezmények",
  "platform.gym.discountsSection": "Kedvezmények",
  "platform.gym.vatCurrencySection": "Áfa és pénznem",
  "platform.gym.quarterlySection": "Negyedéves díj",
  "platform.gym.discountReadOnly": "Kedvezmény módosításához „számlázás szerkesztése” jogosultság szükséges.",
  "platform.gym.vatStatus": "Áfa-státusz",
  "platform.gym.vatAuto": "Auto",
  "platform.gym.vatDomestic": "Áfás",
  "platform.gym.vatReverseCharge": "Fordított",
  "platform.gym.vatOutOfScope": "Hatályon kívül",
  "platform.gym.vatEffective": "Érvényes státusz: {status}",
  "platform.gym.vatStatusHint": "Az Auto a terem számlázási országa és EU adószáma alapján dönt; kézi választás ezt felülbírálja (a negyedéves számlázásban is).",
  "platform.gym.currencyLock": "Zárolás",
  "platform.gym.currencyLockHint": "Zárolva a terem admin nem válthat pénznemet (a szerver is elutasítja) — te itt továbbra is módosíthatod.",
  "platform.gym.vatEuMissingWarn": "EU-s cím EU adószám nélkül — a fordított adózás nem alkalmazható, addig áfát számlázunk. Kérd be az EU adószámot, vagy bíráld felül a státuszt.",
  "platform.gym.regenerateButton": "Számlázási CSV generálása",
  "platform.gym.regenerateRunning": "Generálás…",
  "platform.gym.regenerateConfirm": "Generálsz egy számlázási CSV-t a következő teremhez: {name}? Az előző negyedévre számol, frissíti a quarterlyBilling snapshot-ot, és letölti a CSV-t. Email NEM megy a teremnek — a számlát neked kell elküldened.",
  "platform.gym.regenerateSuccess": "Generálva ({quarter}) — {total} {currency}. Snapshot frissítve, CSV letöltve.",

  // Cookie consent
  "cookie.message": "Ez a weboldal cookie-kat (sütiket) használ a felhasználói élmény javítására. Az analitikai cookie-k segítenek megérteni, hogyan használják a Platformot.",
  "cookie.accept": "Elfogadom",
  "cookie.decline": "Elutasítom",
  "cookie.details": "Részletek",

  // Legal pages
  "legal.back": "Vissza",
  "legal.lastUpdated": "Utolsó frissítés",
  "legal.contact": "Kapcsolat",
  "legal.terms.short": "ÁSZF",
  "legal.privacy.short": "Adatkezelési Tájékoztató",

  // Consent modal
  "consent.welcome": "Üdvözlünk a Sendly-ben!",
  "consent.updated": "A feltételek frissültek",
  "consent.description": "A Platform használatához el kell fogadnod az alábbi dokumentumokat:",
  "consent.acceptTerms": "Elolvastam és elfogadom az ÁSZF-et",
  "consent.acceptPrivacy": "Elolvastam és elfogadom az Adatkezelési Tájékoztatót",
  "consent.submit": "Elfogadom és folytatom",
  "consent.cannotUse": "Ha nem fogadod el, nem tudod használni a Platformot.",
  "consent.profileTitle": "Profilod",
  "consent.profileHint": "Ellenőrizd az adataidat — később a Beállításokban bármikor módosíthatod.",
  "settings.legal": "Jogi",
  "settings.legal.acceptedAt": "Elfogadva",

  // Disciplines
  "discipline.boulder": "Boulder",
  "discipline.lead": "Lead",
  "discipline.label": "Diszciplína",
  "discipline.filterAll": "Mind",

  // Admin — disciplines
  "admin.disciplines": "Diszciplínák",
  "admin.disciplinesHint": "Milyen típusú utakat kezel a terem?",
  "admin.diffTabBoulder": "Boulder nehézségek",
  "admin.diffTabLead": "Lead nehézségek",

  // Admin — TV discipline
  "admin.tvDisciplineMode": "Diszciplína szűrő",
  "admin.tvDisciplineAll": "Mindkettő (váltakozva)",

  // Settings — lead grade preference
  "settings.gradePreferenceBoulder": "Boulder nehézségi skála",
  "settings.gradePreferenceLead": "Lead nehézségi skála",
  "settings.gradeFrench": "Francia (6a, 6b+, ...)",
  "settings.gradeUiaa": "UIAA (VI, VII+, ...)",

  // Settings — Monthly recap
  "settings.monthlyRecapTitle": "Havi összefoglaló",
  "settings.monthlyRecapDesc": "Havonta emailben összefoglalót kapsz a mászós teljesítményedről.",
  "settings.monthlyRecapLevel": "Összefoglaló típusa",
  "settings.recapFull": "Teljes (személyes + terem + verseny)",
  "settings.recapPersonal": "Személyes (csak saját statisztikák)",
  "settings.recapMinimal": "Minimális (pontszám és rangsor)",
  "settings.recapOff": "Kikapcsolva",
  "settings.gymAdminReport": "Terem admin riport emailek",
  "settings.gymAdminReportDesc": "Havi üzleti riport a termekről amiket kezelsz — MAU, népszerű utak, új tagok. Termenként külön ki/be kapcsolható, független a mászó recap beállításától.",

  // Platform Admin — Recap Management
  "platformAdmin.recapTitle": "Havi összefoglaló",
  "platformAdmin.recapEnabled": "Email küldés engedélyezve",
  "platformAdmin.recapFromEmail": "Feladó",
  "platformAdmin.recapDailyLimit": "Napi limit",
  "platformAdmin.recapDailyLimitUnit": "email",
  "platformAdmin.recapScheduleDay": "Küldés napja",
  "platformAdmin.recapScheduleDayUnit": "nap",
  "platformAdmin.recapScheduleHour": "Küldés órája (UTC)",
  "platformAdmin.recapSentThisMonth": "Küldött ebben a hónapban",
  "platformAdmin.recapLastSent": "Utolsó kiküldés",
  "platformAdmin.recapSuccess": "Sikeres",
  "platformAdmin.recapFailed": "Hiba",
  "platformAdmin.recapTestTitle": "Teszt email küldése",
  "platformAdmin.recapTestType": "Típus",
  "platformAdmin.recapTestTypeRecap": "Havi összefoglaló (mászó)",
  "platformAdmin.recapTestTypeAdmin": "Terem admin riport",
  "platformAdmin.recapTestTypeInactive": "Inaktív mód (gyere mászni)",
  "platformAdmin.recapTestTypeWrapped": "Éves Wrapped (előző év)",
  "platformAdmin.recapTestSend": "Teszt küldése magamnak",
  "platformAdmin.recapTestSending": "Küldés...",
  "platformAdmin.recapTestSent": "Elküldve!",
  "platformAdmin.recapTestError": "Hiba a küldésnél",
  "platformAdmin.recapManualTrigger": "Manuális kiküldés indítása",
  "platformAdmin.recapManualWarning": "Ez azonnal kiküldi MINDEN aktív usernek. Normál esetben a scheduled function végzi automatikusan.",
  "platformAdmin.recapManualConfirm": "Biztosan elindítod a manuális kiküldést?",
  "platformAdmin.recapManualStarted": "Kiküldés elindítva",
  "platformAdmin.recapPerGym": "Per-gym statisztikák",
  "platformAdmin.recapGym": "Terem",
  "platformAdmin.recapSent": "Küld.",
  "platformAdmin.recapErrors": "Hiba",
  "platformAdmin.recapSaved": "Mentve!",
  "platformAdmin.recapNeverSent": "Még nem volt kiküldés",
  "platformAdmin.recapTestLevel": "Szint",

  // Wrapped (yearly summary)
  "wrapped.title": "SENDLY WRAPPED {year}",
  "wrapped.subtitle": "{name} éves összefoglalója",
  "wrapped.previewBanner": "Élő előnézet — az adatok valós időben számolódnak, az év még nem zárult le.",
  "wrapped.totalPoints": "Összpontszám",
  "wrapped.totalRoutes": "Megmászás",
  "wrapped.activeDays": "Aktív nap",
  "wrapped.hardestClimb": "Legnehezebb megmászás",
  "wrapped.longestStreak": "Leghosszabb streak",
  "wrapped.weeks": "hét",
  "wrapped.bestWeek": "Legjobb heted",
  "wrapped.week": "{n}. hét",
  "wrapped.bestFlashMonth": "Legtöbb flash egy hónapban",
  "wrapped.flashes": "flash",
  "wrapped.monthlyChart": "Éves fejlődésed",
  "wrapped.firstAscent": "Első megmászásod",
  "wrapped.lastAscent": "Utolsó megmászásod",
  "wrapped.gyms": "Termeid",
  "wrapped.activeDaysIn": "aktív nap",
  "wrapped.funFacts": "Tudtad?",
  "wrapped.mostClimbed": "Legtöbbször mászott utad",
  "wrapped.times": "{n}×",
  "wrapped.gymCount": "{n} teremben másztál",
  "wrapped.sprayTitle": "Spraywall",
  "wrapped.sprayHardest": "Legnehezebb küldés",
  "wrapped.sprayDays": "Spray-nap",
  "wrapped.spraySends": "Küldés",
  "wrapped.sprayProblemsCreated": "Létrehozott út",
  "wrapped.noData": "Még nincs Wrapped adatod ehhez az évhez.",
  "wrapped.backToGyms": "Vissza a teremlistához",
  "wrapped.gymPoints": "{n} pont",
  "wrapped.loading": "Wrapped betöltése...",
  "wrapped.monthNames": "Jan,Feb,Már,Ápr,Máj,Jún,Júl,Aug,Sze,Okt,Nov,Dec",

  // ── Interval Timer (Tabata) ──
  "intervalTimer.waitingForWorkout": "Interval Timer",
  "intervalTimer.scanToControl": "Olvasd be a QR kódot a telefonoddal az edzés indításához",
  "intervalTimer.pinUnavailable": "A PIN most nem érhető el. Kérd meg a személyzetet, hogy párosítsa újra ezt a képernyőt az admin panelen.",
  "intervalTimer.pin": "PIN",
  "intervalTimer.work": "MUNKA",
  "intervalTimer.rest": "PIHENŐ",
  "intervalTimer.prepare": "FELKÉSZÜLÉS",
  "intervalTimer.paused": "SZÜNET",
  "intervalTimer.restBetweenSetsLabel": "PIHENŐ (SETEK KÖZÖTT)",
  "intervalTimer.setRoundLabel": "Set {currentSet}/{totalSets} · Kör {currentRound}/{totalRounds}",
  "intervalTimer.workoutComplete": "Edzés vége! 💪",
  "intervalTimer.totalTime": "Összesen",
  "intervalTimer.enterPin": "Add meg a PIN kódot",
  "intervalTimer.invalidPin": "Érvénytelen kód, próbáld újra",
  "intervalTimer.tooManyAttempts": "Túl sok próbálkozás, várj néhány percet",
  "intervalTimer.myPresets": "Saját",
  "intervalTimer.gymPresets": "Terem",
  "intervalTimer.noPresetsYet": "Még nincsenek presetek. Hozz létre egyet alul.",
  "intervalTimer.loginForMyPresets": "Jelentkezz be a saját presetjeid kezeléséhez",
  "intervalTimer.newPreset": "Új preset",
  "intervalTimer.totalDuration": "Összesen: {time}",
  "intervalTimer.presetSummary": "{rounds} × ({work}s munka / {rest}s pihenő) · {sets} set",
  "intervalTimer.presetName": "Preset neve",
  "intervalTimer.addDescription": "Leírás hozzáadása",
  "intervalTimer.addPhase": "+ Új szakasz",
  "intervalTimer.totalRounds": "Körök száma",
  "intervalTimer.sets": "Sorozatok",
  "intervalTimer.restBetweenSets": "Sorozatok közti pihenő",
  "intervalTimer.prepareTime": "Felkészülés",
  "intervalTimer.save": "Mentés",
  "intervalTimer.cancel": "Mégse",
  "intervalTimer.confirmDelete": "Biztosan törlöd ezt a presetet?",
  "intervalTimer.editPreset": "Preset szerkesztése",
  "intervalTimer.removePhase": "Szakasz törlése",
  "intervalTimer.pauseBtn": "Szünet",
  "intervalTimer.resumeBtn": "Folytatás",
  "intervalTimer.stopBtn": "Leállítás",
  "intervalTimer.skipPhase": "Szakasz átugrása",
  "intervalTimer.volume": "Hangerő",
  "intervalTimer.backToPresets": "Vissza a presetekhez",
  "intervalTimer.controlTakenOver": "Egy másik felhasználó átvette a vezérlést.",
  "intervalTimer.ok": "OK",
  "intervalTimer.errorNameRequired": "A név megadása kötelező",
  "intervalTimer.errorNameTooLong": "A név maximum 60 karakter lehet",
  "intervalTimer.errorRoundsRequired": "Legalább egy szakaszt meg kell adni",
  "intervalTimer.errorDurationRange": "Az időtartam 1 és 3600 másodperc között lehet",
  "intervalTimer.errorTotalRoundsRange": "A körök száma 1 és 100 között lehet",
  "intervalTimer.errorSetsRange": "A sorozatok száma 1 és 20 között lehet",
  "intervalTimer.errorRestBetweenSetsRange": "A pihenő 0 és 3600 másodperc között lehet",
  "intervalTimer.errorPrepareTimeRange": "A felkészülési idő 0 és 60 másodperc között lehet",
  "intervalTimer.adminPin": "PIN: {pin}",
  "intervalTimer.adminRepair": "Képernyő újrapárosítása",
  "intervalTimer.adminRepairConfirm": "Bontod a képernyő eszköz-párosítását? A TV a következő betöltéskor új PIN-t kér — csak akkor használd, ha a falon nem jelenik meg PIN.",
  "intervalTimer.adminControlActive": "Vezérli: aktív",
  "intervalTimer.adminControlFree": "Nincs vezérlő",
  "intervalTimer.adminReleaseControl": "Vezérlés felszabadítása",
  "intervalTimer.adminAllToIntervalTimer": "Minden TV-t Interval timerre",
  "intervalTimer.typeWork": "Munka",
  "intervalTimer.typeRest": "Pihenő",
  "intervalTimer.cycles": "Körök",
  "intervalTimer.switchToRest": "Váltás pihenőre",
  "intervalTimer.switchToWork": "Váltás munkára",
  "intervalTimer.decrease": "{label} csökkentése",
  "intervalTimer.increase": "{label} növelése",
  "intervalTimer.selectPreset": "Válassz presetet",
  "intervalTimer.startBtn": "Indítás",
  "intervalTimer.scanQr": "Olvasd be a QR kódot a TV-n, vagy írd be a PIN kódot",
  "intervalTimer.autoResetIn": "Automatikus visszaállás {seconds} mp múlva",

  // Public gym widget (embeddable iframe)
  "widget.summary.activeRoutes": "aktív út",
  "widget.summary.members": "mászó",
  "widget.summary.totalAscents": "megmászás",
  "widget.summary.totalClimbs": "összes mászás",
  "widget.grades.title": "Nehézségi eloszlás",
  "widget.grades.boulder": "Boulder",
  "widget.grades.lead": "Kötelet",
  "widget.grades.noData": "Nincs még elég adat",
  "widget.competition.title": "Verseny",
  "widget.competition.viewLeaderboard": "Élő ranglista →",
  "widget.competition.viewExternal": "Részletek →",
  "widget.competition.viewResults": "Eredmények →",
  "widget.upgrade.required": "Ez a widget csak Pro csomagtól érhető el",
  "widget.powered": "Powered by Sendly",
  "widget.error.notFound": "Terem nem található",
  "widget.error.noSnapshot": "A widget jelenleg nem elérhető",
  "widget.occupancy.title": "Kihasználtság",

  // Occupancy chart (shared across widget, admin panel, gym info)
  "occupancy.title": "Kihasználtság",
  "occupancy.quiet": "Csendes",
  "occupancy.busy": "Népszerű",
  "occupancy.level.quiet": "Csendes",
  "occupancy.level.moderate": "Közepes",
  "occupancy.level.busy": "Forgalmas",
  "occupancy.level.veryBusy": "Nagyon forgalmas",
  "occupancy.noData": "Még nincs elég adat",
  "occupancy.closed": "Zárva",
  "occupancy.basedOn": "Az elmúlt {weeks} hét adatai alapján",

  // Admin panel — widget settings
  "admin.widget.title": "Widget / API",
  "admin.widget.description": "Jelenítsd meg a terem adatait a saját weboldaladon egy egyszerű beágyazással, vagy kérdezd le a JSON API-n keresztül.",
  "admin.widget.sectionHeader.widget": "Widget",
  "admin.widget.sectionHeader.api": "JSON API",
  "admin.widget.enable": "Widget engedélyezése",
  "admin.widget.enableWarning": "Bekapcsolással a terem neve, városa, útvonalainak és tagjainak száma nyilvánosan elérhetővé válik.",
  "admin.widget.enableConfirm": "Biztosan publikussá teszed a terem alapadatait?",
  "admin.widget.apiKey.title": "API kulcs",
  "admin.widget.apiKey.generate": "Új kulcs generálása",
  "admin.widget.apiKey.regenerate": "Új kulcs generálása (a régi érvénytelenné válik)",
  "admin.widget.apiKey.regenerateConfirm": "A régi kulcs azonnal érvénytelen lesz. Folytatod?",
  "admin.widget.apiKey.copy": "Másolás",
  "admin.widget.apiKey.copied": "Másolva",
  "admin.widget.apiKey.show": "Megjelenítés",
  "admin.widget.apiKey.hide": "Elrejtés",
  "admin.widget.apiKey.none": "Még nincs kulcs generálva",
  "admin.widget.preview.title": "Előnézet",
  "admin.widget.preview.summary": "Összefoglaló",
  "admin.widget.preview.grades": "Nehézségi eloszlás",
  "admin.widget.preview.competition": "Aktív verseny",
  "admin.widget.preview.occupancy": "Kihasználtság",
  "admin.widget.preview.full": "Mind",
  "admin.widget.snippet.title": "Beágyazás kódja",
  "admin.widget.snippet.copy": "Kód másolása",
  "admin.widget.snippet.copied": "Kód másolva",
  "admin.widget.api.description": "Fejlesztőknek: kérdezd le a JSON API-t saját alkalmazásodból.",
  "admin.widget.api.endpoint": "Végpont",
  "admin.widget.api.example": "Példa (curl)",
  "admin.widget.api.usage": "API hívások",
  "admin.widget.api.usageToday": "Ma",
  "admin.widget.api.usage7d": "Utolsó 7 nap",
  "admin.widget.api.usage30d": "Utolsó 30 nap",
  "admin.widget.api.usageTotal": "Összesen",
  "admin.widget.api.usageNever": "Még nincs lekérés",
  "admin.widget.rebuild": "Frissítés most",
  "admin.widget.rebuilding": "Frissítés folyamatban…",
  "admin.widget.rebuildSuccess": "Widget adatok frissítve",
  "admin.widget.rebuildError": "Frissítés sikertelen",
  "admin.widget.planRequired": "Pro csomag szükséges",
  "admin.widget.disabled": "A widget jelenleg ki van kapcsolva",

  // ── Permission system: roles ──
  "roles.user.label": "Felhasználó",
  "roles.user.desc": "Alapvető terem-tag funkciók",
  "roles.setter.label": "Építő",
  "roles.setter.desc": "Útvonalak rögzítése és kezelése",
  "roles.coach.label": "Edző",
  "roles.coach.desc": "Edzés tervek és interval timer presetek",
  "roles.receptionist.label": "Recepciós",
  "roles.receptionist.desc": "TV és interval timer kezelése",
  "roles.gymAdmin.label": "Terem admin",
  "roles.gymAdmin.desc": "Teljes terem-szintű hozzáférés",

  // ── Permission system: capability categories ──
  "capCategory.routes": "Útvonalak",
  "capCategory.users": "Felhasználók",
  "capCategory.gym": "Terem profil",
  "capCategory.mapsAndConfig": "Térképek és beállítások",
  "capCategory.tv": "TV vezérlőpult",
  "capCategory.stats": "Statisztikák",
  "capCategory.competitions": "Versenyek",
  "capCategory.series": "Sorozatok",
  "capCategory.database": "Adatbázis",
  "capCategory.billing": "Számlázás",
  "capCategory.intervalTimer": "Interval timer",

  // ── Permission system: capability labels & descriptions ──
  "caps.routes.create.label": "Új útvonal rögzítése",
  "caps.routes.create.desc": "Útvonal felvétele a térképre",
  "caps.routes.edit.label": "Útvonal szerkesztése",
  "caps.routes.edit.desc": "Meglévő útvonal módosítása",
  "caps.routes.archive.label": "Útvonal archiválása",
  "caps.routes.archive.desc": "Útvonal archiválása (visszafordítható)",
  "caps.routes.delete.label": "Útvonal törlése",
  "caps.routes.delete.desc": "Útvonal végleges törlése (visszafordíthatatlan)",
  "caps.routes.viewTab.label": "Útvonalak fül",
  "caps.routes.viewTab.desc": "Hozzáférés az Útvonalak kezelő fülhöz",

  "caps.users.view.label": "Tagok megtekintése",
  "caps.users.view.desc": "Terem tagok listájának megtekintése",
  "caps.users.viewProfile.label": "Tag profil megtekintése",
  "caps.users.viewProfile.desc": "Tagok statisztikáinak megtekintése (megmászások, pontok, gyakoriság) — pl. az utak listán a mászó-fejlécre kattintva",
  "caps.users.changeRole.label": "Szerepkör módosítása",
  "caps.users.changeRole.desc": "Tag szerepkörének és jogosultságainak módosítása",
  "caps.users.kick.label": "Tag eltávolítása",
  "caps.users.kick.desc": "Tag eltávolítása a teremből",
  "caps.users.ban.label": "Tag kitiltása",
  "caps.users.ban.desc": "Tag tartós kitiltása a teremből (indok és audit bejegyzés kötelező)",
  "caps.users.viewAuditLog.label": "Audit napló megtekintése",
  "caps.users.viewAuditLog.desc": "Jogosultság-módosítások és tagsági események előzményei",

  "caps.gym.editProfile.label": "Terem profil szerkesztése",
  "caps.gym.editProfile.desc": "Név, leírás, cím, GPS, kontakt, diszciplínák, widget",
  "caps.gym.editBranding.label": "Arculat szerkesztése",
  "caps.gym.editBranding.desc": "Logó, borítókép, kiemelő szín",
  "caps.gym.editVisibility.label": "Láthatóság szerkesztése",
  "caps.gym.editVisibility.desc": "Nyilvános megjelenés a teremválasztóban",
  "caps.gym.editGeneral.label": "Általános beállítások",
  "caps.gym.editGeneral.desc": "Új útvonal badge napok, nyitvatartás, időzóna",

  "caps.maps.manage.label": "Térképek kezelése",
  "caps.maps.manage.desc": "Emeletek hozzáadása, átnevezése, kép feltöltés, törlés",
  "caps.difficulty.manage.label": "Nehézségi szintek kezelése",
  "caps.difficulty.manage.desc": "Nehézségi szintek és fokozattartományok szerkesztése",
  "caps.holdColors.manage.label": "Fogásszínek kezelése",
  "caps.holdColors.manage.desc": "Fogásszín opciók szerkesztése",

  "caps.tv.manage.label": "TV beállítások",
  "caps.tv.manage.desc": "TV képernyők (jóváhagyás, átnevezés, módváltás, törlés), valamint slide-ok, időzítés, téma, OLED védelem",
  "caps.tv.regenerateToken.label": "TV token újragenerálás",
  "caps.tv.regenerateToken.desc": "Új TV token generálás (régi link érvénytelenítése)",
  "caps.tv.forceReleaseTimer.label": "Timer felszabadítás",
  "caps.tv.forceReleaseTimer.desc": "Interval timer mobil vezérlés erőszakos felszabadítása",

  "caps.stats.viewSetterTab.label": "Építők fül",
  "caps.stats.viewSetterTab.desc": "Hozzáférés az Építők statisztika fülhöz",
  "caps.stats.viewAdvanced.label": "Bővített statisztikák",
  "caps.stats.viewAdvanced.desc": "Forgalom, fokozateloszlás, útvonal elemzés, hőtérkép",

  "caps.competitions.manage.label": "Versenyek kezelése",
  "caps.competitions.manage.desc": "Versenyek létrehozása, szerkesztése, aktiválása, lezárása, törlése",
  "caps.competitions.viewClimberTimeline.label": "Mászók idővonala",
  "caps.competitions.viewClimberTimeline.desc": "A verseny bármely versenyzőjének session-idővonala: milyen sorrendben és hány próbával ment az utakra",

  "caps.series.manage.label": "Sorozatok kezelése",
  "caps.series.manage.desc": "Versenysorozatok létrehozása, szerkesztése, lezárása, törlése",

  "caps.db.export.label": "Adatok exportálása",
  "caps.db.export.desc": "Teljes terem JSON adatexport",
  "caps.db.maintain.label": "Adatbázis karbantartás",
  "caps.db.maintain.desc": "Terem adatok törlési műveletei",

  "caps.billing.view.label": "Számlázás megtekintése",
  "caps.billing.view.desc": "Előfizetés státusz, MAU szám, árazás",
  "caps.billing.changeCurrency.label": "Pénznem váltás",
  "caps.billing.changeCurrency.desc": "Számlázási pénznem váltás (HUF/EUR/USD)",

  "caps.intervalTimer.managePresets.label": "Timer presetek",
  "caps.intervalTimer.managePresets.desc": "Terem presetek létrehozása, szerkesztése, törlése",

  "capCategory.mcp": "AI-kapcsolat",
  "capCategory.spraywall": "Spraywall",
  "caps.mcp.read.label": "AI-kapcsolat: olvasás",
  "caps.mcp.read.desc": "A Sendly MCP szerver terem-ági olvasó eszközeinek használata AI-asszisztensen át (mindegyik a saját adat-jogosultságával együtt), és az admin panel „AI-kapcsolat” szekciójának megjelenítése",
  "caps.mcp.write.label": "AI-kapcsolat: írás",
  "caps.mcp.write.desc": "A Sendly MCP szerver terem-ági író eszközeinek használata AI-asszisztensen át (a gym:write jogosultsággal és az adott művelet saját jogosultságával együtt), és az „Írás engedélyezése AI-n keresztül” kapcsoló kezelése",
  "caps.spraywall.manage.label": "Spraywall: falak kezelése",
  "caps.spraywall.manage.desc": "Spraywall falak létrehozása, szerkesztése és törlése; fotó, fogásfelismerés, fogások és fal-verziók; elhelyezés a térképen; a spray-út létrehozási jogának beállításai; hivatalos listák",
  "caps.spraywall.moderate.label": "Spraywall: moderálás",
  "caps.spraywall.moderate.desc": "Bárki spray-útjának elrejtése, törlése és szerkesztése; privát, barát-szintű és rejtett spray-utak látása; kommentek törlése; benchmark jelölés (a benchmark problémák küldései beszámítanak a mászók szintjébe); bejelentések kezelése",
  "spraywall.whatIsSendBody": "Send = az út teljes kimászása esés nélkül, a starttól a topig.",
  "spraywall.gradeVote": "Grade-szavazatom",
  "spraywall.gradeVoteEasier": "Könnyebb grade-ek",
  "spraywall.gradeVoteHarder": "Nehezebb grade-ek",
  "spraywall.gradeVoteHint": "A szaggatott keret a mostani konszenzus. A szavazat nem kötelező, később is módosíthatod; a kijelöltre koppintva visszavonod.",
  "spraywall.view.problems": "Utak",
  "spraywall.view.lists": "Listák",
  "spraywall.wallHeader.back": "Vissza a falakhoz",
  "spraywall.wallMenu.button": "Továbbiak",
  "spraywall.wallMenu.versions": "Régi fal-verziók",
  "spraywall.wallMenu.edit": "Fal szerkesztése",
  "spraywall.wallMenu.manage": "Falak kezelése",
  "spraywall.wallMenu.newWall": "Új fal",
  "spraywall.strip.fullWall": "Teljes fal",
  "spraywall.versions.title": "Régi fal-verziók",
  "spraywall.versions.body": "A fal korábbi felállásai. Az útjaik böngészhetők, és a saját logodat törölheted, de nem logolhatók.",
  "spraywall.versions.empty": "Még nincs régi fal-verzió.",
  "spraywall.versions.dates": "{from} – {to}",
  "spraywall.versions.routeCount": "{count} út",
  "spraywall.versions.band": "Archív — csak böngészés",
  "spraywall.versions.backToCurrent": "Vissza a mostanihoz",
  "spraywall.versions.crumb": "Régi verzió: {label}",
  "spraywall.empty.noProblems": "Még nincs út — légy te az első",
  "spraywall.empty.photoFailed": "A fal fotója nem töltődött be.",
  "spraywall.empty.retry": "Újrapróbálás",
  "spraywall.empty.noWall": "Még nincs spraywall. Vegyél fel egy falat: fotó, fogásfelismerés, élesítés. Amíg nincs kiélesített fal, a tagok nem látják ezt a fület.",
  "spraywall.empty.noLists": "Még nincs lista.",
  "spraywall.empty.noLog": "Még nincs naplóbejegyzésed.",
  "spraywall.loading": "Spraywall betöltése…",
  "spraywall.picker.newWall": "+ Új fal",
  "spraywall.picker.manage": "Falak kezelése",
  "spraywall.picker.problemCount": "{count} aktív út",
  "spraywall.picker.kicker": "Spray fal",
  "spraywall.picker.newThisWeek": "{count} új a héten",
  "spraywall.picker.openReports": "{count} bejelentés",
  "spraywall.picker.reportsLabel": "Bejelentések",
  "spraywall.picker.reportsHint": "Megnyitás → Bejelentések",
  "spraywall.picker.ownReportsHint": "A saját utaidon — a staff megnézi",
  "spraywall.picker.needsReview": "{count} felülvizsgálandó",
  "spraywall.picker.needsReviewLabel": "Felülvizsgálandó",
  "spraywall.picker.needsReviewHint": "Megnyitás → Felülvizsgálandó",
  "spraywall.picker.ownNeedsReviewHint": "A saját utaidon — Megnyitás → Saját utaid",
  "spraywall.picker.you": "Te",
  "spraywall.picker.youLine": "{sends} send · {projects} projekt",
  "spraywall.picker.lastClimbed": "Utoljára: {date}",
  "spraywall.picker.open": "Megnyitás",
  "spraywall.picker.manageLabel": "Kezelés",
  "spraywall.wall.angle": "Dőlés: {angle}°",
  "spraywall.wall.hidden": "Rejtett",
  "spraywall.wall.notPublished": "Nincs élesítve",
  "spraywall.wall.live": "Élő",
  "spraywall.wall.notPublishedBody": "Ennek a falnak még nincs élesített verziója, ezért a tagok nem látják. Nyisd meg a szerkesztőt, és élesítsd.",
  "spraywall.wall.deleting": "Törlés folyamatban",
  "spraywall.wall.deletingBody": "A fal törlése megszakadt vagy még fut. A Falak kezelése nézetben újra elindíthatod a befejezéshez.",
  "spraywall.wall.edit": "Szerkesztés",
  "spraywall.manage.title": "Falak kezelése",
  "spraywall.manage.membersCanCreate": "Tagok is létrehozhatnak utat",
  "spraywall.manage.membersCanCreateHint": "A staff mindig létrehozhat. Falanként felülírható.",
  "spraywall.manage.climbersVisible": "Tagok is látják, ki mászta meg az utat",
  "spraywall.manage.climbersVisibleHint": "Kikapcsolva a „Kik mászták” listát csak a staff látja.",
  "spraywall.manage.moveUp": "Feljebb",
  "spraywall.manage.moveDown": "Lejjebb",
  "spraywall.manage.active": "Aktív",
  "spraywall.manage.edit": "Szerkesztés",
  "spraywall.manage.delete": "Fal törlése",
  "spraywall.manage.deleteResume": "Törlés folytatása",
  "spraywall.manage.deleteConfirmTitle": "Törlöd a falat?",
  "spraywall.manage.deleteConfirmBody": "„{name}\" — minden verziója, fotója, útja, a logok, értékelések, kommentek, bejelentések és a falhoz tartozó listák törlődnek. A mászók idővonala és aktív napjai megmaradnak (az út-nevek pillanatképből). Nem vonható vissza.",
  "spraywall.manage.deleting": "Törlés…",
  "spraywall.editor.titleNew": "Új fal",
  "spraywall.editor.title": "Fal szerkesztése",
  "spraywall.editor.back": "Vissza",
  "spraywall.editor.basics": "Alapadatok",
  "spraywall.editor.name": "Név",
  "spraywall.editor.description": "Leírás",
  "spraywall.editor.angle": "Dőlésszög (fok)",
  "spraywall.editor.angleHint": "Csak információ, semmit nem befolyásol.",
  "spraywall.editor.active": "Aktív",
  "spraywall.editor.activeHint": "Kikapcsolva a tagok nem látják a falat.",
  "spraywall.editor.membersCanCreate": "Tagok is létrehozhatnak utat",
  "spraywall.editor.membersCanCreate.gym": "Terem-beállítás",
  "spraywall.editor.membersCanCreate.yes": "Igen",
  "spraywall.editor.membersCanCreate.no": "Nem",
  "spraywall.editor.create": "Létrehozás",
  "spraywall.editor.save": "Mentés",
  "spraywall.editor.saved": "Mentve",
  "spraywall.editor.created": "Fal létrehozva",
  "spraywall.editor.saveFailed": "A mentés nem sikerült. Próbáld újra.",
  "spraywall.editor.photoHint": "A teljes fal férjen rá a fotóra, szemből, egyenletes fényben. Ami nem fér rá, az legyen külön fal.",
  "spraywall.editor.photoNoPeople": "Olyan fotót tölts fel, amin nem látszik ember.",
  "spraywall.editor.uploadPhoto": "Fotó kiválasztása",
  "spraywall.editor.uploading": "Feltöltés…",
  "spraywall.editor.uploadFailed": "A feltöltés nem sikerült. Próbáld újra.",
  "spraywall.editor.versions": "Verziók",
  "spraywall.editor.versionDraft": "piszkozat",
  "spraywall.editor.versionLive": "élő",
  "spraywall.editor.versionStats": "{holds} fogás · {problems} út",
  "spraywall.editor.newVersion": "Új verzió készítése",
  "spraywall.editor.versionLabel": "Verzió neve",
  "spraywall.editor.firstVersionLabel": "Első verzió",
  "spraywall.editor.replaceDraftConfirm": "Van már egy piszkozat. Lecseréled?",
  "spraywall.editor.discardDraft": "Piszkozat elvetése",
  "spraywall.editor.discardDraftConfirm": "A piszkozat, a felismerési javaslatai és a fotója törlődnek. Az élő fal nem változik.",
  "spraywall.editor.draftDiscarded": "Piszkozat elvetve",
  "spraywall.editor.publish": "Élesítés",
  "spraywall.editor.publishConfirm": "Élesíted a „{label}\" verziót? A tagok mostantól ezt a fotót és ezeket a fogásokat látják; a korábbi élő verzió útjai archiválódnak.",
  "spraywall.editor.published": "Verzió élesítve",
  "spraywall.editor.publishHint": "Az élesítésig a tagok nem látják ezt a verziót.",
  "spraywall.editor.holds": "Fogások",
  "spraywall.editor.holdsCount": "{count} fogás · {feetOnly} csak-láb",
  "spraywall.editor.detect": "Fogások felismerése",
  "spraywall.editor.detecting": "Felismerés folyamatban…",
  "spraywall.editor.detectFailed": "A felismerés nem sikerült.",
  "spraywall.editor.editHolds": "Fogások szerkesztése",
  "spraywall.editor.noActiveModel": "Nincs aktív felismerő modell — a + Kör használható",
  "spraywall.editor.placement": "Elhelyezés a térképen",
  "spraywall.editor.placedOn": "Elhelyezve: {map}",
  "spraywall.editor.notPlaced": "Nincs elhelyezve",
  "spraywall.editor.takeOffMap": "Levétel a térképről",
  "spraywall.editor.placementBlocked": "Nyitott átnézés mellett nem érhető el — előbb hagyd jóvá vagy told el.",
  "spraywall.editor.deleteWall": "Fal törlése",
  "spraywall.editor.phoneWarning": "A 300+ fogás átnézéséhez tablet vagy gép ajánlott. Telefonon egy-egy fogás javítása megy.",
  "spraywall.editor.discardReviewConfirm": "Kilépsz az átnézésből? A felismerés és a döntéseid ezen az eszközön 24 óráig megmaradnak.",
  "spraywall.progress.title": "Fogások felismerése",
  "spraywall.progress.starting": "Felismerő indítása…",
  "spraywall.progress.stepStart": "Indítás",
  "spraywall.progress.stepPhoto": "Fotó betöltése",
  "spraywall.progress.stepParts": "Fogások keresése",
  "spraywall.progress.partsCount": "{done} / {total} rész",
  "spraywall.progress.stepMerge": "Összefésülés",
  "spraywall.progress.stepOutline": "Fal széle",
  "spraywall.progress.coldStart": "Az első futásnál ez kb. 10 mp.",
  "spraywall.progress.etaUnknown": "Becslés…",
  "spraywall.progress.etaSoon": "pár másodperc",
  "spraywall.progress.eta": "kb. {s} mp van hátra",
  "spraywall.progress.help": "Nyugodtan továbbléphetsz: a felismerés a szerveren fut, és ha visszajössz, itt folytathatod.",
  "spraywall.resume.title": "Kész felismerés vár átnézésre",
  "spraywall.resume.meta": "{ago} · {count} javaslat · {model} modell",
  "spraywall.resume.agoNow": "most készült",
  "spraywall.resume.agoMinutes": "{count} perce készült",
  "spraywall.resume.agoHours": "{count} órája készült",
  "spraywall.resume.expiry": "24 óráig vár rád, utána újra kell futtatni.",
  "spraywall.resume.open": "Átnézés",
  "spraywall.resume.dismiss": "Elvetés",
  "spraywall.resume.dismissed": "Felismerés elvetve",
  "spraywall.resume.staleTitle": "A legutóbbi felismerés már nem használható.",
  "spraywall.resume.staleBody": "Azóta módosultak a fogások ezen a verzión.",
  "spraywall.resume.expiredTitle": "A legutóbbi felismerés lejárt",
  "spraywall.resume.rerun": "Új felismerés",
  "spraywall.review.toolSelect": "Szerkesztés",
  "spraywall.review.toolSmartPick": "+ Okos",
  "spraywall.review.toolManual": "+ Kör",
  "spraywall.review.reject": "Elvetés",
  "spraywall.review.restore": "Visszavétel",
  "spraywall.review.feetOnly": "Csak láb",
  "spraywall.review.delete": "Törlés",
  "spraywall.review.nextCandidate": "Következő jelölt",
  "spraywall.review.doubtful": "Kétes",
  "spraywall.review.counter": "{count} / 1500",
  "spraywall.review.tooMany": "Egy falon legfeljebb 1500 fogás lehet — vegyél ki néhányat.",
  "spraywall.review.approve": "Jóváhagyás",
  "spraywall.review.keptHint": "{count} kézzel jelölt fogás — a gép nem látta őket, megtartottuk. Vedd ki, ami lekerült.",
  "spraywall.review.dropped": "levéve?",
  "spraywall.review.noHold": "Itt nem látok fogást — rajzolj kézi kört.",
  "spraywall.review.noSmaller": "Nem találtam benne kisebb fogást — rajzolj kézi kört.",
  "spraywall.review.alreadyHold": "Ez már fogás.",
  "spraywall.review.picking": "Fogás keresése…",
  "spraywall.review.needsReviewTitle": "Felülvizsgálatra kerülő utak",
  "spraywall.review.needsReviewBody": "Ezek az utak felülvizsgálatra kerülnek:",
  "spraywall.review.restrictedProblem": "nem nyilvános / rejtett út",
  "spraywall.review.deleteHoldConfirm": "Törlöd a(z) {id} fogást?",
  "spraywall.review.missingNote": "A fogás „hiányzó\" jelölést kap, az azonosítója megmarad; a meglévő küldések nem változnak. Ctrl+Z-vel vagy a fogásra kattintva visszaállítható.",
  "spraywall.review.needsReviewHold": "{count} út használja ezt a fogást. Felülvizsgálatra kerülnek:",
  "spraywall.review.needsReviewHoldOne": "Egy út használja ezt a fogást. Felülvizsgálatra kerül:",
  "spraywall.review.holdCrop": "A(z) {id} fogás a fotón",
  "spraywall.review.feetOnlyConfirm": "Csak láb lesz a(z) {id} fogás?",
  "spraywall.focus.open": "Fókusz nézet",
  "spraywall.focus.exit": "Kilépés a fókusz nézetből",
  "spraywall.focus.fullscreen": "Teljes képernyő",
  "spraywall.focus.exitFullscreen": "Kilépés a teljes képernyőből",
  "spraywall.focus.saving": "Mentés…",
  "spraywall.focus.saved": "✓ Minden mentve",
  "spraywall.focus.idleTitle": "Nincs kijelölt fogás",
  "spraywall.focus.idleMouse": "Kattints egy fogásra a fotón.",
  "spraywall.focus.idleTouch": "Koppints egy fogásra a fotón.",
  "spraywall.focus.hintDrag": "a kijelölt fogáson: mozgatás · máshol: a kép",
  "spraywall.focus.hintTwoFingers": "nagyítás, mozgatás",
  "spraywall.focus.hintLongPress": "csak láb",
  "spraywall.focus.hintPoint": "húzd · a karikával új pont · hosszan nyomva törlés",
  "spraywall.focus.hintDelete": "fogás vagy pont törlése",
  "spraywall.focus.hintFeetOnly": "csak láb",
  "spraywall.focus.hintUndo": "visszavonás",
  "spraywall.focus.hintNudge": "finom tologatás",
  "spraywall.focus.hintEscape": "kilépés a fókusz nézetből",
  "spraywall.focus.keyDrag": "Húzás",
  "spraywall.focus.keyTwoFingers": "Két ujj",
  "spraywall.focus.keyLongPress": "Hosszú nyomás",
  "spraywall.focus.keyPoint": "Pont",
  "spraywall.shape.hint": "Húzd a fogást az áthelyezéshez. A pontokat húzva igazíthatod a körvonalat; az él közepén lévő karikával új pontot teszel be, jobb klikkel (érintőképernyőn hosszan nyomva) törlöd a pontot.",
  "spraywall.outline.tool": "Fal széle",
  "spraywall.outline.points": "Kontúr: {count} / {max} pont",
  "spraywall.outline.none": "Nincs kontúr — a teljes fotó látszik.",
  "spraywall.outline.maxPoints": "Elérted a 64 pontot — új pont előtt törölj egyet.",
  "spraywall.outline.removeOutside": "Kívül eső fogások törlése ({count})",
  "spraywall.outline.removeOutsideConfirm": "Törlöd a kontúron kívüli {count} fogást?",
  "spraywall.outline.rejectOutside": "Kívül esők elutasítása ({count})",
  "spraywall.tools.info": "Mire jók az eszközök?",
  "spraywall.tools.select": "Szerkesztés — koppints egy fogásra. A kijelölt fogást húzva mozgatod, a pontjait húzva igazítod; az él közepén lévő karika új pontot tesz be. Jobb klikk (érintőn hosszan nyomva) egy ponton: a pont törlése; a fogáson: csak láb.",
  "spraywall.tools.smartPick": "+ Okos — koppints egy fogásra, amit a gép nem talált meg: kirajzolja a körvonalát. A kijelölt fogáson belül koppintva kisebbet keres benne.",
  "spraywall.tools.manual": "+ Kör — húzz kört a fogás köré: ahol lenyomod, az a közepe.",
  "spraywall.tools.outline": "Fal széle — ami kívül esik, azt a tagok nem látják. A pontokat húzod, az él karikájával újat teszel be, jobb klikkel (érintőn hosszan nyomva) törlöd.",
  "spraywall.tools.view": "Két ujjal vagy görgővel nagyítasz és mozgatsz; a ⟲ visszaállítja a nézetet.",
  "spraywall.tools.doubtful": "Kétes — csak azokat a javaslatokat emeli ki, amelyekben a gép bizonytalan. A többi elhalványul, és nem lehet rájuk koppintani.",
  "spraywall.outline.auto": "Automatikus kontúr",
  "spraywall.outline.clear": "Kontúr törlése",
  "spraywall.outline.autoFailed": "Nem sikerült kontúrt számolni — ehhez legalább 5 fogás kell egy csoportban.",
  "spraywall.outline.tooSmall": "Túl kicsi a kontúr — legalább a fotó 5%-át kell lefednie.",
  "spraywall.outline.outsideCount": "{count} javaslat a falon kívül esett — elutasítva indulnak.",
  "spraywall.outline.hint": "A kontúron kívüli részt a tagok nem látják, és a felismerés az ottani javaslatokat elutasítva hozza. Húzd a pontokat a fal széleire; az él közepén lévő karikával új pontot teszel be, jobb klikkel (érintőképernyőn hosszan nyomva) törlöd a pontot. A fotó nem változik.",
  "spraywall.shape.zoomIn": "A pontok szerkesztéséhez nagyíts rá a fogásra.",
  "spraywall.shape.maxPoints": "Elérted a 16 pontot — új pont előtt törölj egyet.",
  "spraywall.shape.minPoints": "Legalább 3 pont kell",
  "spraywall.shape.points": "Körvonal: {count} / {max} pont",
  "spraywall.shape.unused": "Egy út sem használja — kérdés nélkül törölhető",
  "spraywall.shape.edited": "kézzel javítva",
  "spraywall.undo.undo": "Visszavonás",
  "spraywall.undo.redo": "Újra",
  "spraywall.undo.restoredRoutes": "Visszaállítva: {id} · {count} út újra rendben",
  "spraywall.restore.title": "{id} · hiányzó",
  "spraywall.restore.body": "Ezt a fogást törölték, de {count} út még használja:",
  "spraywall.restore.button": "Visszaállítás",
  "spraywall.restore.help": "Visszaállítás után az utak újra rendben lesznek, ha más miatt nem felülvizsgálandók. A körvonalat utána igazíthatod. Ha az utakat kijavítják, a fogás magától eltűnik.",
  "spraywall.review.note": "Megjegyzés",
  "spraywall.review.noteHint": "Mindenki látja — ne írj bele nevet.",
  "spraywall.review.noteSave": "Megjegyzés mentése",
  "spraywall.review.rerun": "Újrafuttatás",
  "spraywall.review.srcAuto": "automatikus",
  "spraywall.review.srcPick": "okos",
  "spraywall.review.srcManual": "kézi",
  "spraywall.review.missingHold": "hiányzó",
  "spraywall.photo.coopHint": "Két ujjal mozgasd és nagyítsd a fotót",
  "spraywall.photo.alt": "{name} fal fotója",
  "spraywall.footRule.marked": "Jelölt láb",
  "spraywall.footRule.marked.desc": "Lábnak csak az úton lábként jelölt fogások használhatók, a kézfogások nem.",
  "spraywall.footRule.any": "Kötetlen",
  "spraywall.footRule.any.desc": "Lábnak bármelyik fogás jó, a fal csak-láb fogásai is (a fotón halványan látszanak).",
  "spraywall.footRule.feetFollow": "Kötött",
  "spraywall.footRule.feetFollow.desc": "A kéznek jelölt fogások lábnak is jók.",
  "spraywall.footRule.noFeet": "Láb nélkül",
  "spraywall.footRule.noFeet.desc": "Campus: a lábak nem érhetnek fogást.",
  "spraywall.startHolds.matched": "Egy beszállós",
  "spraywall.startHolds.matched.desc": "Egy beszálló van: mindkét kéz rajta.",
  "spraywall.startHolds.two": "Két beszállós",
  "spraywall.startHolds.two.desc": "Két beszálló van: mindegyiken egy kéz.",
  "spraywall.list.filter.notClimbed": "Még nem másztam",
  "spraywall.list.filter.projects": "Projektjeim",
  "spraywall.list.filter.benchmark": "Benchmark",
  "spraywall.list.filter.mine": "Saját",
  "spraywall.list.filter.hiddenReview": "Rejtett / felülvizsgálandó",
  "spraywall.list.clearFilters": "Szűrők törlése",
  "spraywall.empty.noFilterResult": "Nincs a szűrőknek megfelelő út.",
  "spraywall.list.hiddenReviewEmpty": "Nincs rejtett vagy felülvizsgálandó út.",
  "spraywall.list.loadFailed": "Az utak nem töltődtek be.",
  "spraywall.list.sort": "Rendezés",
  "spraywall.list.sort.new": "Új elöl",
  "spraywall.list.sort.rating": "Legjobbra értékelt",
  "spraywall.list.sort.mostClimbed": "Legtöbbet mászott",
  "spraywall.list.sort.grade": "Nehézség szerint",
  "spraywall.list.row.sends": "{count} send",
  "spraywall.list.row.new": "új",
  "spraywall.list.row.sent": "Elküldve",
  "spraywall.list.row.project": "Projekt",
  "spraywall.list.row.private": "Privát",
  "spraywall.list.row.friends": "Barátok",
  "spraywall.list.row.benchmark": "Benchmark",
  "spraywall.list.row.benchmarkTitle": "Benchmark — beszámít a szintbe",
  "spraywall.list.row.you": "Te",
  "spraywall.filter.title": "Szűrők",
  "spraywall.filter.section.grade": "Nehézség",
  "spraywall.filter.section.status": "Állapot",
  "spraywall.filter.section.style": "Stílus",
  "spraywall.filter.section.list": "Hivatalos lista",
  "spraywall.filter.searchPlaceholder": "Keresés névre",
  "spraywall.filter.count": "{count} út",
  "spraywall.filter.filtered": "szűrve",
  "spraywall.filter.chip.search": "„{query}”",
  "spraywall.badge.hidden": "Rejtett",
  "spraywall.badge.needsReview": "Felülvizsgálandó",
  "spraywall.badge.archived": "Archív",
  "spraywall.badge.reported": "Bejelentve",
  "spraywall.list.ownAttention": "Saját utaid ({count})",
  "spraywall.problem.unavailable": "Az út nem érhető el",
  "spraywall.problem.share": "Megosztás",
  "spraywall.problem.linkCopied": "Link másolva!",
  "spraywall.problem.noteHolds": "Fogás-megjegyzések",
  "spraywall.problem.editedByStaff": "Módosította a staff",
  "spraywall.problem.formerMember": "Volt tag",
  "spraywall.problem.byline": "{name} · {date}",
  "spraywall.problem.authorGrade": "szerző: {grade}",
  "spraywall.problem.footRule": "Lábszabály",
  "spraywall.problem.votesTitle": "Grade-szavazatok",
  "spraywall.problem.votesSummary": "{count} szavazat · konszenzus: medián",
  "spraywall.problem.noVotes": "Még nincs grade-szavazat.",
  "spraywall.problem.counters": "{sends} send · {flashes} flash · {projects} projekt",
  "spraywall.problem.back": "Vissza a listához",
  "spraywall.problem.prev": "Előző út",
  "spraywall.problem.next": "Következő út",
  "spraywall.problem.fullscreen": "Teljes képernyő",
  "spraywall.problem.fullscreenExit": "Kilépés a teljes képernyőből",
  "spraywall.problem.position": "{wall} · {n} / {N}",
  "spraywall.problem.opinions": "Vélemények",
  "spraywall.problem.opinionsSub": "{ratings} értékelés · {comments} komment",
  "spraywall.problem.about": "Az útról",
  "spraywall.problem.climbs": "Mászások",
  "spraywall.problem.fact.grade": "Grade",
  "spraywall.problem.fact.start": "Start",
  "spraywall.problem.fact.style": "Stílus",
  "spraywall.problem.fact.setUp": "Felállítva",
  "spraywall.footer.own": "Saját út",
  "spraywall.footer.staff": "Staff",
  "spraywall.problem.ratingCount": "({count} értékelés)",
  "spraywall.problem.noRatings": "Még nincs értékelés",
  "spraywall.problem.underReview": "Felülvizsgálat alatt",
  "spraywall.problem.underReviewBody": "Egy fogása lekerült a falról, ezért most nem logolható. A szerző vagy a staff javítja.",
  "spraywall.problem.archivedBody": "Archivált fal-verzió. Az utat böngészheted és a saját logodat törölheted, de nem logolható.",
  "spraywall.problem.authorHidden": "Rejtett — csak te és a staff látja.",
  "spraywall.problem.authorReported": "Ezt az utat bejelentették ({count}). A staff megnézi, és ő zárja le.",
  "spraywall.problem.moderatorReported": "{count} nyitott bejelentés ezen az úton. A fal listája fölötti „Bejelentések” gombnál kezelheted.",
  "spraywall.problem.authorNeedsReview": "Felülvizsgálandó — egy fogása lekerült a falról. Javítsd a szerkesztőben, hogy újra logolható legyen.",
  "spraywall.problem.authorPrivate": "Privát — csak te és a staff látja.",
  "spraywall.problem.authorFriends": "Barátok — te, a barátaid és a staff látja.",
  "spraywall.problem.delete": "Törlés",
  "spraywall.problem.deleteConfirmTitle": "Út törlése?",
  "spraywall.problem.deleteConfirmBody": "A „{name}” út véglegesen törlődik.",
  "spraywall.problem.photoAlt": "{name} — az út fogásai",
  "spraywall.log.sent": "Send: {name}",
  "spraywall.log.flashed": "Flash: {name}",
  "spraywall.log.project": "Próbálkozás rögzítve: {name}",
  "spraywall.log.repeat": "Ismétlés: {name}",
  "spraywall.log.failed": "A log rögzítése nem sikerült. Próbáld újra.",
  "spraywall.editor.problemTitleNew": "Új út",
  "spraywall.editor.problemTitleEdit": "Út szerkesztése",
  "spraywall.editor.clear": "Kiürítés",
  "spraywall.editor.fullscreen": "Teljes képernyő",
  "spraywall.editor.step.holds": "Fogások",
  "spraywall.editor.step.start": "Start",
  "spraywall.editor.step.top": "Top",
  "spraywall.editor.step.data": "Adatok",
  "spraywall.editor.step.prev": "Vissza",
  "spraywall.editor.step.next": "Tovább",
  "spraywall.editor.step.save": "Mentés",
  "spraywall.editor.instruction.holds": "Koppints a fogásokra: 1× kéz, 2× láb, 3× kiveszed.",
  "spraywall.editor.instruction.start": "Koppints 1–2 kéz-fogásra: ezek lesznek a startok.",
  "spraywall.editor.instruction.top": "Koppints 1–2 kéz-fogásra: ezek lesznek a topok.",
  "spraywall.editor.chip.hands": "{count} kéz",
  "spraywall.editor.chip.feet": "{count} láb",
  "spraywall.editor.preview.title": "Így látszik majd a listában",
  "spraywall.editor.preview.noName": "(még nincs neve)",
  "spraywall.editor.counter.starts": "Start: {count} / 2",
  "spraywall.editor.counter.tops": "Top: {count} / 2",
  "spraywall.editor.hint.minHands": "Legalább 2 kéz-fogás kell (egy start és egy top).",
  "spraywall.editor.hint.maxHolds": "Legfeljebb 60 fogás lehet.",
  "spraywall.editor.hint.needStart": "Jelölj ki legalább 1 startot.",
  "spraywall.editor.hint.needHandLeft": "Legalább egy kéz-fogásnak maradnia kell a top-nak.",
  "spraywall.editor.hint.needTop": "Jelölj ki legalább 1 topot.",
  "spraywall.editor.hint.needGrade": "Válassz grade-et.",
  "spraywall.editor.maxStart": "Legfeljebb 2 start lehet.",
  "spraywall.editor.maxTop": "Legfeljebb 2 top lehet.",
  "spraywall.editor.noFeetWithFeet": "Láb nélküli úton nem lehet láb fogás — vedd ki őket az 1. lépésben.",
  "spraywall.editor.holdNote": "Megjegyzés: {note}",
  "spraywall.editor.field.name": "Név",
  "spraywall.editor.field.nameShuffle": "Másik név",
  "spraywall.editor.field.grade": "Grade",
  "spraywall.editor.field.footRule": "Lábszabály",
  "spraywall.editor.field.tags": "Címkék (legfeljebb 5)",
  "spraywall.editor.field.description": "Leírás",
  "spraywall.editor.privateLocked": "Más már mászta, értékelte, kommentelte vagy listába tette — szűkebb láthatóságra már csak a staff teheti.",
  "spraywall.editor.field.visibility": "Ki látja?",
  "spraywall.editor.visibility.public": "Mindenki",
  "spraywall.editor.visibility.friends": "Barátok",
  "spraywall.editor.visibility.private": "Csak én",
  "spraywall.editor.privateNotAuthor": "A láthatóságot csak a szerző állíthatja.",
  "spraywall.editor.locked": "A fogássor zárt — {count} send már erre szól. A név, a leírás, a grade és a címkék szerkeszthetők. Más fogássor = új út.",
  "spraywall.editor.fixable": "{count} javítandó fogás (?) — a falról lekerült. Cseréld egy másikra vagy hagyd el; a többi fogás zárt, a send-ek megmaradnak. Hiánytalan fogássorral az út újra aktív.",
  "spraywall.editor.reviewNotice": "Felülvizsgálandó út: {count} fogás javításra vár — eltűnt a falról, vagy csak láb lehet. Koppints a kiemelt fogásra: lekerül, vagy lábbá válik. Utána mentsd, és az út újra aktív.",
  "spraywall.editor.reviewPending": "Még {count} fogás javításra vár — így mentve felülvizsgálandó marad.",
  "spraywall.editor.reviewFixed": "Minden fogás rendben — mentés után az út újra aktív.",
  "spraywall.editor.staffEditNote": "Mentés után az út nézetben „Módosította a staff” jelölés látszik.",
  "spraywall.editor.wallUpdated": "A fal közben frissült",
  "spraywall.editor.discardTitle": "Elveted a változtatásokat?",
  "spraywall.editor.discardBody": "A mentetlen módosítások elvesznek.",
  "spraywall.editor.discardConfirm": "Elvetem",
  "spraywall.journal.tile.sends": "Send",
  "spraywall.journal.tile.flashes": "Flash",
  "spraywall.journal.tile.days": "Spray-nap",
  "spraywall.journal.gradeDist": "Grade-eloszlás",
  "spraywall.journal.gradeDistHint": "send",
  "spraywall.journal.sum.sends": "{count} send",
  "spraywall.journal.sum.repeats": "{count} ismétlés",
  "spraywall.journal.sum.projects": "{count} projekt",
  "spraywall.journal.deletedProblem": "törölt út",
  "spraywall.journal.unavailableProblem": "nem elérhető út",
  "spraywall.journal.unavailable": "nem érhető el",
  "spraywall.journal.deleteWholeLog": "„{name}” teljes logjának törlése",
  "spraywall.journal.loadFailed": "A napló nem töltődött be.",
  "stats.sprayBox.title": "Spraywall",
  "stats.sprayBox.openProjects": "Nyitott projektek ({count})",
  "stats.sprayBox.journalBtn": "Teljes spray-napló · {count} bejegyzés",
  "stats.sprayBox.journalTitle": "Spray-napló",
  "stats.sprayBox.journalSub": "Minden fal · {count} bejegyzés",
  "stats.sprayBox.perGym": "Termenként",
  "stats.sprayBox.gymLine": "{sends} send · {days} nap",
  "stats.sprayBox.openGymLog": "Napló",
  "spraywall.rating.title": "Milyen az út?",
  "spraywall.rating.hint": "Koppints egy csillagra.",
  "spraywall.rating.hintRated": "Az értékelésed: {count}/5. Koppints ugyanarra a csillagra a visszavonáshoz.",
  "spraywall.rating.group": "Az út értékelése",
  "spraywall.rating.star": "{count}/5 csillag",
  "spraywall.rating.failed": "Az értékelés nem sikerült. Próbáld újra.",
  "spraywall.climbers.title": "Kik mászták",
  "spraywall.climbers.you": "Te",
  "spraywall.climbers.flash": "⚡ Flash",
  "spraywall.climbers.attempts": "{count} próba",
  "spraywall.climbers.repeats": "{count} ismétlés",
  "spraywall.climbers.empty": "Még senki nem küldte.",
  "spraywall.climbers.more": "Továbbiak",
  "spraywall.climbers.unknown": "Ismeretlen tag",
  "spraywall.climbers.loadFailed": "A lista nem tölthető be.",
  "spraywall.comments.title": "Kommentek",
  "spraywall.comments.placeholder": "Írj kommentet…",
  "spraywall.comments.send": "Küldés",
  "spraywall.comments.empty": "Még nincs komment.",
  "spraywall.comments.more": "Továbbiak",
  "spraywall.comments.delete": "Komment törlése",
  "spraywall.comments.deleteConfirm": "Biztosan törlöd ezt a kommentet?",
  "spraywall.comments.loadFailed": "A kommentek nem tölthetők be.",
  "spraywall.report.button": "Bejelentés",
  "spraywall.report.title": "Út bejelentése",
  "spraywall.report.subtitle": "{name} · a bejelentést csak a staff látja.",
  "spraywall.report.reasonLabel": "A bejelentés oka",
  "spraywall.report.reason.wrongProblem": "Hibás út",
  "spraywall.report.reason.wrongProblemHint": "rossz fogások, nagyon eltérő grade, spam",
  "spraywall.report.reason.offensive": "Sértő tartalom",
  "spraywall.report.reason.other": "Egyéb",
  "spraywall.report.notePlaceholder": "Megjegyzés (nem kötelező)",
  "spraywall.report.submit": "Bejelentés küldése",
  "spraywall.report.already": "Már bejelentetted. A staff megnézi. Ha lezárják, újra bejelentheted.",
  "spraywall.report.noteTooLong": "A megjegyzés legfeljebb 300 karakter lehet.",
  "spraywall.moderation.edit": "Szerkesztés",
  "spraywall.moderation.benchmark": "Benchmark",
  "spraywall.moderation.hideProblem": "Elrejtem az utat",
  "spraywall.moderation.unhideProblem": "Újra megjelenítem",
  "spraywall.moderation.deleteProblem": "Törlöm az utat",
  "spraywall.moderation.deleteConfirm": "Biztosan törlöd ezt az utat? A hozzá tartozó küldések, kommentek, értékelések és bejelentések is törlődnek. Nem vonható vissza.",
  "spraywall.moderation.unhideNeedsReview": "Visszavéve, de egy fogása hiányzik, ezért felülvizsgálandó",
  "spraywall.moderation.resolve": "Rendben, lezárom",
  "spraywall.moderation.reports": "Bejelentések ({count})",
  "spraywall.moderation.needsReview": "Felülvizsgálandó ({count})",
  "spraywall.moderation.reportsTitle": "Bejelentések",
  "spraywall.moderation.reportCount": "{count} nyitott",
  "spraywall.moderation.reportsEmpty": "Nincs nyitott bejelentés.",
  "spraywall.moderation.reportsLoadFailed": "A bejelentések nem tölthetők be.",
  "spraywall.moderation.deletedProblem": "Törölt út",
  "spraywall.moderation.openProblem": "Az út megnyitása",
  "spraywall.lists.official": "Hivatalos",
  "spraywall.lists.mine": "Listáim",
  "spraywall.lists.gym": "A terem listái",
  "spraywall.lists.friends": "Barátok listái",
  "spraywall.lists.new": "+ Új lista",
  "spraywall.lists.newTitle": "Új lista",
  "spraywall.lists.editTitle": "Lista szerkesztése",
  "spraywall.lists.name": "Név",
  "spraywall.lists.namePlaceholder": "A lista neve",
  "spraywall.lists.circuit": "circuit",
  "spraywall.lists.circuitLabel": "Circuit",
  "spraywall.lists.circuitHint": "Sorban mászandó, számozva, „Következő” gombbal",
  "spraywall.lists.problemCount": "{count} út",
  "spraywall.lists.officialHint": "A teremé — bármely falkezelő szerkesztheti, a fülön elöl jelenik meg",
  "spraywall.lists.officialNotOwn": "Csak a saját listádat teheted hivatalossá.",
  "spraywall.lists.officialNoCreator": "A létrehozó nélküli hivatalos lista nem fokozható le, csak törölhető.",
  "spraywall.lists.officialIsGym": "A hivatalos lista mindig a teremé, ezért mindenkinek látszik.",
  "spraywall.lists.visibility": "Láthatóság",
  "spraywall.lists.visibilityPrivate": "Privát",
  "spraywall.lists.visibilityGym": "Terem",
  "spraywall.lists.visibilityFriends": "Barátok",
  "spraywall.lists.lastModified": "Utoljára módosította: {name} · {date}",
  "spraywall.lists.delete": "Lista törlése",
  "spraywall.lists.deleteConfirm": "Biztosan törlöd a(z) „{name}” listát? Az utak nem törlődnek.",
  "spraywall.lists.saveFailed": "A lista mentése nem sikerült. Próbáld újra.",
  "spraywall.lists.removeFromList": "Kivétel a listából",
  "spraywall.lists.moveUp": "Feljebb",
  "spraywall.lists.moveDown": "Lejjebb",
  "spraywall.lists.unavailable": "Nem elérhető",
  "spraywall.lists.full": "A lista megtelt (legfeljebb 100 út).",
  "spraywall.lists.emptyList": "Ebben a listában még nincs út.",
  "spraywall.lists.addTitle": "Listához adás",
  "spraywall.lists.addHint": "Privát utat nem lehet listába tenni.",
  "spraywall.lists.circuitPosition": "{pos} / {total}",
  "spraywall.lists.prev": "← Előző",
  "spraywall.lists.next": "Következő →",
  "spraywall.lists.log": "Logolás",
  "spraywall.lists.circuitSkipHint": "A „Következő” átugorja az elérhetetlen vagy archivált tételeket.",
  "spraywall.lists.circuitEmpty": "Ebben a circuitben nincs elérhető út.",
  "spraywall.tag.crimpy": "crimpy",
  "spraywall.tag.slopey": "slopey",
  "spraywall.tag.pinchy": "pinchy",
  "spraywall.tag.pockety": "pockety",
  "spraywall.tag.juggy": "juggy",
  "spraywall.tag.compression": "compression",
  "spraywall.tag.dynamic": "dynamic",
  "spraywall.tag.technical": "technical",
  "spraywall.tag.powerful": "powerful",
  "spraywall.tag.endurance": "endurance",
  "spraywall.role.start": "start",
  "spraywall.role.hand": "kéz",
  "spraywall.role.foot": "láb",
  "spraywall.role.finish": "top",
  "spraywall.error.notMember": "Nem vagy tagja ennek a teremnek.",
  "spraywall.error.banned": "Ki vagy tiltva ebből a teremből.",
  "spraywall.error.missingCap": "Ehhez nincs jogosultságod.",
  "spraywall.error.addonInactive": "A Spraywall kiegészítő nem aktív ebben a teremben.",
  "spraywall.error.invalidArgument": "Érvénytelen kérés. Frissítsd az oldalt, és próbáld újra.",
  "spraywall.error.invalidMode": "Ez a felismerési mód most nem használható ezen a verzión.",
  "spraywall.error.invalidPhotoPath": "A feltöltött fotó nem található vagy érvénytelen. Töltsd fel újra.",
  "spraywall.error.invalidPoint": "A kijelölt pont a fotón kívül van.",
  "spraywall.error.invalidLabel": "A verzió neve 1–40 karakter legyen.",
  "spraywall.error.invalidSize": "A fotó mérete érvénytelen.",
  "spraywall.error.invalidProposalIdx": "A javaslatok közben megváltoztak — futtasd újra a felismerést.",
  "spraywall.error.invalidHoldId": "Ez a fogás már nem létezik. Töltsd újra a szerkesztőt.",
  "spraywall.error.invalidPoly": "A fogás körvonala érvénytelen.",
  "spraywall.error.invalidOutline": "A fal kontúrja érvénytelen vagy túl kicsi.",
  "spraywall.error.invalidTransform": "A fotó-igazítás értéke érvénytelen.",
  "spraywall.error.refreshOnly": "Ez a beállítás csak újrafelismerésnél használható.",
  "spraywall.error.versionNotFound": "A verzió nem található — lehet, hogy közben elvetették.",
  "spraywall.error.wallNotFound": "A fal nem található.",
  "spraywall.error.runNotFound": "A felismerés nem található. Futtasd újra.",
  "spraywall.error.runExists": "Ez a felismerés már elindult.",
  "spraywall.error.versionExists": "Ez a verzió már létezik másik fotóval. Próbáld újra.",
  "spraywall.error.versionNotEditable": "Ez a verzió már nem szerkeszthető.",
  "spraywall.error.versionNotEmpty": "Az első felismeréshez a verzió legyen üres — használd az újrafelismerést.",
  "spraywall.error.versionNotDraft": "Ez csak piszkozat verzióval lehetséges.",
  "spraywall.error.versionEmpty": "Fogások nélkül nem élesíthető a verzió.",
  "spraywall.error.wallDeleting": "A fal törlése folyamatban van.",
  "spraywall.error.draftExists": "Ennek a falnak már van piszkozata.",
  "spraywall.error.runInProgress": "A felismerés még fut — várd meg, vagy próbáld újra pár perc múlva",
  "spraywall.error.staleRun": "Közben módosult a fogássor — futtasd újra a felismerést.",
  "spraywall.error.alreadyApproved": "Ezt a felismerést már jóváhagytad.",
  "spraywall.error.notDone": "A felismerés még nem készült el.",
  "spraywall.error.runExpired": "A felismerés lejárt (24 óránál régebbi). Futtasd újra.",
  "spraywall.error.tooManyHolds": "Egy falon legfeljebb 1500 fogás lehet.",
  "spraywall.error.photoGone": "Az átmeneti fotó lejárt, töltsd fel újra",
  "spraywall.error.versionNotLive": "Ez a verzió nem az élő verzió.",
  "spraywall.error.versionNotArchived": "Csak archivált verzió élesíthető újra.",
  "spraywall.error.no-active-model": "Nincs aktív felismerő modell — a + Kör használható",
  "spraywall.error.tooManyProposals": "A felismerés túl sok javaslatot adott (2000 fölött). Próbálj jobb fotót.",
  "spraywall.error.internal": "A felismerés belső hibával leállt. Próbáld újra.",
  "spraywall.error.staleEdit": "A fogássor közben megváltozott — töltsd újra a szerkesztőt.",
  "spraywall.error.emptyEdit": "Nincs mit menteni.",
  "spraywall.error.holdMissing": "Ez a fogás már hiányzik, nem szerkeszthető.",
  "spraywall.error.holdNotRemoved": "Ez a fogás nem törölt, ezért nem állítható vissza.",
  "spraywall.error.invalidNote": "A megjegyzés 1–40 karakter legyen.",
  "spraywall.error.rateLimit": "Ezen a falon egy órán belül már 10 felismerés futott — próbáld újra később.",
  "spraywall.error.photoTooLarge": "A kép túl nagy (5 MB fölött) — válassz kisebb felbontást.",
  "spraywall.error.photoUnreadable": "A böngésződ nem tudja megnyitni ezt a képet (pl. HEIC formátum). Mentsd el JPG-ként vagy PNG-ként, és töltsd fel úgy.",
  "spraywall.error.invalidName": "A név 1–60 karakter legyen.",
  "spraywall.error.invalidDescription": "A leírás legfeljebb 500 karakter lehet.",
  "spraywall.error.invalidGrade": "Érvénytelen grade.",
  "spraywall.error.invalidTags": "Legfeljebb 5 címkét választhatsz a listából.",
  "spraywall.error.invalidFootRule": "Érvénytelen lábszabály.",
  "spraywall.error.invalidVisibility": "Érvénytelen láthatóság.",
  "spraywall.error.holdCount": "Az útban 2–60 fogás lehet.",
  "spraywall.error.unknownHold": "Egy kijelölt fogás már nem létezik a falon. Töltsd újra a szerkesztőt.",
  "spraywall.error.startCount": "1–2 start kell.",
  "spraywall.error.finishCount": "1–2 top kell.",
  "spraywall.error.feetOnlyRole": "Csak-láb fogás csak láb szerepet kaphat.",
  "spraywall.error.noFeetRule": "Láb nélküli úton nem lehet láb fogás.",
  "spraywall.error.duplicateHold": "Egy fogás csak egyszer szerepelhet.",
  "spraywall.error.missingHold": "Egy kijelölt fogás lekerült a falról. Cseréld vagy hagyd el.",
  "spraywall.error.notAuthor": "Ezt csak a szerző vagy a staff teheti meg.",
  "spraywall.error.visibilityNotAuthor": "A láthatóságot csak a szerző állíthatja.",
  "spraywall.error.problemNotFound": "Az út nem található.",
  "spraywall.error.cannotCreate": "Ezen a falon most nem hozhatsz létre utat.",
  "spraywall.error.locked": "A fogássor zárt, mert már van rá send. A többi adat szerkeszthető.",
  "spraywall.error.hasActivity": "Más már mászta, értékelte, kommentelte vagy listába tette — szűkebb láthatóságra már csak a staff teheti.",
  "spraywall.error.hasSends": "Már van rá send, ezért nem törölhető. Kérd a staffot.",
  "spraywall.error.saveRateLimit": "Túl sokszor mentetted az utat. Próbáld újra később.",
  "spraywall.error.invalidText": "A komment 1–500 karakter legyen.",
  "spraywall.error.invalidReason": "Válassz egy okot a listából.",
  "spraywall.error.invalidAction": "Ez a moderációs művelet nem ismert. Frissítsd az oldalt.",
  "spraywall.error.commentNotFound": "A komment már nem létezik.",
  "spraywall.error.problemNotOpen": "Ez az út most nem nyitott — kommentelni és bejelenteni sem lehet.",
  "spraywall.error.ownProblem": "A saját utadat nem jelentheted be.",
  "spraywall.error.notHidden": "Ez az út nincs elrejtve.",
  "spraywall.error.privateProblem": "Privát vagy barát-szintű utat nem lehet benchmarkká tenni.",
  "spraywall.error.friendsDisabled": "Ebben a teremben a barát-funkció ki van kapcsolva.",
  "spraywall.error.alreadyReported": "Ezt az utat már bejelentetted.",
  "spraywall.error.unknown": "Valami hiba történt. Próbáld újra.",
  // Spraywall wall refresh (step 7): photo swap, matching review, archive
  "spraywall.editor.photoSwap": "Fotócsere",
  "spraywall.editor.photoSwapUpload": "Új fotó…",
  "spraywall.editor.photoSwapBody": "Pár fogást felcsavartak vagy levettek, vagy csak jobb képet csinálnál. Az utak megmaradnak.",
  "spraywall.editor.photoSwapHint": "Ugyanonnan fotózd, mint az előzőt.",
  "spraywall.editor.photoSwapReviewNote": "Ha egy út fogása eltűnik, az út felülvizsgálandó lesz.",
  "spraywall.editor.newVersionBody": "A falat újracsavarozták. Új fal-verzió indul üres útlistával.",
  "spraywall.editor.newVersionArchive": "A mostani {count} út élesítéskor archiválódik — böngészhető marad, de nem logolható.",
  "spraywall.editor.newVersionArchiveAll": "A mostani utak élesítéskor archiválódnak — böngészhetők maradnak, de nem logolhatók.",
  "spraywall.editor.newVersionConfirmTitle": "Új verziót kezdesz?",
  "spraywall.editor.newVersionConfirmBody": "A mostani {count} út élesítéskor archiválódik. Addig a tagok a mostani falat látják.",
  "spraywall.editor.newVersionConfirmBodyAll": "A mostani utak élesítéskor archiválódnak. Addig a tagok a mostani falat látják.",
  "spraywall.editor.choose": "Kezdés",
  "spraywall.editor.continue": "Tovább",
  "spraywall.editor.versionBlockStats": "{holds} fogás · {feetOnly} csak-láb · {problems} út",
  "spraywall.editor.versionBlockStatsDraft": "{holds} fogás · {feetOnly} csak-láb · még nincs út",
  "spraywall.editor.headerDraft": "+ piszkozat",
  "spraywall.editor.publishSwap": "{draft} → élő · {live} → archivált",
  "spraywall.editor.publishArchive": "A „{label}\" verzió {count} útja archiválódik: böngészhető marad, de nem logolható.",
  "spraywall.editor.publishArchiveAll": "A „{label}\" verzió útjai archiválódnak: böngészhetők maradnak, de nem logolhatók.",
  "spraywall.editor.publishHintLive": "Az élesítésig a tagok a mostani falat látják.",
  "spraywall.editor.republish": "Újraélesítés",
  "spraywall.editor.republishConfirmTitle": "Újraélesíted a „{label}\" verziót?",
  "spraywall.editor.republishConfirmBody": "A tagok újra ezt a fotót és ezeket a fogásokat látják. A {count} régi út újra logolható.",
  "spraywall.editor.republishConfirmBodyAll": "A tagok újra ezt a fotót és ezeket a fogásokat látják. A régi utak újra logolhatók.",
  "spraywall.editor.republishArchive": "A mostani „{label}\" verzió archiválódik. A rá feltett {count} út böngészhető marad, de nem logolható.",
  "spraywall.editor.republishArchiveAll": "A mostani „{label}\" verzió archiválódik. Az útjai böngészhetők maradnak, de nem logolhatók.",
  "spraywall.editor.republishArchiveNone": "A mostani „{label}\" verzió archiválódik; még nincs rajta út.",
  "spraywall.editor.republished": "Verzió újraélesítve",
  "spraywall.editor.compWarning": "Fut egy spray kihívás vagy verseny, ami ennek a falnak az útjait használja: {names}. Az archiválódó utakat utána nem lehet logolni.",
  "spraywall.holdUsage.open": "Melyik utakban van?",
  "spraywall.holdUsage.title": "Melyik utakban van?",
  "spraywall.holdUsage.subtitle": "Koppints egy fogásra a fotón.",
  "spraywall.holdUsage.pick": "Válassz egy fogást a fotón.",
  "spraywall.holdUsage.none": "Ezt a fogást egy út sem használja.",
  "spraywall.holdUsage.count": "{count} út használja ezt a fogást",
  "spraywall.holdUsage.missingCount": "Hiányzó fogás — {count} út használja még",
  "spraywall.holdUsage.missingHint": "Ha ezeket kijavítod, a fogás magától eltűnik a falról.",
  "spraywall.holdUsage.privateName": "Privát út",
  "spraywall.holdUsage.loadFailed": "Nem sikerült betölteni az utakat.",
  "spraywall.editor.photoSwapDraftBlocked": "Piszkozat mellett nem érhető el — előbb élesítsd vagy vesd el a piszkozatot.",
  "spraywall.editor.archivedVersions": "Archivált verziók ({count})",
  "spraywall.editor.versionArchived": "archivált",
  "spraywall.editor.archivedAt": "Archiválva: {date}",
  "spraywall.review.photoSwapTitle": "Új fotó párosítása",
  "spraywall.review.chipMatched": "Párosítva",
  "spraywall.review.chipNew": "Új fogás",
  "spraywall.review.chipDropped": "Levéve?",
  "spraywall.review.chipKept": "Kézzel jelölt, megtartva",
  "spraywall.review.droppedNote": "A „levéve?\" fogás jóváhagyáskor törlődik — ha út használja, „hiányzó\" lesz, és az út felülvizsgálandó.",
  "spraywall.review.align": "Kézi igazítás (ha a becslés elcsúszott)",
  "spraywall.review.alignFailed": "Az automatikus igazítás nem sikerült — igazítsd kézzel a régi fogásokat az új fotóhoz, majd nyomd meg az Újrapárosítást.",
  "spraywall.review.alignShiftX": "Eltolás X",
  "spraywall.review.alignShiftY": "Eltolás Y",
  "spraywall.review.alignScale": "Nagyítás",
  "spraywall.review.alignRotate": "Forgatás",
  "spraywall.review.alignReset": "Becslés visszaállítása",
  "spraywall.review.rematch": "Újrapárosítás",
  "spraywall.review.photoSwapConfirmTitle": "Jóváhagyod a fotócserét?",
  "spraywall.review.photoSwapConfirmBody": "A tagok mostantól az új fotót látják. A küldések és a számlálók maradnak.",
  "spraywall.archive.noProblems": "Ebben az archivált verzióban nincsenek utak.",
  "spraywall.archive.loadFailed": "Az archivált verziók nem töltődtek be.",

  // ── Permission system: platform capability labels ──
  "caps.platform.gym.create.label": "Terem létrehozása",
  "caps.platform.gym.create.desc": "Új terem létrehozása a platformon",
  "caps.platform.gym.activate.label": "Terem aktiválása",
  "caps.platform.gym.activate.desc": "Terem aktív/inaktív állapot váltása",
  "caps.platform.gym.delete.label": "Terem törlése",
  "caps.platform.gym.delete.desc": "Terem végleges törlése",
  "caps.platform.gym.editPlan.label": "Csomag szerkesztése",
  "caps.platform.gym.editPlan.desc": "Terem csomag váltás (free/pro/competition)",
  "caps.platform.gym.editFeatures.label": "Feature-ök szerkesztése",
  "caps.platform.gym.editFeatures.desc": "Feature flag override-ok",
  "caps.platform.gym.editBilling.label": "Számlázás szerkesztése",
  "caps.platform.gym.editBilling.desc": "MAU sáv, számlázási override-ok",
  "caps.platform.gym.assignAdmin.label": "Terem admin kinevezése",
  "caps.platform.gym.assignAdmin.desc": "Terem admin hozzáadása email alapján",
  "caps.platform.gym.adminAny.label": "Bármely terem admin",
  "caps.platform.gym.adminAny.desc": "Teljes admin hozzáférés minden teremhez",
  "caps.platform.stats.view.label": "Platform statisztikák",
  "caps.platform.stats.view.desc": "Platform szintű statisztikák és grafikonok",
  "caps.platform.pricing.edit.label": "Árazás szerkesztése",
  "caps.platform.pricing.edit.desc": "Tier árak és MAU sávok",
  "caps.platform.settings.edit.label": "Platform beállítások",
  "caps.platform.settings.edit.desc": "Kiemelő szín, térkép toggle, fokozatskála",
  "caps.platform.user.editCaps.label": "Felhasználó jogosultságok",
  "caps.platform.user.editCaps.desc": "Platform szintű jogosultságok szerkesztése",
  "caps.platform.viewAuditLog.label": "Audit napló",
  "caps.platform.viewAuditLog.desc": "Platform szintű audit események (jogosultság-módosítások, jövőbeli admin események)",
  "caps.platform.recap.manage.label": "Recap kezelése",
  "caps.platform.recap.manage.desc": "Havi összefoglaló konfiguráció és teszt email",
  "caps.platform.crashLogs.view.label": "Crash naplók",
  "caps.platform.crashLogs.view.desc": "Crash naplók és digest email beállítás",
  "caps.platform.viewMarketData.label": "Piaci adatok",
  "caps.platform.viewMarketData.desc": "Havi anonim piaci snapshot-ok megtekintése",
  "caps.platform.users.view.label": "Felhasználók megtekintése",
  "caps.platform.users.view.desc": "Platform szintű felhasználói lista böngészése és profilok megnyitása",
  "caps.platform.users.ban.label": "Felhasználók tiltása",
  "caps.platform.users.ban.desc": "Felhasználó tiltása vagy feloldása az egész platformon",
  "caps.platform.mcp.use.label": "AI-kapcsolat (platform)",
  "caps.platform.mcp.use.desc": "A Sendly MCP szerver platform-ágának használata: minden terem olvasása kiegészítő-státusztól függetlenül, plusz a platform-eszközök",
  "caps.platform.gym.editAddons.label": "Kiegészítők kezelése",
  "caps.platform.gym.editAddons.desc": "Fizetős kiegészítő (pl. MCP) be- vagy kikapcsolása egy teremben, és a kiegészítő-napló megtekintése",

  // ── Permission system: UI strings ──
  "permissions.modalTitle": "Jogosultságok",
  "permissions.requires": "Feltétele: {caps}",
  "permissions.cannotGrant": "Nincs jogod ezt a jogosultságot adni — neked sincs meg",
  "permissions.save": "Mentés",
  "permissions.cancel": "Mégse",

  // ── Audit log (unified: permission changes + membership events) ──
  "audit.title": "Audit napló",
  "audit.filter.all": "Mind",
  "audit.filter.permission": "Jogosultság",
  "audit.filter.membership": "Tagság",
  "audit.filter.routes": "Útvonalak",
  "audit.entry.permissionChange": "Jogosultság módosítás",
  "audit.entry.routeCreate": "Útvonal létrehozva",
  "audit.entry.routeUpdate": "Útvonal módosítva",
  "audit.entry.routeDelete": "Útvonal törölve",
  "audit.entry.routeUnnamed": "(névtelen útvonal)",
  "audit.entry.memberJoin": "Csatlakozott",
  "audit.entry.memberKick": "Eltávolítva",
  "audit.entry.memberBan": "Kitiltás",
  "audit.entry.memberUnban": "Kitiltás feloldva",
  "audit.entry.memberLeave": "Kilépett",
  "audit.entry.memberAccountDeleted": "Fiók törölve",
  "audit.entry.selfDelete": "Fiók törölve",
  "audit.entry.nameReset": "Név visszaállítva",
  "audit.entry.nameUnban": "Feloldva a tiltólistáról",
  "audit.entry.platformBan": "Platform tiltás",
  "audit.entry.platformUnban": "Platform feloldás",
  "audit.entry.gymCreate": "Terem létrehozva (AI-n át)",
  "audit.entry.gymSetupUpdate": "Terem-beállítás (AI-n át)",
  "audit.gymCreateAdmin": "Admin: {name}",
  "audit.gymSetupFields": "Módosítva: {fields}",
  "audit.entry.deletedData": "Törölt: {ascents} megmászás, {ratings} értékelés",
  // Verseny / esemény létezés-események a terem naplójában
  "audit.filter.programs": "Versenyek és események",
  "audit.entry.competitionCreate": "Verseny létrehozva",
  "audit.entry.competitionDelete": "Verseny törölve",
  "audit.entry.eventCreate": "Esemény létrehozva",
  "audit.entry.eventDelete": "Esemény törölve",
  "audit.entry.unnamedEntity": "(névtelen)",
  "audit.filter.spray": "Spraywall",
  "audit.entry.sprayProblemDelete": "Spray út törölve",
  "audit.entry.sprayProblemEdit": "Spray út módosítva",
  "audit.entry.sprayProblemHide": "Spray út elrejtve",
  "audit.entry.sprayProblemUnhide": "Spray út visszaállítva",
  "audit.entry.sprayBenchmark": "Benchmark lett",
  "audit.entry.sprayUnbenchmark": "Benchmark levéve",
  "audit.entry.sprayWallDelete": "Spray fal törölve",
  "audit.entry.sprayWallPublish": "Spray fal élesítve",
  "audit.entry.sprayWallRepublish": "Régi verzió újra élesítve",
  "audit.entry.sprayWallDiscard": "Spray piszkozat elvetve",
  "audit.spray.problemMeta": "Szerző: {author} · Fal: {wall}",
  "audit.spray.problemMetaNoWall": "Szerző: {author}",
  "audit.spray.version": "Verzió: {label}",
  "audit.spray.field.footRule": "Láb-szabály",
  "audit.spray.field.tags": "Címkék",
  "audit.spray.descriptionChanged": "Leírás módosítva",
  "audit.spray.holdsChanged": "Fogások módosítva",
  // Út-módosítás diff-chipek: a mezőnév és az érték is fordítva megy ki, mert a
  // naplót terem-adminok olvassák, nem a Firestore mezőnevek szerzői.
  "audit.field.name": "Név",
  "audit.field.difficulty": "Nehézség",
  "audit.field.holdColor": "Fogás szín",
  "audit.field.active": "Állapot",
  "audit.field.discipline": "Diszciplína",
  "audit.value.active": "Aktív",
  "audit.value.archived": "Archivált",

  // ── Szervezői műveleti napló (verseny + esemény) ──
  "events.editor.tabLog": "Napló",
  "events.editor.tabLog.short": "Napló",
  "opsLog.tabJudge": "Bírói",
  "opsLog.tabOps": "Szervezői",
  "opsLog.empty": "Még nincs bejegyzés.",
  "opsLog.emptyFiltered": "Ehhez a szűréshez nincs bejegyzés.",
  "opsLog.denied": "Ehhez a naplóhoz nincs jogosultságod.",
  "opsLog.loadMore": "Mutass többet",
  "opsLog.filterAuthor": "Minden szerkesztő",
  "opsLog.systemActor": "Rendszer",
  "opsLog.unknownActor": "Ismeretlen",
  "opsLog.bulkNote": "{n} résztvevőt érintett egy műveletben",
  "opsLog.filter.all": "Mind",
  "opsLog.filter.money": "Fizetés",
  "opsLog.filter.role": "Szerepkör",
  "opsLog.filter.roster": "Nevezések",
  "opsLog.filter.setup": "Beállítás",
  "opsLog.cascade.memberRemoved": "A tag eltávolítása miatt",
  "opsLog.cascade.memberKicked": "A tagot kirúgták a teremből",
  "opsLog.cascade.memberBanned": "A tagot kitiltották a teremből",
  "opsLog.cascade.platformBanned": "A felhasználót platform szinten tiltották",
  "opsLog.cascade.memberLeft": "A tag kilépett a teremből",
  "opsLog.cascade.accountDeleted": "A felhasználó törölte a fiókját",
  "opsLog.type.comp.activate": "Aktiválva",
  "opsLog.type.comp.close": "Lezárva",
  "opsLog.type.comp.reopen": "Lezárás visszavonva",
  "opsLog.type.comp.settings": "Beállítás",
  "opsLog.type.comp.attemptsLock": "Rögzítés zárolása",
  "opsLog.type.comp.tvToken": "TV token",
  "opsLog.type.group.create": "Csoport létrehozva",
  "opsLog.type.group.update": "Csoport módosítva",
  "opsLog.type.group.delete": "Csoport törölve",
  "opsLog.type.session.create": "Session létrehozva",
  "opsLog.type.session.update": "Session módosítva",
  "opsLog.type.session.delete": "Session törölve",
  "opsLog.type.session.start": "Session indítva",
  "opsLog.type.session.pause": "Session szüneteltetve",
  "opsLog.type.session.resume": "Session folytatva",
  "opsLog.type.session.finish": "Session befejezve",
  "opsLog.type.session.restart": "Session újraindítva",
  "opsLog.type.session.attemptsLock": "Session zárolása",
  "opsLog.type.session.finalsPhase": "Döntő fázis",
  "opsLog.type.reg.join": "Nevezés",
  "opsLog.type.reg.leave": "Nevezés törölve",
  "opsLog.type.reg.role": "Szerepkör",
  "opsLog.type.reg.paid": "Fizetés",
  "opsLog.type.reg.move": "Átsorolva",
  "opsLog.type.reg.submit": "Eredmény beadva",
  "opsLog.type.reg.startNumber": "Rajtszám",
  "opsLog.type.reg.edit": "Adat módosítva",
  "opsLog.type.guest.create": "Vendég felvéve",
  "opsLog.type.guest.update": "Vendég módosítva",
  "opsLog.type.guest.delete": "Vendég törölve",
  "opsLog.type.event.publish": "Közzétéve",
  "opsLog.type.event.close": "Lezárva",
  "opsLog.type.event.cancel": "Lemondva",
  "opsLog.type.event.settings": "Beállítás",
  "opsLog.type.event.organizers": "Szervezők",
  "opsLog.type.part.join": "Jelentkezés",
  "opsLog.type.part.cancel": "Lemondva",
  "opsLog.type.part.rejoin": "Újra jelentkezett",
  "opsLog.type.part.delete": "Résztvevő törölve",
  "opsLog.type.part.paid": "Fizetés",
  "opsLog.type.part.move": "Átsorolva",
  "opsLog.type.part.edit": "Adat módosítva",
  "opsLog.type.waitlist.join": "Várólistára került",
  "opsLog.type.waitlist.promote": "Várólistáról behívva",
  "opsLog.type.waitlist.decline": "Várólista elutasítva",
  "opsLog.type.waitlist.leave": "Lelépett a várólistáról",
  "opsLog.type.waitlist.edit": "Várólista módosítva",
  "opsLog.field.name": "Név",
  "opsLog.field.status": "Állapot",
  "opsLog.field.type": "Típus",
  "opsLog.field.settings": "Beállítások módosultak",
  "opsLog.field.rules": "Szabályzat módosult",
  "opsLog.field.description": "Rövid leírás módosult",
  "opsLog.field.longDescription": "Hosszú leírás módosult",
  "opsLog.field.startDate": "Kezdés",
  "opsLog.field.endDate": "Befejezés",
  "opsLog.field.registrationStart": "Nevezés nyitás",
  "opsLog.field.registrationDeadline": "Nevezési határidő",
  "opsLog.field.registrationClosed": "Nevezés zárva",
  "opsLog.field.guestMode": "Vendég mód",
  "opsLog.field.allowGuests": "Vendégek",
  "opsLog.field.proxyGuestLimit": "Vendég/fő limit",
  "opsLog.field.discipline": "Szakág",
  "opsLog.field.externalUrl": "Külső link",
  "opsLog.field.coverImageUrl": "Borítókép",
  "opsLog.field.organizerContact": "Rendező elérhetősége módosult",
  "opsLog.field.attemptsLocked": "Rögzítés zárolva",
  "opsLog.field.tvToken": "TV token",
  "opsLog.field.participation": "Részvétel",
  "opsLog.field.excludedUsers": "Kizárt mászók módosultak",
  "opsLog.field.excludedRoutes": "Kizárt utak módosultak",
  "opsLog.field.entryFeePaid": "Fizetett",
  "opsLog.field.paidAmount": "Befizetett összeg",
  "opsLog.field.paymentMethod": "Fizetési mód",
  "opsLog.field.role": "Szerepkör",
  "opsLog.field.isOrganizer": "Szervező",
  "opsLog.field.groupId": "Csoport",
  "opsLog.field.sessionId": "Session",
  "opsLog.field.sessionIds": "Bírói sessionök módosultak",
  "opsLog.field.submissionStatus": "Beadás",
  "opsLog.field.startNumber": "Rajtszám",
  "opsLog.field.displayName": "Név",
  "opsLog.field.birthYear": "Születési év",
  "opsLog.field.club": "Klub",
  "opsLog.field.notes": "Megjegyzés",
  "opsLog.field.mode": "Mód",
  "opsLog.field.order": "Sorrend",
  "opsLog.field.color": "Szín",
  "opsLog.field.entryFeeAmount": "Nevezési díj",
  "opsLog.field.maxAttempts": "Max. próba",
  "opsLog.field.ageMin": "Min. életkor",
  "opsLog.field.ageMax": "Max. életkor",
  "opsLog.field.sortIndex": "Sorrend",
  "opsLog.field.maxDifficulty": "Legnehezebb szint módosult",
  "opsLog.field.groupIds": "Csoportok módosultak",
  "opsLog.field.startTime": "Kezdés",
  "opsLog.field.durationMinutes": "Hossz (perc)",
  "opsLog.field.maxParticipants": "Max. résztvevő",
  "opsLog.field.finals.phase": "Döntő fázis",
  "opsLog.field.capacity": "Létszám",
  "opsLog.field.waitlistEnabled": "Várólista",
  "opsLog.field.autoPromoteFromWaitlist": "Automatikus behívás",
  "opsLog.field.entryFee": "Nevezési díj módosult",
  "opsLog.field.schedule": "Program módosult",
  "opsLog.field.coaches": "Edzők módosultak",
  "opsLog.field.organizers": "Szervezők módosultak",
  "opsLog.field.groups": "Csoportok módosultak",
  "opsLog.field.ageGroups": "Korosztályok módosultak",
  "opsLog.field.fullyPaid": "Teljesen fizetett",
  "opsLog.field.paidAt": "Fizetés ideje",
  "opsLog.field.paymentNote": "Fizetési megjegyzés módosult",
  "opsLog.field.allergies": "Allergia módosult",
  "opsLog.field.medicalNotes": "Orvosi megjegyzés módosult",
  "opsLog.field.parentName": "Szülő neve módosult",
  "opsLog.field.parentPhone": "Szülő telefon módosult",
  "opsLog.field.parentEmail": "Szülő e-mail módosult",
  "opsLog.field.parentalConsent": "Szülői hozzájárulás",
  "admin.auditLogEmpty": "Még nincs bejegyzés a naplóban.",
  "admin.auditLogError": "A napló betöltése nem sikerült. Lehet, hogy nincs jogosultságod a napló megtekintéséhez.",
  "admin.auditLogLoadMore": "Korábbi bejegyzések betöltése",
  "platformAdmin.auditLogTitle": "Platform audit napló",
  "platformAdmin.auditLogEmpty": "Még nincs platform szintű audit bejegyzés.",
  "platformAdmin.billingTitle": "Negyedéves számlázás",
  "platformAdmin.billingSub": "Email + CSV összefoglaló minden új negyedévben",
  "platformAdmin.billingScheduleTitle": "Időzítés",
  "platformAdmin.billingScheduleBody": "A negyedéves számlázási összefoglaló minden új negyedév első napján (január 1., április 1., július 1., október 1.) reggel 08:00-kor megy ki magyar idő szerint, az alább felsorolt címzettekre. Az emailben szerepel egy összesítő táblázat termenként + egy részletes CSV melléklet (cégnév, adószám, cím, fizetendő összeg).",
  "platformAdmin.billingRecipientsTitle": "Címzettek",
  "platformAdmin.billingRecipientsHint": "A negyedéves összefoglaló KIZÁRÓLAG az itt felsorolt címekre megy ki — a platform adminok automatikusan nem kapják meg. A címke csak ezen a felületen látszik, a levélbe nem kerül bele. Legfeljebb {max} cím.",
  "platformAdmin.billingRecipientsEmpty": "Nincs egyetlen címzett sem, így a negyedéves összefoglaló nem megy ki senkinek.",
  "platformAdmin.billingRecipientsEmailPlaceholder": "email@pelda.hu",
  "platformAdmin.billingRecipientsLabelPlaceholder": "Címke (pl. könyvelő)",
  "platformAdmin.billingRecipientsAdd": "Hozzáadás",
  "platformAdmin.billingRecipientsRemove": "Címzett törlése",
  "platformAdmin.billingRecipientsInvalid": "Érvénytelen email cím.",
  "platformAdmin.billingRecipientsLimit": "Legfeljebb {max} címzett lehet a listán.",
  "platformAdmin.billingCoverageTitle": "Számlázási adatok lefedettsége",
  "platformAdmin.billingCoverageReady": "Számlázható",
  "platformAdmin.billingCoverageMissing": "Hiányos",
  "platformAdmin.billingCoverageTotal": "Összes terem",
  "platformAdmin.billingCoverageHint": "A hiányos termeknél a terem admin a Beállítások → Előfizetés és Számlázás panelen tudja megadni a cégnevet és adószámot. A negyedéves email kiküldhető, a hiányos sorok piros „MISSING” tag-gel jelennek meg.",
  "platformAdmin.billingTestTitle": "Teszt email küldése",
  "platformAdmin.billingTestHint": "A jelenlegi adatokkal és az ELŐZŐ negyedévre számolva küld egy teszt összefoglalót csak neked. Nem érinti a soron következő igazi negyedéves küldést.",
  "platformAdmin.billingTestButton": "Teszt email küldése magamnak",
  "platformAdmin.billingTestSending": "Küldés…",
  "platformAdmin.billingTestSent": "Teszt elküldve ide: {email} — {quarter}, {gyms} számlázandó terem ({missing} hiányos, {zero} kihagyva 0 Ft-tal).",
  "platformAdmin.billingHistoryTitle": "Korábbi negyedéves küldések",
  "platformAdmin.billingHistoryEmpty": "Még nem futott le negyedéves küldés.",
  "platformAdmin.billingHistoryRecipients": "{sent}/{total} címzett",
  "platformAdmin.billingHistoryGyms": "{gyms} terem · {missing} hiányos",
  "platformAdmin.billingHistoryNoRecipients": "Nem volt címzett",
  "platformAdmin.billingHistoryManual": "Kézi CSV — nem volt kiküldés",
  "platformAdmin.selfDeleteCascade": "{gyms} terem · {ascents} megmászás, {ratings} értékelés, {friendships} kapcsolat törölve",
  "audit.roleChange": "szerepkör",
  "audit.blocked": "blokk",

  // ── Member ban (admin-side) ──
  "ban.modal.title": "Tag kitiltása",
  "ban.modal.titleKick": "Tag kirúgása",
  "ban.modal.titlePlatform": "Platform-tiltás",
  "ban.modal.actionLabel": "Művelet",
  "ban.modal.optKick": "Kirúgás",
  "ban.modal.optBan": "Kitiltás",
  "ban.modal.kickDesc": "Eltávolítja a teremből és törli az itteni megmászásait/értékeléseit — de bármikor újra beléphet.",
  "ban.modal.banDesc": "Eltávolítja ÉS blokkolja az újra-belépést (indokot lát). Az itteni megmászásai/értékelései törlődnek.",
  "ban.modal.warning": "Ez a művelet törli a tag minden megmászását és értékelését ebben a teremben. A verseny eredmények érintetlenek maradnak. A tag nem tud újra csatlakozni a teremhez.",
  "ban.modal.warningKick": "Ez eltávolítja a tagot ebből a teremből, és törli az itteni megmászásait és értékeléseit. A versenyeredmények érintetlenek maradnak. Később bármikor újra beléphet.",
  "ban.modal.warningPlatform": "Ez kizárja a felhasználót az EGÉSZ Sendly platformról, ÉS törli a megmászásait és értékeléseit MINDEN teremben. A versenyeredmények érintetlenek maradnak. A terem-tagságai megmaradnak — a feloldás visszaadja a hozzáférést, de a törölt adatokat NEM.",
  "ban.modal.confirmButtonKick": "Kirúgás",
  "ban.modal.reasonLabel": "Indok (kötelező)",
  "ban.modal.reasonUserWillSee": "A tag látni fogja ezt az indokot a kitiltási képernyőn.",
  "ban.modal.reasonPlaceholder": "Pl. Házirend megsértése, fizetési vita, ...",
  "ban.modal.reasonTooShort": "Az indok legalább 3 karakter kell legyen",
  "ban.modal.reasonTooLong": "Az indok maximum 500 karakter lehet",
  "ban.modal.confirmLabel": "Írd be: \"{word}\" a megerősítéshez",
  "ban.modal.confirmButton": "Tag kitiltása",
  "ban.modal.error.lastAdmin": "Nem tilthatod ki az utolsó admint a teremből",
  "ban.modal.error.self": "Önmagadat nem tilthatod ki",
  "ban.modal.error.platformAdmin": "Platform admin nem tiltható ki",
  "ban.modal.error.generic": "Hiba történt a kitiltás során",
  "ban.unban.confirm": "Feloldod {name} tiltását? A korábban törölt megmászások és értékelések NEM jönnek vissza.",
  "ban.button.label": "Kitiltás",
  "ban.unban.button.label": "Tiltás feloldása",
  "ban.badge": "Kitiltva",
  "ban.tooltip": "Kitiltva: {date}\nIndok: {reason}",

  // ── Banned user full-screen view ──
  "banned.title": "Ki vagy tiltva ebből a teremből",
  "banned.reasonLabel": "Indok",
  "banned.dateLabel": "Tiltás dátuma",
  "banned.contactHint": "Ha tévedésnek gondolod, vedd fel a kapcsolatot a teremmel:",
  "banned.backToSelector": "Vissza a teremválasztóhoz",
  "banned.platformTitle": "Ki vagy tiltva a Sendly-ről",
  "banned.platformSub": "A Sendly platformhoz való hozzáférésedet felfüggesztették.",
  "banned.logout": "Kijelentkezés",

  // ── Events (camps, workshops) ──
  "capCategory.events": "Események",
  "caps.events.manage.label": "Események kezelése",
  "caps.events.manage.desc": "Események létrehozása, szerkesztése, törlése, résztvevők kezelése",
  "caps.events.checkIn.label": "Jelenléti ív",
  "caps.events.checkIn.desc": "Résztvevők jelenlétének rögzítése",

  "events.tab": "Események",
  "events.tab.short": "Esem.",
  "events.sectionHeading": "Táborok & Workshopok",
  "events.competitionsHeading": "Versenyek",
  "events.empty": "Nincs esemény",
  "events.create": "+ Új esemény",
  "events.filter.active": "Aktív",
  "events.filter.closed": "Lezárt",
  "events.filter.draft": "Vázlat",
  "events.filter.all": "Mind",
  "events.edit": "Szerkesztés",
  "events.delete": "Törlés",
  "events.deleteConfirm": "Biztosan törlöd a(z) \"{name}\" eseményt és minden hozzá tartozó adatot?",
  "events.past": "Korábbi események",
  "events.manage": "Szerkesztés",
  "events.closeEditor": "Bezárás",
  "events.checkInOpen": "Jelenlét",
  "events.publish": "Publikálás",
  "events.unpublish": "Leállítás",
  "events.unpublishConfirm": "Biztosan leállítod a(z) \"{name}\" eseményt? Visszakerül vázlat állapotba.",
  "events.noEvents": "Nincs esemény",
  "events.overview": "Áttekintés",
  "events.menu.export": "Export",
  "events.menu.other": "Egyéb",
  "events.template.copy.btnLabel": "Másolás sablonként",
  "events.template.copy.downloadLabel": "Letöltés .json-ként",
  "events.template.copy.copied": "Esemény-sablon a vágólapra másolva",
  "events.template.copy.failed": "Nem sikerült a sablont elkészíteni.",
  "events.template.paste.btnLabel": "📋 Beillesztés sablonból",
  "events.template.paste.title": "Esemény létrehozása sablonból",
  "events.template.paste.intro": "Illessz be egy másik eseményből másolt sablont. A beállítások, a csoportok és a program jönnek át — résztvevők, edzők, szervezők és a regisztrációs határidők nem.",
  "events.template.paste.nameLabel": "Az új esemény neve",
  "events.template.paste.startDateLabel": "Kezdőnap",
  "events.template.paste.startDateHint": "A záró nap és a program napjai ehhez igazodnak ({n} napos esemény).",
  "events.template.paste.previewTitle": "Amit a sablon tartalmaz",
  "events.template.paste.previewCounts": "{groups} csoport · {days} programnap · {slots} idősáv",
  "events.template.paste.previewSource": "Forrás: {gym}",
  "events.template.paste.previewExcluded": "Nem jön át: résztvevők, edzők (az idősávokból sem), szervezők, a rendező elérhetősége, a borítókép, a regisztrációs és a lemondási határidő. Az esemény piszkozatként jön létre.",
  "events.template.paste.warningsTitle": "Figyelmeztetések ({n})",
  "events.template.paste.warnUnknownGroupKey": "A(z) {day}. programnap egyik idősávja ismeretlen csoportra hivatkozik: {key} — kihagyva.",
  "events.template.paste.warnDuplicateGroupKey": "Ismétlődő csoport-kulcs: {key} — a második új kulcsot kapott.",
  "events.template.paste.warnGroupNoName": "A(z) {n}. csoportnak nincs neve — kihagyva.",
  "events.template.paste.warnGroupsTruncated": "{n} csoport a limit fölött — kihagyva.",
  "events.template.paste.warnDaysTruncated": "{n} programnap a limit fölött — kihagyva.",
  "events.template.paste.warnSlotsTruncated": "A(z) {day}. programnapon {n} idősáv a limit fölött — kihagyva.",
  "events.template.paste.createBtn": "Létrehozás",
  "events.template.paste.importing": "Létrehozás…",
  "events.template.paste.doneTitle": "Az esemény létrejött",
  "events.template.paste.doneNextSteps": "Az esemény piszkozat állapotban van. Állítsd be a regisztrációs határidőket, és rendeld hozzá az edzőket az idősávokhoz, mielőtt publikálod.",
  "events.template.paste.openEditor": "Megnyitás",
  "events.template.paste.errorImportFailed": "Hiba történt a létrehozás során: {message}",
  "events.template.paste.error_empty": "A mező üres — illessz be egy sablont.",
  "events.template.paste.error_notJson": "A beillesztett szöveg nem érvényes JSON.",
  "events.template.paste.error_notTemplate": "A beillesztett szöveg nem Sendly esemény-sablon.",
  "events.template.paste.error_wrongKind": "Ez nem esemény-sablon. Egy verseny-sablont a Versenyek panelen tudsz beilleszteni.",
  "events.template.paste.error_futureVersion": "Ez a sablon egy újabb verzióval készült. Frissítsd az alkalmazást.",
  "events.template.paste.error_noContent": "A sablon nem tartalmaz eseménynevet.",

  // Event card
  "events.card.cancelled": "Lemondva",
  "events.card.kicker": "Esemény",
  "events.card.row.registration": "Jelentkezés",
  "events.card.row.fee": "Regisztrációs díj",
  "events.card.row.spotsValue": "{current} / {max} hely betöltve",
  "events.card.manageBar": "Szervező",
  "events.feeStatus.paid": "{paid} rendezve",
  "events.feeStatus.partial": "{paid} / {total}",
  "events.feeStatus.unpaid": "{amount} — fizetésre vár",
  "events.card.unlisted": "Nem listázott",

  // Editor tabs
  "events.editor.title": "Esemény szerkesztése",
  "events.editor.titleNew": "Új esemény létrehozása",
  "events.editor.tabBasic": "Alapadatok",
  "events.editor.tabBasic.short": "Alap",
  "events.editor.tabGroups": "Csoportok",
  "events.editor.tabGroups.short": "Csop.",
  "events.editor.tabSchedule": "Program",
  "events.editor.tabSchedule.short": "Prog.",
  "events.editor.tabCoaches": "Edzők",
  "events.editor.tabCoaches.short": "Edzők",
  "events.editor.tabOrganizers": "Szervezők",
  "events.editor.tabOrganizers.short": "Szerv.",
  "events.editor.tabSettings": "Beállítások",
  "events.editor.tabSettings.short": "Beáll.",
  "events.editor.tabParticipants": "Résztvevők",
  "events.editor.tabParticipants.short": "Részt.",
  "events.editor.tabWaitlist": "Várólista",
  "events.editor.tabWaitlist.short": "Vár.",
  "events.editor.tabAttendance": "Jelenlét",
  "events.editor.tabAttendance.short": "Jelen.",
  "events.editor.name": "Esemény neve",
  "events.editor.description": "Rövid leírás",
  "events.editor.descriptionHint": "Egy-két mondat — ez látszik fixen a kártyákon",
  "events.editor.longDescription": "Részletes leírás",
  "events.editor.longDescriptionHint": "A teljes kiírás — a kártyákon alapból összecsukva jelenik meg",
  "events.editor.coverImage": "Borítókép",
  "events.editor.coverHint": "Ajánlott: 1200×400 px · Max 5 MB · JPG, PNG, WebP",
  "events.editor.startDate": "Kezdés dátuma",
  "events.editor.endDate": "Befejezés dátuma",
  "events.editor.dailyStartTime": "Napi kezdés",
  "events.editor.dailyEndTime": "Napi zárás",
  "events.editor.registrationStart": "Regisztráció kezdete",
  "events.editor.registrationDeadline": "Regisztráció határidő",
  "events.editor.cancellationDeadline": "Lemondási határidő",
  "events.editor.saved": "Mentve!",
  "events.editor.endBeforeStart": "A befejezés nem lehet korábban a kezdésnél",
  "events.editor.nameRequired": "A név kötelező",

  // Groups tab
  "events.groups.add": "+ Csoport",
  "events.groupCount": "{n} csoport",
  "events.groups.name": "Csoport neve",
  "events.groups.max": "Max létszám",
  "events.groups.ageMin": "Kor min.",
  "events.groups.ageMax": "Kor max.",
  "events.groups.description": "Leírás (opcionális)",
  "events.groups.totalCapacity": "Összesen: {count} hely",
  "events.groups.empty": "Még nincs csoport. Hozz létre legalább egyet.",
  "events.groups.deleteConfirm": "Törlöd a csoportot? {count} résztvevő van benne — ők csoport nélkül maradnak.",
  "events.groups.hasRegistrants": "({count} fő)",

  // Schedule tab
  "events.schedule.generateDays": "Napok generálása",
  "events.schedule.generateConfirm": "Új napi blokkok létrehozása a dátumtartomány alapján? (Meglévő napok nem törlődnek.)",
  "events.schedule.addSlot": "+ Idősáv",
  "events.schedule.slotStart": "Kezdés",
  "events.schedule.slotEnd": "Vége",
  "events.schedule.slotTitle": "Cím",
  "events.schedule.slotDescription": "Leírás",
  "events.schedule.slotLocation": "Helyszín",
  "events.schedule.slotCoaches": "Edzők",
  "events.schedule.slotGroups": "Csoportok",
  "events.schedule.allGroups": "Mindenki",
  "events.schedule.empty": "Nincs program. Állítsd be a dátumokat, majd kattints a 'Napok generálása' gombra.",
  "events.schedule.dayTitle": "Nap címe",
  "events.schedule.dayDescription": "Nap leírása",
  "events.schedule.deleteSlot": "Idősáv törlése",
  "events.schedule.overlapWarning": "Ez az idősáv átfed egy másikkal",

  // Coaches tab
  "events.coaches.add": "+ Edző hozzáadása",
  "events.coaches.role": "Szerep",
  "events.coaches.rolePlaceholder": "pl. Főedző",
  "events.coaches.remove": "Eltávolítás",
  "events.coaches.empty": "Még nincs edző hozzárendelve",
  "events.coaches.pickTitle": "Edző kiválasztása",
  "events.organizers.add": "+ Szervező hozzáadása",
  "events.organizers.remove": "Szervező eltávolítása",
  "events.organizers.empty": "Még nincs szervező hozzárendelve",
  "events.organizers.pickTitle": "Szervező kiválasztása",

  // Settings tab
  "events.settings.entryFee": "Regisztrációs díj",
  "events.settings.entryFeeEnabled": "Regisztrációs díj aktív",
  "events.settings.entryFeeAmount": "Összeg",
  "events.settings.entryFeeCurrency": "Pénznem",
  "events.settings.entryFeeNote": "Megjegyzés",
  "events.settings.entryFeeNotePlaceholder": "pl. Helyszínen készpénzzel fizetendő",
  "events.settings.allowGuests": "Vendég résztvevők engedélyezése (csak admin)",
  "events.settings.allowProxy": "Proxy regisztráció engedélyezése (szülő regisztrálja a gyereket)",
  "events.settings.proxyLimit": "Proxy limit (fő/felhasználó)",
  "events.settings.requireMinorData": "Születési év és kiskorú adatok bekérése",
  "events.settings.requireMinorDataHint": "Mindenkitől kérjük a születési évet, és megadhat allergiát. A szülő adatai és a hozzájárulás csak attól kötelezőek, aki az esemény évében 18 alatti.",
  "events.settings.waitlistEnabled": "Várólista engedélyezése",
  "events.settings.autoPromoteFromWaitlist": "Automatikus előléptetés lemondáskor",
  "events.settings.status": "Státusz",
  "events.settings.visibility": "Láthatóság",

  // Participants tab
  "events.participants.addUser": "+ Résztvevő hozzáadása",
  "events.participants.addGuest": "+ Vendég hozzáadása",
  "events.participants.empty": "Még nincs regisztrált résztvevő",
  "events.participants.alreadyRegistered": "Már regisztrálva",
  "events.participants.searchPlaceholder": "Keresés név vagy email...",
  "events.participants.pickGroup": "Melyik csoportba?",
  "events.participants.groupCapacity": "{used}/{max}",
  "events.participants.groupUnlimited": "{used} fő",
  "events.participants.groupFull": "Betelt",
  "events.participants.removeConfirm": "Biztosan eltávolítod a résztvevőt?",
  "events.participants.paymentPrompt": "Add meg a fizetett összeget:",
  "events.participants.guestBadge": "Vendég",
  "events.participants.unassigned": "(Csoport nélkül)",
  "events.participants.remove": "Eltávolítás",

  // Guest modal
  "events.guest.name": "Név",
  "events.guest.save": "Hozzáadás",

  // Waitlist tab
  "events.waitlist.empty": "Nincs várólistán senki",
  "events.waitlist.promote": "Előléptetés",
  "events.waitlist.decline": "Elutasítás",
  "events.waitlist.join": "Várólistára feliratkozás",
  "events.waitlist.joined": "Várólistára feliratkozva",
  "events.waitlist.waitingSince": "Feliratkozva: {date}",
  "events.waitlist.promoteConfirm": "Előlépteted {name} résztvevőt a várólistáról?",
  "events.waitlist.groupFullWarning": "A csoport tele van. Az előléptetés növeli a létszámot.",
  "events.waitlist.declineConfirm": "Elutasítod a jelentkezést?",

  // Attendance tab
  "events.attendance.present": "Jelen",
  "events.attendance.summary": "{present} / {total} jelen",
  "events.attendance.print": "Jelenléti ív nyomtatás",
  "events.attendance.noParticipants": "Nincs résztvevő erre a napra",
  "events.attendance.markAllPresent": "Mindenkit jelöl",
  "events.attendance.markAllAbsent": "Mindenkit töröl",
  "events.attendance.noDays": "Az esemény nem tartalmaz napokat",
  "events.attendance.saveFailed": "A jelenlét mentése nem sikerült",
  "events.attendance.pdfBirth": "Sz.év",
  "events.attendance.pdfParent": "Szülő",
  "events.attendance.pdfPhone": "Telefon",
  "events.attendance.pdfSignature": "Aláírás",

  // Registration
  "events.register": "Jelentkezés",
  "events.registerChild": "+ Vendég jelentkeztetése",
  "events.cancel": "Lemondás",
  "events.changeRegistration": "Módosítás",
  "events.updateRegistration": "Regisztráció módosítása",
  "events.cancelConfirmTitle": "Jelentkezés lemondása",
  "events.cancelConfirm": "Biztosan lemondod a részvételed?",
  "events.cancelDeadlinePassed": "A lemondási határidő lejárt",
  "events.unregister.paidBlock": "Nem vonhatod vissza a regisztrációt, mert van befizetett összeg. Kérjük, keresd az esemény szervezőjét!",
  "events.groupFull": "Ez a csoport betelt",
  "events.regClosedTitle": "A regisztráció lezárult",
  "events.regNotYetOpenTitle": "A jelentkezés még nem nyitott",
  "events.selectGroup": "Válassz csoportot",
  "events.freeSlots": "{count} szabad hely",
  "events.fullSlots": "Betelt",

  // Proxy
  "events.proxy.title": "Vendég regisztrálása",
  "events.proxy.childName": "Vendég neve",
  "events.proxy.childNameMissing": "A vendég nevét add meg",
  "events.proxy.count": "{current} / {max} vendég regisztrálva",
  "events.proxy.limit": "Elérted a limitet ({max})",
  "events.proxy.consent": "Hozzájárulok a vendég részvételéhez (kiskorú esetén szülőként)",
  "events.proxy.consentRequired": "A hozzájárulás kötelező",
  "events.proxy.myChildren": "Saját regisztrált vendégek:",

  // Minor data
  "events.minor.birthYear": "Születési év",
  "events.minor.birthYearInvalid": "Adj meg egy érvényes születési évet ({min}–{max})",
  "events.minor.birthYearMissing": "Születési év kötelező",
  "events.age.tooYoung": "Túl fiatal ehhez a korosztályhoz",
  "events.age.tooOld": "Túl idős ehhez a korosztályhoz",
  "events.age.birthYearRequired": "Ehhez a korosztályhoz kötelező megadni a születési évet",
  "events.age.birthYearMissingHint": "Add meg a születési évedet a beállításokban a korosztályos nevezéshez",
  "events.minor.parentNameMissing": "Szülő neve kötelező",
  "events.minor.parentPhoneMissing": "Szülő telefonszáma kötelező",
  "events.minor.allergies": "Ismert allergiák",
  "events.minor.medicalNotes": "Egészségügyi megjegyzések",
  "events.minor.parentName": "Szülő neve",
  "events.minor.parentPhone": "Szülő telefonszáma",
  "events.minor.parentEmail": "Szülő email",
  "events.minor.participantData": "Résztvevő adatai",
  "events.minor.birthYearHint": "Ebből derül ki, kell-e szülői hozzájárulás (18 év alatt).",
  "events.minor.guardianTitle": "Szülő / gondviselő adatai",
  "events.minor.guardianHint": "A résztvevő az esemény évében {age} éves, ezért ezek kötelezőek.",
  "events.contactLoadFailed": "A korábban megadott adatok nem tölthetők be, ezért a mentés most ki van kapcsolva.",

  // Billing
  "events.billing.exportExcel": "Számlázási lista (Excel)",
  "events.billing.exportPdf": "Számlázási lista (PDF)",
  "events.billing.pdfHeading": "Fizetők ({count})",
  "events.billing.pdfPayer": "Fizető",
  "events.billing.pdfPhone": "Telefon",
  "events.billing.pdfPersons": "Fő",
  "events.billing.notInvoice": "Ez a dokumentum nem számla.",
  "events.billing.xlsPaidFlag": "Fizetve (X)",
  "events.billing.participantsPaid": "{paid} / {total} résztvevő fizetett",
  "events.billing.disabled": "Regisztrációs díj nincs engedélyezve ezen az eseményen",
  "events.billing.unregisteredParent": "Nem regisztrált szülő",
  "events.billing.parentOnlyNoEdit": "Ennek a szülőnek nincs saját regisztrációja, ezért nem lehet itt fizetést rögzíteni. A fizetés a résztvevők tabon jelöltess.",
  "events.billing.totalExpected": "Várható",
  "events.billing.totalPaid": "Befizetett",
  "events.billing.outstanding": "Hátralék",
  "events.billing.filter.all": "Mind",
  "events.billing.filter.unpaid": "Nincs fizetve",
  "events.billing.filter.partial": "Részleges",
  "events.billing.filter.paid": "Fizetve",
  "events.editor.tabEntryFees": "Regisztrációs díjak",
  "events.editor.tabEntryFees.short": "Díjak",

  // Status / visibility
  "events.status.draft": "Vázlat",
  "events.status.published": "Publikált",
  "events.status.closed": "Lezárt",
  "events.status.cancelled": "Lemondva",
  "events.visibility.public": "Publikus",
  "events.visibility.unlisted": "Nem listázott (csak linkkel)",
  "events.visibility.unlistedHint": "Ez az esemény nem jelenik meg az eseménylistában. A résztvevők a direkt linkkel érhetik el.",
  "events.visibility.copyLink": "Link másolása",
  "events.visibility.linkCopied": "Link másolva!",
  "events.publishConfirm": "Publikálod az eseményt? Ezután látható lesz a tagok számára.",
  "events.closeConfirm": "Lezárod az eseményt?",

  // Program view (read-only for users)
  "events.programTitle": "Program",
  "events.coachesTitle": "Edzők",
  "events.groupsTitle": "Csoportok",

  // ── Sendly MCP szerver — hozzájárulási oldal (/oauth/authorize) ──
  // docs/spec/20-mcp-server.md "Consent page"
  "oauth.consent.notice": "A(z) {app} ({domain}) hozzáférést kér a Sendly-fiókodhoz. Az alkalmazás a lent felsorolt termek adatait olvashatja — és azokét is, ahol később kapsz ehhez jogot. Személyes adatot (nevet, e-mail címet, elérhetőséget) a Sendly nem ad ki. Amit az alkalmazásnak átadsz, azt a szolgáltatója a saját feltételei szerint kezeli — az ezért való felelősség a teremé. A kapcsolatot bármikor megszüntetheted: Beállítások → Kapcsolt AI-alkalmazások.",
  "oauth.consent.noticeWrite": "A bejelölt írási jogosultság(ok) alapján az alkalmazás rendkívüli nyitvatartást rögzíthet, illetve verseny-, kihívás-, sorozat- és esemény-piszkozatot hozhat létre.",
  "oauth.consent.gymWriteCheckbox": "Írási jogosultság engedélyezése ehhez a teremhez (rendkívüli nyitvatartás, piszkozatok létrehozása)",
  "oauth.consent.platformWriteCheckbox": "Írási jogosultság engedélyezése platform-szinten, minden teremre kiterjedően (a keretszerződés alapján)",
  "oauth.consent.gymsLabel": "Mely termekre vonatkozik",
  "oauth.consent.platformAccess": "Minden terem (platform-hozzáférés)",
  "oauth.consent.noGyms": "Nincs olyan terem, amelyre ez a hozzáférés vonatkozna.",
  "oauth.consent.emptyState": "Jelenleg egyetlen teremben sincs AI-kapcsolat jogosultságod, és platform-hozzáférésed sincs, ezért nincs mit engedélyezni.",
  "oauth.consent.deny": "Mégse",
  "oauth.consent.approve": "Engedélyezés",
  "oauth.consent.approving": "Engedélyezés…",
  "oauth.consent.error": "Nem sikerült feldolgozni a hozzáférési kérést. Ellenőrizd a linket, vagy próbáld újra.",
  "oauth.consent.errorTitle": "Hiba történt",
  "oauth.consent.unknownApp": "Ismeretlen alkalmazás",

  // ── Beállítások → Kapcsolt AI-alkalmazások (mcpApps) ──
  // docs/spec/13-settings.md "Connected AI apps (`mcpApps`)"
  "settings.mcpApps.title": "Kapcsolt AI-alkalmazások",
  "settings.mcpApps.sub": "OAuth-kapcsolatok és személyes tokenek",
  "settings.mcpApps.grantsTitle": "Kapcsolt alkalmazások",
  "settings.mcpApps.grantsDesc": "Az AI-asszisztensek és eszközök, amelyeknek hozzáférést adtál a Sendly-fiókodhoz.",
  "settings.mcpApps.patTitle": "Személyes hozzáférési tokenek",
  "settings.mcpApps.patDesc": "Szkriptekhez, n8n-hez, Claude Code-hoz — 90 nap után lejárnak.",
  "settings.mcpApps.noGrants": "Még nincs kapcsolt alkalmazásod.",
  "settings.mcpApps.loadError": "Nem sikerült betölteni a listát. Próbáld újra.",
  "settings.mcpApps.unnamed": "Névtelen alkalmazás",
  "settings.mcpApps.created": "Létrehozva",
  "settings.mcpApps.lastUsed": "Utoljára használva",
  "settings.mcpApps.neverUsed": "még nem",
  "settings.mcpApps.revoke": "Visszavonás",
  "settings.mcpApps.revokeConfirm": "Biztosan visszavonod a(z) {name} hozzáférését? A kapcsolat azonnal megszűnik.",
  "settings.mcpApps.revokeError": "A visszavonás nem sikerült. Próbáld újra.",
  "settings.mcpApps.newToken": "Új token létrehozása",
  "settings.mcpApps.tokenLabel": "Név",
  "settings.mcpApps.tokenLabelPlaceholder": "pl. n8n munkafolyamat",
  "settings.mcpApps.scopesLabel": "Jogosultságok",
  "settings.mcpApps.creating": "Létrehozás…",
  "settings.mcpApps.create": "Létrehozás",
  "settings.mcpApps.patError": "A token létrehozása nem sikerült. Próbáld újra.",
  "settings.mcpApps.tokenReadyFor": "A(z) „{label}” token elkészült",
  "settings.mcpApps.copyToken": "Másolás",
  "settings.mcpApps.tokenCopied": "Token vágólapra másolva",
  "settings.mcpApps.tokenCopyFailed": "A másolás nem sikerült",
  "settings.mcpApps.tokenWarning": "Ez az utolsó alkalom, hogy látod ezt a tokent — mentsd el biztonságos helyre.",

  // Admin panel — "AI-kapcsolat" (AdminMcpConnection.jsx), docs/spec/14b-admin-sections.md
  "admin.mcp.title": "AI-kapcsolat",
  "admin.mcp.statusActive": "Aktív",
  "admin.mcp.statusInactive": "Nem aktív",
  "admin.mcp.interested": "Érdekel",
  "admin.mcp.inactiveHint": "Ez egy fizetős kiegészítő. Írj nekünk, ha szeretnéd bekapcsolni a teremben.",
  "admin.mcp.legalNote": "A kiegészítő a keretszerződés 1. számú melléklete szerint működik. Az AI-alkalmazásnak átadott adatokért a terem felel; a Sendly személyes adatot ezen a felületen nem ad ki. Minden hívás 90 napig naplózódik — a naplót lent látod. A Sendly üzemeltetőinek hozzáférései is itt jelennek meg.",
  "admin.mcp.serverUrlLabel": "Szerver URL",
  "admin.mcp.copy": "Másolás",
  "admin.mcp.copied": "Másolva",
  "admin.mcp.guideTitle": "Hogyan kapcsold be",
  "admin.mcp.guideClaudeTitle": "Claude",
  "admin.mcp.guideChatgptTitle": "ChatGPT",
  "admin.mcp.guide.claude.step1": "Nyisd meg a Claude Beállítások → Connectors menüjét.",
  "admin.mcp.guide.claude.step2": "Kattints az „Egyedi connector hozzáadása” gombra, és illeszd be a fenti szerver URL-t.",
  "admin.mcp.guide.claude.step3": "Első használatkor a Claude átirányít a Sendly bejelentkezéshez és hozzájárulási oldalhoz — válaszd ki a termet és a kívánt jogosultságokat.",
  "admin.mcp.guide.claude.step4": "Ezután természetes nyelven kérdezhetsz a terem adatairól.",
  "admin.mcp.guide.chatgpt.step1": "Nyisd meg a ChatGPT Beállítások → Connectors menüjét.",
  "admin.mcp.guide.chatgpt.step2": "Adj hozzá egy új connectort, és illeszd be a fenti szerver URL-t.",
  "admin.mcp.guide.chatgpt.step3": "Kövesd a hozzájárulási folyamatot — jelentkezz be a Sendly fiókoddal, és add meg a kívánt jogosultságokat.",
  "admin.mcp.guide.chatgpt.step4": "Ezután természetes nyelven kérdezhetsz a terem adatairól.",
  "admin.mcp.writeToggleLabel": "Írás engedélyezése AI-n keresztül",
  "admin.mcp.writeToggleHint": "Rendkívüli nyitvatartás, valamint verseny-, kihívás-, sorozat- és esemény-piszkozat létrehozása AI-n át. Az olvasás mindig engedélyezett.",
  "admin.mcp.writeToggleError": "A kapcsoló mentése nem sikerült. Próbáld újra.",
  "admin.mcp.holdersTitle": "Kik jogosultak",
  "admin.mcp.holdersEmpty": "Senkinek nincs AI-kapcsolat jogosultsága.",
  "admin.mcp.holdersRead": "Olvasás",
  "admin.mcp.holdersWrite": "Írás",
  "admin.mcp.writeCapRequired": "A kapcsoló módosításához „AI-kapcsolat: írás” jogosultság kell.",
  "admin.mcp.usageTitle": "Használati napló (30 nap)",
  "admin.mcp.usageEmpty": "Még nincs naplózott hívás.",
  "admin.mcp.usageLoadError": "A napló betöltése nem sikerült.",
  "admin.mcp.usage.time": "Időpont",
  "admin.mcp.usage.user": "Felhasználó",
  "admin.mcp.usage.client": "Kliens",
  "admin.mcp.usage.tool": "Eszköz",
  "admin.mcp.usage.status": "Állapot",
  "admin.mcp.usage.rows": "Sorok",
  "admin.mcp.usage.ok": "Siker",
  "admin.mcp.usage.failed": "Hiba",
  "admin.mcp.usage.refused": "Elutasítva",
  "admin.mcp.usage.platformActor": "Sendly üzemeltető",
  "admin.mcp.usage.unknownUser": "Ismeretlen",

  // Kiegészítők (add-ons) — AdminSubscription "Kiegészítők" kártya, docs/spec/15b-plan-enforcement.md
  "addons.title": "Kiegészítők",
  "addons.active": "Aktív",
  "addons.inactive": "Nem aktív",
  "addons.interested": "Érdekel",
  "admin.spraywall.title": "Spraywall",
  "admin.spraywall.statusActive": "Aktív",
  "admin.spraywall.statusInactive": "Nem aktív",
  "admin.spraywall.upsellBody": "Tedd fel a spray fal fotóját: a gép felismeri a fogásokat, a mászók pedig utakat jelölnek és logolnak rajta. Fizetős kiegészítő.",
  "admin.spraywall.deleteViaPlatform": "Kikapcsolt kiegészítővel nem törölhető fal. A meglévő falak és fotók törlését kérd a platformtól.",
  "admin.spraywall.openReports": "Nyitott bejelentések: {count}",
  "admin.spraywall.trainingConsentOn": "Tanítási hozzájárulás: engedélyezve {since} óta ({contractRef})",
  "admin.spraywall.trainingConsentOff": "Tanítási hozzájárulás: nincs",
  "addons.noAddons": "Jelenleg nincs elérhető kiegészítő.",

  // Szervezői és terem-napló AI-jelölés, docs/spec/06-competitions-judging.md + 14b-admin-sections.md
  "opsLog.viaMcp": "AI-n át ({client})",
  "opsLog.viaMcpNoClient": "AI-n át",

  // Korai jelentkezési kedvezmény — verseny és esemény ugyanazt a mondatot mondja,
  // docs/plans/early-bird-pricing.md + docs/spec/07c-competitions-editor.md
  "earlyBird.title": "Korai jelentkezési kedvezmény",
  "earlyBird.toggle": "Korai jelentkezési kedvezmény",
  "earlyBird.toggleHint": "Aki legalább ennyi nappal a kezdés előtt jelentkezik, kevesebbet fizet.",
  "earlyBird.daysBefore": "nappal a kezdés előtt",
  "earlyBird.daysBeforeAria": "Napok a kezdés előtt, {n}. sáv",
  "earlyBird.discountPct": "% kedvezmény",
  "earlyBird.discountPctAria": "Kedvezmény százalékban, {n}. sáv",
  "earlyBird.addTier": "+ Sáv",
  "earlyBird.removeTier": "{n}. sáv törlése",
  "earlyBird.chipsLabel": "Új sáv gyorsan",
  "earlyBird.chip.week1": "1 hét",
  "earlyBird.chip.week2": "2 hét",
  "earlyBird.chip.month1": "1 hónap (30 nap)",
  "earlyBird.until": "{date}-ig",
  "earlyBird.thenFull": "utána {amount}",
  "earlyBird.discountUntil": "−{pct}% · {date}-ig",
  "earlyBird.fullPriceStruck": "Teljes ár: {amount}",
  "earlyBird.ladderLabel": "Árlépcső",
  "earlyBird.cardEarly": "korai ár {date}-ig",
  "earlyBird.badge": "Korai −{pct}%",
  "earlyBird.badgeManual": "Korai −{pct}% (kézi)",
  "earlyBird.badgeFullManual": "Teljes ár (kézi)",
  "earlyBird.freeSettled": "Díjmentes ✓",
  "earlyBird.override.menu": "Díjkategória…",
  "earlyBird.override.title": "Díjkategória",
  "earlyBird.override.auto": "Automatikus",
  "earlyBird.override.full": "Teljes ár",
  "earlyBird.override.tier": "−{pct}% ({days} nap)",
  "earlyBird.override.tierOne": "−{pct}% (1 nap)",
  "earlyBird.override.hint": "Az automatikus érték a nevezés eredeti időpontja szerint számol. A kézi választás addig marad, amíg vissza nem állítod.",
  "earlyBird.override.save": "Mentés",
  "earlyBird.override.error": "Nem sikerült menteni a díjkategóriát.",
  "earlyBird.warn.beforeRegOpen": "Ez a sáv sosem fog élni: a határa a jelentkezés megnyitása előtt van.",
  "earlyBird.warn.noStartDate": "A dátumok a kezdőnap megadása után látszanak. Kezdőnap nélkül a sávok nem élnek.",
  "earlyBird.warn.existingEntries": "A már jelentkezettek megtartják a korábbi áraikat.",
  "earlyBird.warn.invalidRows": "Hibás vagy ismétlődő sor: mentéskor kimarad. A napok 1 és 365, a kedvezmény 1 és 100 között lehet, és egy nap csak egyszer szerepelhet.",
  "earlyBird.summaryDiscount": "Kedvezmény összesen",
  "earlyBird.excelColumn": "Kedvezmény",
  "earlyBird.opsLogFull": "teljes ár",
  "earlyBird.opsLogManual": "{value} (kézi)",
  "opsLog.field.earlyBird": "Korai kedvezmény",
};

export default hu;
